import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

 const AddEquipmentCharge_MutationDocument = gql`
    mutation addEquipmentCharge_mutation($filter: ApiFilterOneCarrierInput!, $rate: RateEquipmentChargeInput!) {
  addEquipmentCharge(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type AddEquipmentCharge_MutationMutationFn = Apollo.MutationFunction<Types.AddEquipmentCharge_Mutation, Types.AddEquipmentCharge_MutationVariables>;

/**
 * __useAddEquipmentCharge_Mutation__
 *
 * To run a mutation, you first call `useAddEquipmentCharge_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEquipmentCharge_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEquipmentChargeMutation, { data, loading, error }] = useAddEquipmentCharge_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useAddEquipmentCharge_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AddEquipmentCharge_Mutation, Types.AddEquipmentCharge_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddEquipmentCharge_Mutation, Types.AddEquipmentCharge_MutationVariables>(AddEquipmentCharge_MutationDocument, options);
      }
export type AddEquipmentCharge_MutationHookResult = ReturnType<typeof useAddEquipmentCharge_Mutation>;
export type AddEquipmentCharge_MutationMutationResult = Apollo.MutationResult<Types.AddEquipmentCharge_Mutation>;
export type AddEquipmentCharge_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AddEquipmentCharge_Mutation, Types.AddEquipmentCharge_MutationVariables>;
 const AddRateLaneBased_MutationDocument = gql`
    mutation addRateLaneBased_mutation($filter: ApiFilterOneCarrierInput!, $rate: ApiRateLaneBasedInput!) {
  addRateLaneBased(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type AddRateLaneBased_MutationMutationFn = Apollo.MutationFunction<Types.AddRateLaneBased_Mutation, Types.AddRateLaneBased_MutationVariables>;

/**
 * __useAddRateLaneBased_Mutation__
 *
 * To run a mutation, you first call `useAddRateLaneBased_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRateLaneBased_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRateLaneBasedMutation, { data, loading, error }] = useAddRateLaneBased_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useAddRateLaneBased_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRateLaneBased_Mutation, Types.AddRateLaneBased_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRateLaneBased_Mutation, Types.AddRateLaneBased_MutationVariables>(AddRateLaneBased_MutationDocument, options);
      }
export type AddRateLaneBased_MutationHookResult = ReturnType<typeof useAddRateLaneBased_Mutation>;
export type AddRateLaneBased_MutationMutationResult = Apollo.MutationResult<Types.AddRateLaneBased_Mutation>;
export type AddRateLaneBased_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AddRateLaneBased_Mutation, Types.AddRateLaneBased_MutationVariables>;
 const CreateCarrier_MutationDocument = gql`
    mutation createCarrier_mutation($carrierInput: ApiCreateCarrierInput!) {
  createCarrier(carrierInput: $carrierInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type CreateCarrier_MutationMutationFn = Apollo.MutationFunction<Types.CreateCarrier_Mutation, Types.CreateCarrier_MutationVariables>;

/**
 * __useCreateCarrier_Mutation__
 *
 * To run a mutation, you first call `useCreateCarrier_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrier_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierMutation, { data, loading, error }] = useCreateCarrier_Mutation({
 *   variables: {
 *      carrierInput: // value for 'carrierInput'
 *   },
 * });
 */
export function useCreateCarrier_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCarrier_Mutation, Types.CreateCarrier_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCarrier_Mutation, Types.CreateCarrier_MutationVariables>(CreateCarrier_MutationDocument, options);
      }
export type CreateCarrier_MutationHookResult = ReturnType<typeof useCreateCarrier_Mutation>;
export type CreateCarrier_MutationMutationResult = Apollo.MutationResult<Types.CreateCarrier_Mutation>;
export type CreateCarrier_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateCarrier_Mutation, Types.CreateCarrier_MutationVariables>;
 const CreateDispatcher_MutationDocument = gql`
    mutation createDispatcher_mutation($filter: ApiFilterOneCarrierInput!, $dispatcherInput: ApiDispatcherInput!) {
  createDispatcher(filter: $filter, dispatcherInput: $dispatcherInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type CreateDispatcher_MutationMutationFn = Apollo.MutationFunction<Types.CreateDispatcher_Mutation, Types.CreateDispatcher_MutationVariables>;

/**
 * __useCreateDispatcher_Mutation__
 *
 * To run a mutation, you first call `useCreateDispatcher_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispatcher_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispatcherMutation, { data, loading, error }] = useCreateDispatcher_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      dispatcherInput: // value for 'dispatcherInput'
 *   },
 * });
 */
export function useCreateDispatcher_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDispatcher_Mutation, Types.CreateDispatcher_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDispatcher_Mutation, Types.CreateDispatcher_MutationVariables>(CreateDispatcher_MutationDocument, options);
      }
export type CreateDispatcher_MutationHookResult = ReturnType<typeof useCreateDispatcher_Mutation>;
export type CreateDispatcher_MutationMutationResult = Apollo.MutationResult<Types.CreateDispatcher_Mutation>;
export type CreateDispatcher_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateDispatcher_Mutation, Types.CreateDispatcher_MutationVariables>;
 const CreateFleet_MutationDocument = gql`
    mutation createFleet_mutation($fleetInput: CreateFleetInput!) {
  createFleet(fleetInput: $fleetInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    bodyType
    fleetDimensions {
      totalLoadingWeight
      totalLoadingHeight
      totalLoadingWidth
      totalLoadingLength
      fleetCapabilities
    }
    carriers {
      id
      name
    }
    possibleLocationIds
    possibleCountries
    externalReference
  }
}
    `;
export type CreateFleet_MutationMutationFn = Apollo.MutationFunction<Types.CreateFleet_Mutation, Types.CreateFleet_MutationVariables>;

/**
 * __useCreateFleet_Mutation__
 *
 * To run a mutation, you first call `useCreateFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFleetMutation, { data, loading, error }] = useCreateFleet_Mutation({
 *   variables: {
 *      fleetInput: // value for 'fleetInput'
 *   },
 * });
 */
export function useCreateFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFleet_Mutation, Types.CreateFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFleet_Mutation, Types.CreateFleet_MutationVariables>(CreateFleet_MutationDocument, options);
      }
export type CreateFleet_MutationHookResult = ReturnType<typeof useCreateFleet_Mutation>;
export type CreateFleet_MutationMutationResult = Apollo.MutationResult<Types.CreateFleet_Mutation>;
export type CreateFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateFleet_Mutation, Types.CreateFleet_MutationVariables>;
 const CreateVehicle_MutationDocument = gql`
    mutation createVehicle_mutation($vehicleInput: CreateVehicleInput!) {
  createVehicle(vehicleInput: $vehicleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
export type CreateVehicle_MutationMutationFn = Apollo.MutationFunction<Types.CreateVehicle_Mutation, Types.CreateVehicle_MutationVariables>;

/**
 * __useCreateVehicle_Mutation__
 *
 * To run a mutation, you first call `useCreateVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleMutation, { data, loading, error }] = useCreateVehicle_Mutation({
 *   variables: {
 *      vehicleInput: // value for 'vehicleInput'
 *   },
 * });
 */
export function useCreateVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVehicle_Mutation, Types.CreateVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVehicle_Mutation, Types.CreateVehicle_MutationVariables>(CreateVehicle_MutationDocument, options);
      }
export type CreateVehicle_MutationHookResult = ReturnType<typeof useCreateVehicle_Mutation>;
export type CreateVehicle_MutationMutationResult = Apollo.MutationResult<Types.CreateVehicle_Mutation>;
export type CreateVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateVehicle_Mutation, Types.CreateVehicle_MutationVariables>;
 const CreateVehicles_MutationDocument = gql`
    mutation createVehicles_mutation($vehiclesInput: [CreateVehicleInput!]!) {
  createVehicles(vehiclesInput: $vehiclesInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type CreateVehicles_MutationMutationFn = Apollo.MutationFunction<Types.CreateVehicles_Mutation, Types.CreateVehicles_MutationVariables>;

/**
 * __useCreateVehicles_Mutation__
 *
 * To run a mutation, you first call `useCreateVehicles_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicles_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehiclesMutation, { data, loading, error }] = useCreateVehicles_Mutation({
 *   variables: {
 *      vehiclesInput: // value for 'vehiclesInput'
 *   },
 * });
 */
export function useCreateVehicles_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVehicles_Mutation, Types.CreateVehicles_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVehicles_Mutation, Types.CreateVehicles_MutationVariables>(CreateVehicles_MutationDocument, options);
      }
export type CreateVehicles_MutationHookResult = ReturnType<typeof useCreateVehicles_Mutation>;
export type CreateVehicles_MutationMutationResult = Apollo.MutationResult<Types.CreateVehicles_Mutation>;
export type CreateVehicles_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateVehicles_Mutation, Types.CreateVehicles_MutationVariables>;
 const DeleteCarrier_MutationDocument = gql`
    mutation deleteCarrier_mutation($filter: ApiFilterOneCarrierInput!) {
  deleteCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type DeleteCarrier_MutationMutationFn = Apollo.MutationFunction<Types.DeleteCarrier_Mutation, Types.DeleteCarrier_MutationVariables>;

/**
 * __useDeleteCarrier_Mutation__
 *
 * To run a mutation, you first call `useDeleteCarrier_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrier_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierMutation, { data, loading, error }] = useDeleteCarrier_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteCarrier_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCarrier_Mutation, Types.DeleteCarrier_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCarrier_Mutation, Types.DeleteCarrier_MutationVariables>(DeleteCarrier_MutationDocument, options);
      }
export type DeleteCarrier_MutationHookResult = ReturnType<typeof useDeleteCarrier_Mutation>;
export type DeleteCarrier_MutationMutationResult = Apollo.MutationResult<Types.DeleteCarrier_Mutation>;
export type DeleteCarrier_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCarrier_Mutation, Types.DeleteCarrier_MutationVariables>;
 const DeleteDispatchers_MutationDocument = gql`
    mutation deleteDispatchers_mutation($filter: FilterDeleteCarrierDispatcherInput!) {
  deleteDispatchers(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type DeleteDispatchers_MutationMutationFn = Apollo.MutationFunction<Types.DeleteDispatchers_Mutation, Types.DeleteDispatchers_MutationVariables>;

/**
 * __useDeleteDispatchers_Mutation__
 *
 * To run a mutation, you first call `useDeleteDispatchers_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDispatchers_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDispatchersMutation, { data, loading, error }] = useDeleteDispatchers_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteDispatchers_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDispatchers_Mutation, Types.DeleteDispatchers_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDispatchers_Mutation, Types.DeleteDispatchers_MutationVariables>(DeleteDispatchers_MutationDocument, options);
      }
export type DeleteDispatchers_MutationHookResult = ReturnType<typeof useDeleteDispatchers_Mutation>;
export type DeleteDispatchers_MutationMutationResult = Apollo.MutationResult<Types.DeleteDispatchers_Mutation>;
export type DeleteDispatchers_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDispatchers_Mutation, Types.DeleteDispatchers_MutationVariables>;
 const DeleteEquipmentCharges_MutationDocument = gql`
    mutation deleteEquipmentCharges_mutation($filter: ApiFilterOneCarrierInput!, $rates: [RateEquipmentChargeInput!]!) {
  deleteEquipmentCharges(filter: $filter, rates: $rates) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type DeleteEquipmentCharges_MutationMutationFn = Apollo.MutationFunction<Types.DeleteEquipmentCharges_Mutation, Types.DeleteEquipmentCharges_MutationVariables>;

/**
 * __useDeleteEquipmentCharges_Mutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentCharges_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentCharges_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentChargesMutation, { data, loading, error }] = useDeleteEquipmentCharges_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useDeleteEquipmentCharges_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteEquipmentCharges_Mutation, Types.DeleteEquipmentCharges_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteEquipmentCharges_Mutation, Types.DeleteEquipmentCharges_MutationVariables>(DeleteEquipmentCharges_MutationDocument, options);
      }
export type DeleteEquipmentCharges_MutationHookResult = ReturnType<typeof useDeleteEquipmentCharges_Mutation>;
export type DeleteEquipmentCharges_MutationMutationResult = Apollo.MutationResult<Types.DeleteEquipmentCharges_Mutation>;
export type DeleteEquipmentCharges_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteEquipmentCharges_Mutation, Types.DeleteEquipmentCharges_MutationVariables>;
 const DeleteFleet_MutationDocument = gql`
    mutation deleteFleet_mutation($filter: FilterFleetInput!) {
  deleteFleet(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    bodyType
    fleetDimensions {
      totalLoadingWeight
      totalLoadingHeight
      totalLoadingWidth
      totalLoadingLength
      fleetCapabilities
    }
    carriers {
      id
      name
    }
    possibleLocationIds
    possibleCountries
    externalReference
  }
}
    `;
export type DeleteFleet_MutationMutationFn = Apollo.MutationFunction<Types.DeleteFleet_Mutation, Types.DeleteFleet_MutationVariables>;

/**
 * __useDeleteFleet_Mutation__
 *
 * To run a mutation, you first call `useDeleteFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFleetMutation, { data, loading, error }] = useDeleteFleet_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFleet_Mutation, Types.DeleteFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFleet_Mutation, Types.DeleteFleet_MutationVariables>(DeleteFleet_MutationDocument, options);
      }
export type DeleteFleet_MutationHookResult = ReturnType<typeof useDeleteFleet_Mutation>;
export type DeleteFleet_MutationMutationResult = Apollo.MutationResult<Types.DeleteFleet_Mutation>;
export type DeleteFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFleet_Mutation, Types.DeleteFleet_MutationVariables>;
 const DeleteFleets_MutationDocument = gql`
    mutation deleteFleets_mutation($filter: FilterFleetsInput!) {
  deleteFleets(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type DeleteFleets_MutationMutationFn = Apollo.MutationFunction<Types.DeleteFleets_Mutation, Types.DeleteFleets_MutationVariables>;

/**
 * __useDeleteFleets_Mutation__
 *
 * To run a mutation, you first call `useDeleteFleets_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFleets_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFleetsMutation, { data, loading, error }] = useDeleteFleets_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteFleets_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFleets_Mutation, Types.DeleteFleets_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFleets_Mutation, Types.DeleteFleets_MutationVariables>(DeleteFleets_MutationDocument, options);
      }
export type DeleteFleets_MutationHookResult = ReturnType<typeof useDeleteFleets_Mutation>;
export type DeleteFleets_MutationMutationResult = Apollo.MutationResult<Types.DeleteFleets_Mutation>;
export type DeleteFleets_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFleets_Mutation, Types.DeleteFleets_MutationVariables>;
 const DeleteVehicle_MutationDocument = gql`
    mutation deleteVehicle_mutation($filter: FilterVehicleInput!) {
  deleteVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
export type DeleteVehicle_MutationMutationFn = Apollo.MutationFunction<Types.DeleteVehicle_Mutation, Types.DeleteVehicle_MutationVariables>;

/**
 * __useDeleteVehicle_Mutation__
 *
 * To run a mutation, you first call `useDeleteVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleMutation, { data, loading, error }] = useDeleteVehicle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVehicle_Mutation, Types.DeleteVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVehicle_Mutation, Types.DeleteVehicle_MutationVariables>(DeleteVehicle_MutationDocument, options);
      }
export type DeleteVehicle_MutationHookResult = ReturnType<typeof useDeleteVehicle_Mutation>;
export type DeleteVehicle_MutationMutationResult = Apollo.MutationResult<Types.DeleteVehicle_Mutation>;
export type DeleteVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVehicle_Mutation, Types.DeleteVehicle_MutationVariables>;
 const DeleteVehicles_MutationDocument = gql`
    mutation deleteVehicles_mutation($filter: FilterVehiclesInput!) {
  deleteVehicles(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type DeleteVehicles_MutationMutationFn = Apollo.MutationFunction<Types.DeleteVehicles_Mutation, Types.DeleteVehicles_MutationVariables>;

/**
 * __useDeleteVehicles_Mutation__
 *
 * To run a mutation, you first call `useDeleteVehicles_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicles_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehiclesMutation, { data, loading, error }] = useDeleteVehicles_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteVehicles_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVehicles_Mutation, Types.DeleteVehicles_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVehicles_Mutation, Types.DeleteVehicles_MutationVariables>(DeleteVehicles_MutationDocument, options);
      }
export type DeleteVehicles_MutationHookResult = ReturnType<typeof useDeleteVehicles_Mutation>;
export type DeleteVehicles_MutationMutationResult = Apollo.MutationResult<Types.DeleteVehicles_Mutation>;
export type DeleteVehicles_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVehicles_Mutation, Types.DeleteVehicles_MutationVariables>;
 const DisableCarrier_MutationDocument = gql`
    mutation disableCarrier_mutation($filter: ApiFilterOneCarrierInput!) {
  disableCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type DisableCarrier_MutationMutationFn = Apollo.MutationFunction<Types.DisableCarrier_Mutation, Types.DisableCarrier_MutationVariables>;

/**
 * __useDisableCarrier_Mutation__
 *
 * To run a mutation, you first call `useDisableCarrier_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableCarrier_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableCarrierMutation, { data, loading, error }] = useDisableCarrier_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDisableCarrier_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DisableCarrier_Mutation, Types.DisableCarrier_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisableCarrier_Mutation, Types.DisableCarrier_MutationVariables>(DisableCarrier_MutationDocument, options);
      }
export type DisableCarrier_MutationHookResult = ReturnType<typeof useDisableCarrier_Mutation>;
export type DisableCarrier_MutationMutationResult = Apollo.MutationResult<Types.DisableCarrier_Mutation>;
export type DisableCarrier_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DisableCarrier_Mutation, Types.DisableCarrier_MutationVariables>;
 const EnableCarrier_MutationDocument = gql`
    mutation enableCarrier_mutation($filter: ApiFilterOneCarrierInput!) {
  enableCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type EnableCarrier_MutationMutationFn = Apollo.MutationFunction<Types.EnableCarrier_Mutation, Types.EnableCarrier_MutationVariables>;

/**
 * __useEnableCarrier_Mutation__
 *
 * To run a mutation, you first call `useEnableCarrier_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCarrier_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCarrierMutation, { data, loading, error }] = useEnableCarrier_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEnableCarrier_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.EnableCarrier_Mutation, Types.EnableCarrier_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EnableCarrier_Mutation, Types.EnableCarrier_MutationVariables>(EnableCarrier_MutationDocument, options);
      }
export type EnableCarrier_MutationHookResult = ReturnType<typeof useEnableCarrier_Mutation>;
export type EnableCarrier_MutationMutationResult = Apollo.MutationResult<Types.EnableCarrier_Mutation>;
export type EnableCarrier_MutationMutationOptions = Apollo.BaseMutationOptions<Types.EnableCarrier_Mutation, Types.EnableCarrier_MutationVariables>;
 const FindCarrier_QueryDocument = gql`
    query findCarrier_query($filter: ApiFilterOneCarrierInput!) {
  findCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;

/**
 * __useFindCarrier_Query__
 *
 * To run a query within a React component, call `useFindCarrier_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindCarrier_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCarrier_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindCarrier_Query(baseOptions: Apollo.QueryHookOptions<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables> & ({ variables: Types.FindCarrier_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables>(FindCarrier_QueryDocument, options);
      }
export function useFindCarrier_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables>(FindCarrier_QueryDocument, options);
        }
export function useFindCarrier_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables>(FindCarrier_QueryDocument, options);
        }
export type FindCarrier_QueryHookResult = ReturnType<typeof useFindCarrier_Query>;
export type FindCarrier_QueryLazyQueryHookResult = ReturnType<typeof useFindCarrier_QueryLazyQuery>;
export type FindCarrier_QuerySuspenseQueryHookResult = ReturnType<typeof useFindCarrier_QuerySuspenseQuery>;
export type FindCarrier_QueryQueryResult = Apollo.QueryResult<Types.FindCarrier_Query, Types.FindCarrier_QueryVariables>;
 const FindCarriers_QueryDocument = gql`
    query findCarriers_query($query: QueryCarriersInput!) {
  findCarriers(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      company {
        name
        contact {
          name
          mobile
          phone
          email
        }
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
      }
      dispatchers {
        id
        contact {
          name
          mobile
          phone
          email
        }
      }
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      preferredLanguage
      disabled
    }
  }
}
    `;

/**
 * __useFindCarriers_Query__
 *
 * To run a query within a React component, call `useFindCarriers_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindCarriers_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCarriers_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindCarriers_Query(baseOptions: Apollo.QueryHookOptions<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables> & ({ variables: Types.FindCarriers_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables>(FindCarriers_QueryDocument, options);
      }
export function useFindCarriers_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables>(FindCarriers_QueryDocument, options);
        }
export function useFindCarriers_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables>(FindCarriers_QueryDocument, options);
        }
export type FindCarriers_QueryHookResult = ReturnType<typeof useFindCarriers_Query>;
export type FindCarriers_QueryLazyQueryHookResult = ReturnType<typeof useFindCarriers_QueryLazyQuery>;
export type FindCarriers_QuerySuspenseQueryHookResult = ReturnType<typeof useFindCarriers_QuerySuspenseQuery>;
export type FindCarriers_QueryQueryResult = Apollo.QueryResult<Types.FindCarriers_Query, Types.FindCarriers_QueryVariables>;
 const FindFleets_QueryDocument = gql`
    query findFleets_query($query: QueryFleetInput!) {
  findFleets(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      name
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      externalReference
    }
  }
}
    `;

/**
 * __useFindFleets_Query__
 *
 * To run a query within a React component, call `useFindFleets_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindFleets_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFleets_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindFleets_Query(baseOptions: Apollo.QueryHookOptions<Types.FindFleets_Query, Types.FindFleets_QueryVariables> & ({ variables: Types.FindFleets_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindFleets_Query, Types.FindFleets_QueryVariables>(FindFleets_QueryDocument, options);
      }
export function useFindFleets_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindFleets_Query, Types.FindFleets_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindFleets_Query, Types.FindFleets_QueryVariables>(FindFleets_QueryDocument, options);
        }
export function useFindFleets_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindFleets_Query, Types.FindFleets_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindFleets_Query, Types.FindFleets_QueryVariables>(FindFleets_QueryDocument, options);
        }
export type FindFleets_QueryHookResult = ReturnType<typeof useFindFleets_Query>;
export type FindFleets_QueryLazyQueryHookResult = ReturnType<typeof useFindFleets_QueryLazyQuery>;
export type FindFleets_QuerySuspenseQueryHookResult = ReturnType<typeof useFindFleets_QuerySuspenseQuery>;
export type FindFleets_QueryQueryResult = Apollo.QueryResult<Types.FindFleets_Query, Types.FindFleets_QueryVariables>;
 const FindVehicle_QueryDocument = gql`
    query findVehicle_query($filter: FilterVehicleInput!) {
  findVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;

/**
 * __useFindVehicle_Query__
 *
 * To run a query within a React component, call `useFindVehicle_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindVehicle_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVehicle_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindVehicle_Query(baseOptions: Apollo.QueryHookOptions<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables> & ({ variables: Types.FindVehicle_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables>(FindVehicle_QueryDocument, options);
      }
export function useFindVehicle_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables>(FindVehicle_QueryDocument, options);
        }
export function useFindVehicle_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables>(FindVehicle_QueryDocument, options);
        }
export type FindVehicle_QueryHookResult = ReturnType<typeof useFindVehicle_Query>;
export type FindVehicle_QueryLazyQueryHookResult = ReturnType<typeof useFindVehicle_QueryLazyQuery>;
export type FindVehicle_QuerySuspenseQueryHookResult = ReturnType<typeof useFindVehicle_QuerySuspenseQuery>;
export type FindVehicle_QueryQueryResult = Apollo.QueryResult<Types.FindVehicle_Query, Types.FindVehicle_QueryVariables>;
 const FindVehicles_QueryDocument = gql`
    query findVehicles_query($query: QueryVehiclesInput!) {
  findVehicles(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      ldmm
      vehicleType
      maxLoadingWeight
      vehicleCapabilities
      costCalculationId
    }
  }
}
    `;

/**
 * __useFindVehicles_Query__
 *
 * To run a query within a React component, call `useFindVehicles_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindVehicles_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVehicles_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindVehicles_Query(baseOptions: Apollo.QueryHookOptions<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables> & ({ variables: Types.FindVehicles_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables>(FindVehicles_QueryDocument, options);
      }
export function useFindVehicles_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables>(FindVehicles_QueryDocument, options);
        }
export function useFindVehicles_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables>(FindVehicles_QueryDocument, options);
        }
export type FindVehicles_QueryHookResult = ReturnType<typeof useFindVehicles_Query>;
export type FindVehicles_QueryLazyQueryHookResult = ReturnType<typeof useFindVehicles_QueryLazyQuery>;
export type FindVehicles_QuerySuspenseQueryHookResult = ReturnType<typeof useFindVehicles_QuerySuspenseQuery>;
export type FindVehicles_QueryQueryResult = Apollo.QueryResult<Types.FindVehicles_Query, Types.FindVehicles_QueryVariables>;
 const FindVehiclesByExternalReferences_QueryDocument = gql`
    query findVehiclesByExternalReferences_query($externalReferences: [String!]!) {
  findVehiclesByExternalReferences(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      ldmm
      vehicleType
      maxLoadingWeight
      vehicleCapabilities
      costCalculationId
    }
  }
}
    `;

/**
 * __useFindVehiclesByExternalReferences_Query__
 *
 * To run a query within a React component, call `useFindVehiclesByExternalReferences_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindVehiclesByExternalReferences_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVehiclesByExternalReferences_Query({
 *   variables: {
 *      externalReferences: // value for 'externalReferences'
 *   },
 * });
 */
export function useFindVehiclesByExternalReferences_Query(baseOptions: Apollo.QueryHookOptions<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables> & ({ variables: Types.FindVehiclesByExternalReferences_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables>(FindVehiclesByExternalReferences_QueryDocument, options);
      }
export function useFindVehiclesByExternalReferences_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables>(FindVehiclesByExternalReferences_QueryDocument, options);
        }
export function useFindVehiclesByExternalReferences_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables>(FindVehiclesByExternalReferences_QueryDocument, options);
        }
export type FindVehiclesByExternalReferences_QueryHookResult = ReturnType<typeof useFindVehiclesByExternalReferences_Query>;
export type FindVehiclesByExternalReferences_QueryLazyQueryHookResult = ReturnType<typeof useFindVehiclesByExternalReferences_QueryLazyQuery>;
export type FindVehiclesByExternalReferences_QuerySuspenseQueryHookResult = ReturnType<typeof useFindVehiclesByExternalReferences_QuerySuspenseQuery>;
export type FindVehiclesByExternalReferences_QueryQueryResult = Apollo.QueryResult<Types.FindVehiclesByExternalReferences_Query, Types.FindVehiclesByExternalReferences_QueryVariables>;
 const ImportCarriers_MutationDocument = gql`
    mutation importCarriers_mutation($carriersImport: [CarrierImportWithIndexInput!]!) {
  importCarriers(carriersImport: $carriersImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportCarriers_MutationMutationFn = Apollo.MutationFunction<Types.ImportCarriers_Mutation, Types.ImportCarriers_MutationVariables>;

/**
 * __useImportCarriers_Mutation__
 *
 * To run a mutation, you first call `useImportCarriers_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCarriers_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCarriersMutation, { data, loading, error }] = useImportCarriers_Mutation({
 *   variables: {
 *      carriersImport: // value for 'carriersImport'
 *   },
 * });
 */
export function useImportCarriers_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportCarriers_Mutation, Types.ImportCarriers_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportCarriers_Mutation, Types.ImportCarriers_MutationVariables>(ImportCarriers_MutationDocument, options);
      }
export type ImportCarriers_MutationHookResult = ReturnType<typeof useImportCarriers_Mutation>;
export type ImportCarriers_MutationMutationResult = Apollo.MutationResult<Types.ImportCarriers_Mutation>;
export type ImportCarriers_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportCarriers_Mutation, Types.ImportCarriers_MutationVariables>;
 const ImportRateLaneBased_MutationDocument = gql`
    mutation importRateLaneBased_mutation($filter: ApiFilterOneCarrierInput!, $rates: [ApiRateLaneBasedInput!]!) {
  importRateLaneBased(filter: $filter, rates: $rates) {
    successfulCount
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportRateLaneBased_MutationMutationFn = Apollo.MutationFunction<Types.ImportRateLaneBased_Mutation, Types.ImportRateLaneBased_MutationVariables>;

/**
 * __useImportRateLaneBased_Mutation__
 *
 * To run a mutation, you first call `useImportRateLaneBased_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRateLaneBased_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRateLaneBasedMutation, { data, loading, error }] = useImportRateLaneBased_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useImportRateLaneBased_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportRateLaneBased_Mutation, Types.ImportRateLaneBased_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportRateLaneBased_Mutation, Types.ImportRateLaneBased_MutationVariables>(ImportRateLaneBased_MutationDocument, options);
      }
export type ImportRateLaneBased_MutationHookResult = ReturnType<typeof useImportRateLaneBased_Mutation>;
export type ImportRateLaneBased_MutationMutationResult = Apollo.MutationResult<Types.ImportRateLaneBased_Mutation>;
export type ImportRateLaneBased_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportRateLaneBased_Mutation, Types.ImportRateLaneBased_MutationVariables>;
 const RatesLookup_QueryDocument = gql`
    query ratesLookup_query($filter: ApiFilterOneCarrierInput!) {
  ratesLookup(filter: $filter) {
    perKm {
      minDistance
      costPerKm
    }
    unloadingCharges {
      costPerAdditionalStop
      isAppliedAtDepot
    }
    laneBased {
      id
      pickUp {
        country
        zipCode
      }
      dropOff {
        country
        zipCode
      }
      cost
      costWeight {
        valueFromLimit
        valueToLimit
        costMin
        costMax
        cost
      }
    }
    equipmentCharges {
      equipment
      rateType
      costPerEquipment
    }
    calculatedTotalCost
    agreedTotalCost
  }
}
    `;

/**
 * __useRatesLookup_Query__
 *
 * To run a query within a React component, call `useRatesLookup_Query` and pass it any options that fit your needs.
 * When your component renders, `useRatesLookup_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesLookup_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRatesLookup_Query(baseOptions: Apollo.QueryHookOptions<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables> & ({ variables: Types.RatesLookup_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables>(RatesLookup_QueryDocument, options);
      }
export function useRatesLookup_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables>(RatesLookup_QueryDocument, options);
        }
export function useRatesLookup_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables>(RatesLookup_QueryDocument, options);
        }
export type RatesLookup_QueryHookResult = ReturnType<typeof useRatesLookup_Query>;
export type RatesLookup_QueryLazyQueryHookResult = ReturnType<typeof useRatesLookup_QueryLazyQuery>;
export type RatesLookup_QuerySuspenseQueryHookResult = ReturnType<typeof useRatesLookup_QuerySuspenseQuery>;
export type RatesLookup_QueryQueryResult = Apollo.QueryResult<Types.RatesLookup_Query, Types.RatesLookup_QueryVariables>;
 const RemoveRateLaneBased_MutationDocument = gql`
    mutation removeRateLaneBased_mutation($filter: ApiFilterOneCarrierRateInput!) {
  removeRateLaneBased(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type RemoveRateLaneBased_MutationMutationFn = Apollo.MutationFunction<Types.RemoveRateLaneBased_Mutation, Types.RemoveRateLaneBased_MutationVariables>;

/**
 * __useRemoveRateLaneBased_Mutation__
 *
 * To run a mutation, you first call `useRemoveRateLaneBased_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRateLaneBased_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRateLaneBasedMutation, { data, loading, error }] = useRemoveRateLaneBased_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRemoveRateLaneBased_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveRateLaneBased_Mutation, Types.RemoveRateLaneBased_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveRateLaneBased_Mutation, Types.RemoveRateLaneBased_MutationVariables>(RemoveRateLaneBased_MutationDocument, options);
      }
export type RemoveRateLaneBased_MutationHookResult = ReturnType<typeof useRemoveRateLaneBased_Mutation>;
export type RemoveRateLaneBased_MutationMutationResult = Apollo.MutationResult<Types.RemoveRateLaneBased_Mutation>;
export type RemoveRateLaneBased_MutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveRateLaneBased_Mutation, Types.RemoveRateLaneBased_MutationVariables>;
 const SeedVehiclesE2E_MutationDocument = gql`
    mutation seedVehiclesE2E_mutation {
  seedVehiclesE2E {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type SeedVehiclesE2E_MutationMutationFn = Apollo.MutationFunction<Types.SeedVehiclesE2E_Mutation, Types.SeedVehiclesE2E_MutationVariables>;

/**
 * __useSeedVehiclesE2E_Mutation__
 *
 * To run a mutation, you first call `useSeedVehiclesE2E_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedVehiclesE2E_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedVehiclesE2EMutation, { data, loading, error }] = useSeedVehiclesE2E_Mutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedVehiclesE2E_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SeedVehiclesE2E_Mutation, Types.SeedVehiclesE2E_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeedVehiclesE2E_Mutation, Types.SeedVehiclesE2E_MutationVariables>(SeedVehiclesE2E_MutationDocument, options);
      }
export type SeedVehiclesE2E_MutationHookResult = ReturnType<typeof useSeedVehiclesE2E_Mutation>;
export type SeedVehiclesE2E_MutationMutationResult = Apollo.MutationResult<Types.SeedVehiclesE2E_Mutation>;
export type SeedVehiclesE2E_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SeedVehiclesE2E_Mutation, Types.SeedVehiclesE2E_MutationVariables>;
 const UpdateCarrier_MutationDocument = gql`
    mutation updateCarrier_mutation($filter: ApiFilterOneCarrierInput!, $carrierInput: ApiCreateCarrierInput!) {
  updateCarrier(filter: $filter, carrierInput: $carrierInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type UpdateCarrier_MutationMutationFn = Apollo.MutationFunction<Types.UpdateCarrier_Mutation, Types.UpdateCarrier_MutationVariables>;

/**
 * __useUpdateCarrier_Mutation__
 *
 * To run a mutation, you first call `useUpdateCarrier_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrier_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierMutation, { data, loading, error }] = useUpdateCarrier_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      carrierInput: // value for 'carrierInput'
 *   },
 * });
 */
export function useUpdateCarrier_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCarrier_Mutation, Types.UpdateCarrier_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCarrier_Mutation, Types.UpdateCarrier_MutationVariables>(UpdateCarrier_MutationDocument, options);
      }
export type UpdateCarrier_MutationHookResult = ReturnType<typeof useUpdateCarrier_Mutation>;
export type UpdateCarrier_MutationMutationResult = Apollo.MutationResult<Types.UpdateCarrier_Mutation>;
export type UpdateCarrier_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCarrier_Mutation, Types.UpdateCarrier_MutationVariables>;
 const UpdateDispatcher_MutationDocument = gql`
    mutation updateDispatcher_mutation($filter: ApiFilterOneCarrierInput!, $dispatcherInput: ApiDispatcherInput!) {
  updateDispatcher(filter: $filter, dispatcherInput: $dispatcherInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type UpdateDispatcher_MutationMutationFn = Apollo.MutationFunction<Types.UpdateDispatcher_Mutation, Types.UpdateDispatcher_MutationVariables>;

/**
 * __useUpdateDispatcher_Mutation__
 *
 * To run a mutation, you first call `useUpdateDispatcher_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDispatcher_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDispatcherMutation, { data, loading, error }] = useUpdateDispatcher_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      dispatcherInput: // value for 'dispatcherInput'
 *   },
 * });
 */
export function useUpdateDispatcher_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDispatcher_Mutation, Types.UpdateDispatcher_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDispatcher_Mutation, Types.UpdateDispatcher_MutationVariables>(UpdateDispatcher_MutationDocument, options);
      }
export type UpdateDispatcher_MutationHookResult = ReturnType<typeof useUpdateDispatcher_Mutation>;
export type UpdateDispatcher_MutationMutationResult = Apollo.MutationResult<Types.UpdateDispatcher_Mutation>;
export type UpdateDispatcher_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDispatcher_Mutation, Types.UpdateDispatcher_MutationVariables>;
 const UpdateEquipmentCharge_MutationDocument = gql`
    mutation updateEquipmentCharge_mutation($filter: ApiFilterOneCarrierInput!, $rate: RateEquipmentChargeInput!) {
  updateEquipmentCharge(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type UpdateEquipmentCharge_MutationMutationFn = Apollo.MutationFunction<Types.UpdateEquipmentCharge_Mutation, Types.UpdateEquipmentCharge_MutationVariables>;

/**
 * __useUpdateEquipmentCharge_Mutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentCharge_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentCharge_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentChargeMutation, { data, loading, error }] = useUpdateEquipmentCharge_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useUpdateEquipmentCharge_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEquipmentCharge_Mutation, Types.UpdateEquipmentCharge_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEquipmentCharge_Mutation, Types.UpdateEquipmentCharge_MutationVariables>(UpdateEquipmentCharge_MutationDocument, options);
      }
export type UpdateEquipmentCharge_MutationHookResult = ReturnType<typeof useUpdateEquipmentCharge_Mutation>;
export type UpdateEquipmentCharge_MutationMutationResult = Apollo.MutationResult<Types.UpdateEquipmentCharge_Mutation>;
export type UpdateEquipmentCharge_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEquipmentCharge_Mutation, Types.UpdateEquipmentCharge_MutationVariables>;
 const UpdateFleet_MutationDocument = gql`
    mutation updateFleet_mutation($filter: FilterFleetInput!, $fleetInput: UpdateFleetInput!) {
  updateFleet(filter: $filter, fleetInput: $fleetInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    bodyType
    fleetDimensions {
      totalLoadingWeight
      totalLoadingHeight
      totalLoadingWidth
      totalLoadingLength
      fleetCapabilities
    }
    carriers {
      id
      name
    }
    possibleLocationIds
    possibleCountries
    externalReference
  }
}
    `;
export type UpdateFleet_MutationMutationFn = Apollo.MutationFunction<Types.UpdateFleet_Mutation, Types.UpdateFleet_MutationVariables>;

/**
 * __useUpdateFleet_Mutation__
 *
 * To run a mutation, you first call `useUpdateFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFleetMutation, { data, loading, error }] = useUpdateFleet_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      fleetInput: // value for 'fleetInput'
 *   },
 * });
 */
export function useUpdateFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFleet_Mutation, Types.UpdateFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFleet_Mutation, Types.UpdateFleet_MutationVariables>(UpdateFleet_MutationDocument, options);
      }
export type UpdateFleet_MutationHookResult = ReturnType<typeof useUpdateFleet_Mutation>;
export type UpdateFleet_MutationMutationResult = Apollo.MutationResult<Types.UpdateFleet_Mutation>;
export type UpdateFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFleet_Mutation, Types.UpdateFleet_MutationVariables>;
 const UpdateRateLaneBased_MutationDocument = gql`
    mutation updateRateLaneBased_mutation($filter: ApiFilterOneCarrierRateInput!, $rate: ApiRateLaneBasedInput!) {
  updateRateLaneBased(filter: $filter, rate: $rate) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type UpdateRateLaneBased_MutationMutationFn = Apollo.MutationFunction<Types.UpdateRateLaneBased_Mutation, Types.UpdateRateLaneBased_MutationVariables>;

/**
 * __useUpdateRateLaneBased_Mutation__
 *
 * To run a mutation, you first call `useUpdateRateLaneBased_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRateLaneBased_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRateLaneBasedMutation, { data, loading, error }] = useUpdateRateLaneBased_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useUpdateRateLaneBased_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRateLaneBased_Mutation, Types.UpdateRateLaneBased_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRateLaneBased_Mutation, Types.UpdateRateLaneBased_MutationVariables>(UpdateRateLaneBased_MutationDocument, options);
      }
export type UpdateRateLaneBased_MutationHookResult = ReturnType<typeof useUpdateRateLaneBased_Mutation>;
export type UpdateRateLaneBased_MutationMutationResult = Apollo.MutationResult<Types.UpdateRateLaneBased_Mutation>;
export type UpdateRateLaneBased_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRateLaneBased_Mutation, Types.UpdateRateLaneBased_MutationVariables>;
 const UpdateRatePerKm_MutationDocument = gql`
    mutation updateRatePerKm_mutation($filter: ApiFilterOneCarrierInput!, $rates: [RatePerKmInput!]!) {
  updateRatePerKm(filter: $filter, rates: $rates) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type UpdateRatePerKm_MutationMutationFn = Apollo.MutationFunction<Types.UpdateRatePerKm_Mutation, Types.UpdateRatePerKm_MutationVariables>;

/**
 * __useUpdateRatePerKm_Mutation__
 *
 * To run a mutation, you first call `useUpdateRatePerKm_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRatePerKm_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRatePerKmMutation, { data, loading, error }] = useUpdateRatePerKm_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useUpdateRatePerKm_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRatePerKm_Mutation, Types.UpdateRatePerKm_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRatePerKm_Mutation, Types.UpdateRatePerKm_MutationVariables>(UpdateRatePerKm_MutationDocument, options);
      }
export type UpdateRatePerKm_MutationHookResult = ReturnType<typeof useUpdateRatePerKm_Mutation>;
export type UpdateRatePerKm_MutationMutationResult = Apollo.MutationResult<Types.UpdateRatePerKm_Mutation>;
export type UpdateRatePerKm_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRatePerKm_Mutation, Types.UpdateRatePerKm_MutationVariables>;
 const UpdateUnloadingCharges_MutationDocument = gql`
    mutation updateUnloadingCharges_mutation($filter: ApiFilterOneCarrierInput!, $rates: RateUnloadingChargesInput!) {
  updateUnloadingCharges(filter: $filter, rates: $rates) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    company {
      name
      contact {
        name
        mobile
        phone
        email
      }
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
    }
    dispatchers {
      id
      contact {
        name
        mobile
        phone
        email
      }
    }
    rate {
      perKm {
        minDistance
        costPerKm
      }
      unloadingCharges {
        costPerAdditionalStop
        isAppliedAtDepot
      }
      laneBased {
        id
        pickUp {
          country
          zipCode
        }
        dropOff {
          country
          zipCode
        }
        cost
        costWeight {
          valueFromLimit
          valueToLimit
          costMin
          costMax
          cost
        }
      }
      equipmentCharges {
        equipment
        rateType
        costPerEquipment
      }
      calculatedTotalCost
      agreedTotalCost
    }
    preferredLanguage
    disabled
  }
}
    `;
export type UpdateUnloadingCharges_MutationMutationFn = Apollo.MutationFunction<Types.UpdateUnloadingCharges_Mutation, Types.UpdateUnloadingCharges_MutationVariables>;

/**
 * __useUpdateUnloadingCharges_Mutation__
 *
 * To run a mutation, you first call `useUpdateUnloadingCharges_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnloadingCharges_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnloadingChargesMutation, { data, loading, error }] = useUpdateUnloadingCharges_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useUpdateUnloadingCharges_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUnloadingCharges_Mutation, Types.UpdateUnloadingCharges_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUnloadingCharges_Mutation, Types.UpdateUnloadingCharges_MutationVariables>(UpdateUnloadingCharges_MutationDocument, options);
      }
export type UpdateUnloadingCharges_MutationHookResult = ReturnType<typeof useUpdateUnloadingCharges_Mutation>;
export type UpdateUnloadingCharges_MutationMutationResult = Apollo.MutationResult<Types.UpdateUnloadingCharges_Mutation>;
export type UpdateUnloadingCharges_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUnloadingCharges_Mutation, Types.UpdateUnloadingCharges_MutationVariables>;
 const UpdateVehicle_MutationDocument = gql`
    mutation updateVehicle_mutation($filter: FilterVehicleInput!, $vehicleInput: UpdateVehicleInput!) {
  updateVehicle(filter: $filter, vehicleInput: $vehicleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    ldmm
    vehicleType
    maxLoadingWeight
    vehicleCapabilities
    costCalculationId
  }
}
    `;
export type UpdateVehicle_MutationMutationFn = Apollo.MutationFunction<Types.UpdateVehicle_Mutation, Types.UpdateVehicle_MutationVariables>;

/**
 * __useUpdateVehicle_Mutation__
 *
 * To run a mutation, you first call `useUpdateVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleMutation, { data, loading, error }] = useUpdateVehicle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      vehicleInput: // value for 'vehicleInput'
 *   },
 * });
 */
export function useUpdateVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateVehicle_Mutation, Types.UpdateVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateVehicle_Mutation, Types.UpdateVehicle_MutationVariables>(UpdateVehicle_MutationDocument, options);
      }
export type UpdateVehicle_MutationHookResult = ReturnType<typeof useUpdateVehicle_Mutation>;
export type UpdateVehicle_MutationMutationResult = Apollo.MutationResult<Types.UpdateVehicle_Mutation>;
export type UpdateVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateVehicle_Mutation, Types.UpdateVehicle_MutationVariables>;
 const CreateArticle_MutationDocument = gql`
    mutation createArticle_mutation($articleInput: CreateArticleInput!) {
  createArticle(articleInput: $articleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
export type CreateArticle_MutationMutationFn = Apollo.MutationFunction<Types.CreateArticle_Mutation, Types.CreateArticle_MutationVariables>;

/**
 * __useCreateArticle_Mutation__
 *
 * To run a mutation, you first call `useCreateArticle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticle_Mutation({
 *   variables: {
 *      articleInput: // value for 'articleInput'
 *   },
 * });
 */
export function useCreateArticle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateArticle_Mutation, Types.CreateArticle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateArticle_Mutation, Types.CreateArticle_MutationVariables>(CreateArticle_MutationDocument, options);
      }
export type CreateArticle_MutationHookResult = ReturnType<typeof useCreateArticle_Mutation>;
export type CreateArticle_MutationMutationResult = Apollo.MutationResult<Types.CreateArticle_Mutation>;
export type CreateArticle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateArticle_Mutation, Types.CreateArticle_MutationVariables>;
 const CreateArticles_MutationDocument = gql`
    mutation createArticles_mutation($articlesInput: [CreateArticleInput!]!) {
  createArticles(articlesInput: $articlesInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type CreateArticles_MutationMutationFn = Apollo.MutationFunction<Types.CreateArticles_Mutation, Types.CreateArticles_MutationVariables>;

/**
 * __useCreateArticles_Mutation__
 *
 * To run a mutation, you first call `useCreateArticles_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticles_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticlesMutation, { data, loading, error }] = useCreateArticles_Mutation({
 *   variables: {
 *      articlesInput: // value for 'articlesInput'
 *   },
 * });
 */
export function useCreateArticles_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateArticles_Mutation, Types.CreateArticles_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateArticles_Mutation, Types.CreateArticles_MutationVariables>(CreateArticles_MutationDocument, options);
      }
export type CreateArticles_MutationHookResult = ReturnType<typeof useCreateArticles_Mutation>;
export type CreateArticles_MutationMutationResult = Apollo.MutationResult<Types.CreateArticles_Mutation>;
export type CreateArticles_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateArticles_Mutation, Types.CreateArticles_MutationVariables>;
 const CreateLoadV2_MutationDocument = gql`
    mutation createLoadV2_mutation($loadInput: CreateLoadInputV2!) {
  createLoadV2(loadInput: $loadInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
export type CreateLoadV2_MutationMutationFn = Apollo.MutationFunction<Types.CreateLoadV2_Mutation, Types.CreateLoadV2_MutationVariables>;

/**
 * __useCreateLoadV2_Mutation__
 *
 * To run a mutation, you first call `useCreateLoadV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoadV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoadV2Mutation, { data, loading, error }] = useCreateLoadV2_Mutation({
 *   variables: {
 *      loadInput: // value for 'loadInput'
 *   },
 * });
 */
export function useCreateLoadV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLoadV2_Mutation, Types.CreateLoadV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLoadV2_Mutation, Types.CreateLoadV2_MutationVariables>(CreateLoadV2_MutationDocument, options);
      }
export type CreateLoadV2_MutationHookResult = ReturnType<typeof useCreateLoadV2_Mutation>;
export type CreateLoadV2_MutationMutationResult = Apollo.MutationResult<Types.CreateLoadV2_Mutation>;
export type CreateLoadV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateLoadV2_Mutation, Types.CreateLoadV2_MutationVariables>;
 const CreateLoadsV2_MutationDocument = gql`
    mutation createLoadsV2_mutation($loadsInput: [CreateLoadInputV2!]!) {
  createLoadsV2(loadsInput: $loadsInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type CreateLoadsV2_MutationMutationFn = Apollo.MutationFunction<Types.CreateLoadsV2_Mutation, Types.CreateLoadsV2_MutationVariables>;

/**
 * __useCreateLoadsV2_Mutation__
 *
 * To run a mutation, you first call `useCreateLoadsV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoadsV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoadsV2Mutation, { data, loading, error }] = useCreateLoadsV2_Mutation({
 *   variables: {
 *      loadsInput: // value for 'loadsInput'
 *   },
 * });
 */
export function useCreateLoadsV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLoadsV2_Mutation, Types.CreateLoadsV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLoadsV2_Mutation, Types.CreateLoadsV2_MutationVariables>(CreateLoadsV2_MutationDocument, options);
      }
export type CreateLoadsV2_MutationHookResult = ReturnType<typeof useCreateLoadsV2_Mutation>;
export type CreateLoadsV2_MutationMutationResult = Apollo.MutationResult<Types.CreateLoadsV2_Mutation>;
export type CreateLoadsV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateLoadsV2_Mutation, Types.CreateLoadsV2_MutationVariables>;
 const CreateLocationV2_MutationDocument = gql`
    mutation createLocationV2_mutation($locationInput: CreateLocationInputV2!) {
  createLocationV2(locationInput: $locationInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
export type CreateLocationV2_MutationMutationFn = Apollo.MutationFunction<Types.CreateLocationV2_Mutation, Types.CreateLocationV2_MutationVariables>;

/**
 * __useCreateLocationV2_Mutation__
 *
 * To run a mutation, you first call `useCreateLocationV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationV2Mutation, { data, loading, error }] = useCreateLocationV2_Mutation({
 *   variables: {
 *      locationInput: // value for 'locationInput'
 *   },
 * });
 */
export function useCreateLocationV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLocationV2_Mutation, Types.CreateLocationV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLocationV2_Mutation, Types.CreateLocationV2_MutationVariables>(CreateLocationV2_MutationDocument, options);
      }
export type CreateLocationV2_MutationHookResult = ReturnType<typeof useCreateLocationV2_Mutation>;
export type CreateLocationV2_MutationMutationResult = Apollo.MutationResult<Types.CreateLocationV2_Mutation>;
export type CreateLocationV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateLocationV2_Mutation, Types.CreateLocationV2_MutationVariables>;
 const CreateLocationsV2_MutationDocument = gql`
    mutation createLocationsV2_mutation($locationsInput: [CreateLocationInputV2!]!) {
  createLocationsV2(locationsInput: $locationsInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type CreateLocationsV2_MutationMutationFn = Apollo.MutationFunction<Types.CreateLocationsV2_Mutation, Types.CreateLocationsV2_MutationVariables>;

/**
 * __useCreateLocationsV2_Mutation__
 *
 * To run a mutation, you first call `useCreateLocationsV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationsV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationsV2Mutation, { data, loading, error }] = useCreateLocationsV2_Mutation({
 *   variables: {
 *      locationsInput: // value for 'locationsInput'
 *   },
 * });
 */
export function useCreateLocationsV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLocationsV2_Mutation, Types.CreateLocationsV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLocationsV2_Mutation, Types.CreateLocationsV2_MutationVariables>(CreateLocationsV2_MutationDocument, options);
      }
export type CreateLocationsV2_MutationHookResult = ReturnType<typeof useCreateLocationsV2_Mutation>;
export type CreateLocationsV2_MutationMutationResult = Apollo.MutationResult<Types.CreateLocationsV2_Mutation>;
export type CreateLocationsV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateLocationsV2_Mutation, Types.CreateLocationsV2_MutationVariables>;
 const CreateOrder_MutationDocument = gql`
    mutation createOrder_mutation($orderInput: CreateOrderInput!) {
  createOrder(orderInput: $orderInput) {
    id
  }
}
    `;
export type CreateOrder_MutationMutationFn = Apollo.MutationFunction<Types.CreateOrder_Mutation, Types.CreateOrder_MutationVariables>;

/**
 * __useCreateOrder_Mutation__
 *
 * To run a mutation, you first call `useCreateOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrder_Mutation({
 *   variables: {
 *      orderInput: // value for 'orderInput'
 *   },
 * });
 */
export function useCreateOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrder_Mutation, Types.CreateOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrder_Mutation, Types.CreateOrder_MutationVariables>(CreateOrder_MutationDocument, options);
      }
export type CreateOrder_MutationHookResult = ReturnType<typeof useCreateOrder_Mutation>;
export type CreateOrder_MutationMutationResult = Apollo.MutationResult<Types.CreateOrder_Mutation>;
export type CreateOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrder_Mutation, Types.CreateOrder_MutationVariables>;
 const CreateOrders_MutationDocument = gql`
    mutation createOrders_mutation($ordersInput: [CreateOrderInput!]!) {
  createOrders(ordersInput: $ordersInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type CreateOrders_MutationMutationFn = Apollo.MutationFunction<Types.CreateOrders_Mutation, Types.CreateOrders_MutationVariables>;

/**
 * __useCreateOrders_Mutation__
 *
 * To run a mutation, you first call `useCreateOrders_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrders_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrdersMutation, { data, loading, error }] = useCreateOrders_Mutation({
 *   variables: {
 *      ordersInput: // value for 'ordersInput'
 *   },
 * });
 */
export function useCreateOrders_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrders_Mutation, Types.CreateOrders_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrders_Mutation, Types.CreateOrders_MutationVariables>(CreateOrders_MutationDocument, options);
      }
export type CreateOrders_MutationHookResult = ReturnType<typeof useCreateOrders_Mutation>;
export type CreateOrders_MutationMutationResult = Apollo.MutationResult<Types.CreateOrders_Mutation>;
export type CreateOrders_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrders_Mutation, Types.CreateOrders_MutationVariables>;
 const CreatePackaging_MutationDocument = gql`
    mutation createPackaging_mutation($input: ArticleUnitInput!) {
  createPackaging(input: $input) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    packagingCode
    packagingDescription
    articlesPerPackage
    maxStackSize
    dimensions {
      weight
      height
      width
      length
    }
    liftingSide
    parent {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        liftingSide
      }
      quantityChildrenPerParent
    }
    tenantId
  }
}
    `;
export type CreatePackaging_MutationMutationFn = Apollo.MutationFunction<Types.CreatePackaging_Mutation, Types.CreatePackaging_MutationVariables>;

/**
 * __useCreatePackaging_Mutation__
 *
 * To run a mutation, you first call `useCreatePackaging_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackaging_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackagingMutation, { data, loading, error }] = useCreatePackaging_Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePackaging_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePackaging_Mutation, Types.CreatePackaging_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePackaging_Mutation, Types.CreatePackaging_MutationVariables>(CreatePackaging_MutationDocument, options);
      }
export type CreatePackaging_MutationHookResult = ReturnType<typeof useCreatePackaging_Mutation>;
export type CreatePackaging_MutationMutationResult = Apollo.MutationResult<Types.CreatePackaging_Mutation>;
export type CreatePackaging_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreatePackaging_Mutation, Types.CreatePackaging_MutationVariables>;
 const DeleteArticle_MutationDocument = gql`
    mutation deleteArticle_mutation($filter: FilterArticleInput!) {
  deleteArticle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
export type DeleteArticle_MutationMutationFn = Apollo.MutationFunction<Types.DeleteArticle_Mutation, Types.DeleteArticle_MutationVariables>;

/**
 * __useDeleteArticle_Mutation__
 *
 * To run a mutation, you first call `useDeleteArticle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteArticle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteArticle_Mutation, Types.DeleteArticle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteArticle_Mutation, Types.DeleteArticle_MutationVariables>(DeleteArticle_MutationDocument, options);
      }
export type DeleteArticle_MutationHookResult = ReturnType<typeof useDeleteArticle_Mutation>;
export type DeleteArticle_MutationMutationResult = Apollo.MutationResult<Types.DeleteArticle_Mutation>;
export type DeleteArticle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteArticle_Mutation, Types.DeleteArticle_MutationVariables>;
 const DeleteArticles_MutationDocument = gql`
    mutation deleteArticles_mutation($filter: FilterArticlesInput!) {
  deleteArticles(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type DeleteArticles_MutationMutationFn = Apollo.MutationFunction<Types.DeleteArticles_Mutation, Types.DeleteArticles_MutationVariables>;

/**
 * __useDeleteArticles_Mutation__
 *
 * To run a mutation, you first call `useDeleteArticles_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticles_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticlesMutation, { data, loading, error }] = useDeleteArticles_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteArticles_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteArticles_Mutation, Types.DeleteArticles_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteArticles_Mutation, Types.DeleteArticles_MutationVariables>(DeleteArticles_MutationDocument, options);
      }
export type DeleteArticles_MutationHookResult = ReturnType<typeof useDeleteArticles_Mutation>;
export type DeleteArticles_MutationMutationResult = Apollo.MutationResult<Types.DeleteArticles_Mutation>;
export type DeleteArticles_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteArticles_Mutation, Types.DeleteArticles_MutationVariables>;
 const DeleteLoadV2_MutationDocument = gql`
    mutation deleteLoadV2_mutation($filter: FilterLoadInput!) {
  deleteLoadV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
export type DeleteLoadV2_MutationMutationFn = Apollo.MutationFunction<Types.DeleteLoadV2_Mutation, Types.DeleteLoadV2_MutationVariables>;

/**
 * __useDeleteLoadV2_Mutation__
 *
 * To run a mutation, you first call `useDeleteLoadV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoadV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoadV2Mutation, { data, loading, error }] = useDeleteLoadV2_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteLoadV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteLoadV2_Mutation, Types.DeleteLoadV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteLoadV2_Mutation, Types.DeleteLoadV2_MutationVariables>(DeleteLoadV2_MutationDocument, options);
      }
export type DeleteLoadV2_MutationHookResult = ReturnType<typeof useDeleteLoadV2_Mutation>;
export type DeleteLoadV2_MutationMutationResult = Apollo.MutationResult<Types.DeleteLoadV2_Mutation>;
export type DeleteLoadV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteLoadV2_Mutation, Types.DeleteLoadV2_MutationVariables>;
 const DeleteLoadsV2_MutationDocument = gql`
    mutation deleteLoadsV2_mutation($filter: FilterLoadsInput!) {
  deleteLoadsV2(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type DeleteLoadsV2_MutationMutationFn = Apollo.MutationFunction<Types.DeleteLoadsV2_Mutation, Types.DeleteLoadsV2_MutationVariables>;

/**
 * __useDeleteLoadsV2_Mutation__
 *
 * To run a mutation, you first call `useDeleteLoadsV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoadsV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoadsV2Mutation, { data, loading, error }] = useDeleteLoadsV2_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteLoadsV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteLoadsV2_Mutation, Types.DeleteLoadsV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteLoadsV2_Mutation, Types.DeleteLoadsV2_MutationVariables>(DeleteLoadsV2_MutationDocument, options);
      }
export type DeleteLoadsV2_MutationHookResult = ReturnType<typeof useDeleteLoadsV2_Mutation>;
export type DeleteLoadsV2_MutationMutationResult = Apollo.MutationResult<Types.DeleteLoadsV2_Mutation>;
export type DeleteLoadsV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteLoadsV2_Mutation, Types.DeleteLoadsV2_MutationVariables>;
 const DeleteLocationV2_MutationDocument = gql`
    mutation deleteLocationV2_mutation($filter: FilterLocationInput!) {
  deleteLocationV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
export type DeleteLocationV2_MutationMutationFn = Apollo.MutationFunction<Types.DeleteLocationV2_Mutation, Types.DeleteLocationV2_MutationVariables>;

/**
 * __useDeleteLocationV2_Mutation__
 *
 * To run a mutation, you first call `useDeleteLocationV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationV2Mutation, { data, loading, error }] = useDeleteLocationV2_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteLocationV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteLocationV2_Mutation, Types.DeleteLocationV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteLocationV2_Mutation, Types.DeleteLocationV2_MutationVariables>(DeleteLocationV2_MutationDocument, options);
      }
export type DeleteLocationV2_MutationHookResult = ReturnType<typeof useDeleteLocationV2_Mutation>;
export type DeleteLocationV2_MutationMutationResult = Apollo.MutationResult<Types.DeleteLocationV2_Mutation>;
export type DeleteLocationV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteLocationV2_Mutation, Types.DeleteLocationV2_MutationVariables>;
 const DeleteLocationsV2_MutationDocument = gql`
    mutation deleteLocationsV2_mutation($filter: FilterLocationsInput!) {
  deleteLocationsV2(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type DeleteLocationsV2_MutationMutationFn = Apollo.MutationFunction<Types.DeleteLocationsV2_Mutation, Types.DeleteLocationsV2_MutationVariables>;

/**
 * __useDeleteLocationsV2_Mutation__
 *
 * To run a mutation, you first call `useDeleteLocationsV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationsV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationsV2Mutation, { data, loading, error }] = useDeleteLocationsV2_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteLocationsV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteLocationsV2_Mutation, Types.DeleteLocationsV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteLocationsV2_Mutation, Types.DeleteLocationsV2_MutationVariables>(DeleteLocationsV2_MutationDocument, options);
      }
export type DeleteLocationsV2_MutationHookResult = ReturnType<typeof useDeleteLocationsV2_Mutation>;
export type DeleteLocationsV2_MutationMutationResult = Apollo.MutationResult<Types.DeleteLocationsV2_Mutation>;
export type DeleteLocationsV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteLocationsV2_Mutation, Types.DeleteLocationsV2_MutationVariables>;
 const DeleteOrder_MutationDocument = gql`
    mutation deleteOrder_mutation($filter: FilterOrderInput!) {
  deleteOrder(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
export type DeleteOrder_MutationMutationFn = Apollo.MutationFunction<Types.DeleteOrder_Mutation, Types.DeleteOrder_MutationVariables>;

/**
 * __useDeleteOrder_Mutation__
 *
 * To run a mutation, you first call `useDeleteOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrder_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrder_Mutation, Types.DeleteOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrder_Mutation, Types.DeleteOrder_MutationVariables>(DeleteOrder_MutationDocument, options);
      }
export type DeleteOrder_MutationHookResult = ReturnType<typeof useDeleteOrder_Mutation>;
export type DeleteOrder_MutationMutationResult = Apollo.MutationResult<Types.DeleteOrder_Mutation>;
export type DeleteOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrder_Mutation, Types.DeleteOrder_MutationVariables>;
 const DeleteOrders_MutationDocument = gql`
    mutation deleteOrders_mutation($filter: FilterOrdersInput!) {
  deleteOrders(filter: $filter) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type DeleteOrders_MutationMutationFn = Apollo.MutationFunction<Types.DeleteOrders_Mutation, Types.DeleteOrders_MutationVariables>;

/**
 * __useDeleteOrders_Mutation__
 *
 * To run a mutation, you first call `useDeleteOrders_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrders_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrdersMutation, { data, loading, error }] = useDeleteOrders_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteOrders_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrders_Mutation, Types.DeleteOrders_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrders_Mutation, Types.DeleteOrders_MutationVariables>(DeleteOrders_MutationDocument, options);
      }
export type DeleteOrders_MutationHookResult = ReturnType<typeof useDeleteOrders_Mutation>;
export type DeleteOrders_MutationMutationResult = Apollo.MutationResult<Types.DeleteOrders_Mutation>;
export type DeleteOrders_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrders_Mutation, Types.DeleteOrders_MutationVariables>;
 const EstimateTravelDuration_QueryDocument = gql`
    query estimateTravelDuration_query($locationIds: [String!]!) {
  estimateTravelDuration(locationIds: $locationIds) {
    locationId
    drivingTime
    distance
  }
}
    `;

/**
 * __useEstimateTravelDuration_Query__
 *
 * To run a query within a React component, call `useEstimateTravelDuration_Query` and pass it any options that fit your needs.
 * When your component renders, `useEstimateTravelDuration_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateTravelDuration_Query({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useEstimateTravelDuration_Query(baseOptions: Apollo.QueryHookOptions<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables> & ({ variables: Types.EstimateTravelDuration_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables>(EstimateTravelDuration_QueryDocument, options);
      }
export function useEstimateTravelDuration_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables>(EstimateTravelDuration_QueryDocument, options);
        }
export function useEstimateTravelDuration_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables>(EstimateTravelDuration_QueryDocument, options);
        }
export type EstimateTravelDuration_QueryHookResult = ReturnType<typeof useEstimateTravelDuration_Query>;
export type EstimateTravelDuration_QueryLazyQueryHookResult = ReturnType<typeof useEstimateTravelDuration_QueryLazyQuery>;
export type EstimateTravelDuration_QuerySuspenseQueryHookResult = ReturnType<typeof useEstimateTravelDuration_QuerySuspenseQuery>;
export type EstimateTravelDuration_QueryQueryResult = Apollo.QueryResult<Types.EstimateTravelDuration_Query, Types.EstimateTravelDuration_QueryVariables>;
 const FindArticle_QueryDocument = gql`
    query findArticle_query($filter: FilterArticleInput!) {
  findArticle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;

/**
 * __useFindArticle_Query__
 *
 * To run a query within a React component, call `useFindArticle_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindArticle_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindArticle_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindArticle_Query(baseOptions: Apollo.QueryHookOptions<Types.FindArticle_Query, Types.FindArticle_QueryVariables> & ({ variables: Types.FindArticle_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindArticle_Query, Types.FindArticle_QueryVariables>(FindArticle_QueryDocument, options);
      }
export function useFindArticle_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindArticle_Query, Types.FindArticle_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindArticle_Query, Types.FindArticle_QueryVariables>(FindArticle_QueryDocument, options);
        }
export function useFindArticle_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindArticle_Query, Types.FindArticle_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindArticle_Query, Types.FindArticle_QueryVariables>(FindArticle_QueryDocument, options);
        }
export type FindArticle_QueryHookResult = ReturnType<typeof useFindArticle_Query>;
export type FindArticle_QueryLazyQueryHookResult = ReturnType<typeof useFindArticle_QueryLazyQuery>;
export type FindArticle_QuerySuspenseQueryHookResult = ReturnType<typeof useFindArticle_QuerySuspenseQuery>;
export type FindArticle_QueryQueryResult = Apollo.QueryResult<Types.FindArticle_Query, Types.FindArticle_QueryVariables>;
 const FindArticles_QueryDocument = gql`
    query findArticles_query($query: QueryArticlesInput!) {
  findArticles(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      weightInKgPerUnit
      packagingOptions {
        packaging {
          packagingCode
          packagingDescription
          articlesPerPackage
          maxStackSize
          dimensions {
            weight
            height
            width
            length
          }
          parent {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              liftingSide
            }
            quantityChildrenPerParent
          }
          liftingSide
        }
        maxStackSize
        articlesPerPackage
      }
    }
  }
}
    `;

/**
 * __useFindArticles_Query__
 *
 * To run a query within a React component, call `useFindArticles_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindArticles_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindArticles_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindArticles_Query(baseOptions: Apollo.QueryHookOptions<Types.FindArticles_Query, Types.FindArticles_QueryVariables> & ({ variables: Types.FindArticles_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindArticles_Query, Types.FindArticles_QueryVariables>(FindArticles_QueryDocument, options);
      }
export function useFindArticles_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindArticles_Query, Types.FindArticles_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindArticles_Query, Types.FindArticles_QueryVariables>(FindArticles_QueryDocument, options);
        }
export function useFindArticles_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindArticles_Query, Types.FindArticles_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindArticles_Query, Types.FindArticles_QueryVariables>(FindArticles_QueryDocument, options);
        }
export type FindArticles_QueryHookResult = ReturnType<typeof useFindArticles_Query>;
export type FindArticles_QueryLazyQueryHookResult = ReturnType<typeof useFindArticles_QueryLazyQuery>;
export type FindArticles_QuerySuspenseQueryHookResult = ReturnType<typeof useFindArticles_QuerySuspenseQuery>;
export type FindArticles_QueryQueryResult = Apollo.QueryResult<Types.FindArticles_Query, Types.FindArticles_QueryVariables>;
 const FindArticlesByExternalReferences_QueryDocument = gql`
    query findArticlesByExternalReferences_query($externalReferences: [String!]!) {
  findArticlesByExternalReferences(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      name
      weightInKgPerUnit
      packagingOptions {
        packaging {
          packagingCode
          packagingDescription
          articlesPerPackage
          maxStackSize
          dimensions {
            weight
            height
            width
            length
          }
          parent {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              liftingSide
            }
            quantityChildrenPerParent
          }
          liftingSide
        }
        maxStackSize
        articlesPerPackage
      }
    }
  }
}
    `;

/**
 * __useFindArticlesByExternalReferences_Query__
 *
 * To run a query within a React component, call `useFindArticlesByExternalReferences_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindArticlesByExternalReferences_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindArticlesByExternalReferences_Query({
 *   variables: {
 *      externalReferences: // value for 'externalReferences'
 *   },
 * });
 */
export function useFindArticlesByExternalReferences_Query(baseOptions: Apollo.QueryHookOptions<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables> & ({ variables: Types.FindArticlesByExternalReferences_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables>(FindArticlesByExternalReferences_QueryDocument, options);
      }
export function useFindArticlesByExternalReferences_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables>(FindArticlesByExternalReferences_QueryDocument, options);
        }
export function useFindArticlesByExternalReferences_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables>(FindArticlesByExternalReferences_QueryDocument, options);
        }
export type FindArticlesByExternalReferences_QueryHookResult = ReturnType<typeof useFindArticlesByExternalReferences_Query>;
export type FindArticlesByExternalReferences_QueryLazyQueryHookResult = ReturnType<typeof useFindArticlesByExternalReferences_QueryLazyQuery>;
export type FindArticlesByExternalReferences_QuerySuspenseQueryHookResult = ReturnType<typeof useFindArticlesByExternalReferences_QuerySuspenseQuery>;
export type FindArticlesByExternalReferences_QueryQueryResult = Apollo.QueryResult<Types.FindArticlesByExternalReferences_Query, Types.FindArticlesByExternalReferences_QueryVariables>;
 const FindLoadCountsByDepots_QueryDocument = gql`
    query findLoadCountsByDepots_query($filter: FilterLoadCountByDepotInput!) {
  findLoadCountsByDepots(filter: $filter) {
    depot {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    count
    date
  }
}
    `;

/**
 * __useFindLoadCountsByDepots_Query__
 *
 * To run a query within a React component, call `useFindLoadCountsByDepots_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLoadCountsByDepots_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLoadCountsByDepots_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindLoadCountsByDepots_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables> & ({ variables: Types.FindLoadCountsByDepots_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables>(FindLoadCountsByDepots_QueryDocument, options);
      }
export function useFindLoadCountsByDepots_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables>(FindLoadCountsByDepots_QueryDocument, options);
        }
export function useFindLoadCountsByDepots_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables>(FindLoadCountsByDepots_QueryDocument, options);
        }
export type FindLoadCountsByDepots_QueryHookResult = ReturnType<typeof useFindLoadCountsByDepots_Query>;
export type FindLoadCountsByDepots_QueryLazyQueryHookResult = ReturnType<typeof useFindLoadCountsByDepots_QueryLazyQuery>;
export type FindLoadCountsByDepots_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLoadCountsByDepots_QuerySuspenseQuery>;
export type FindLoadCountsByDepots_QueryQueryResult = Apollo.QueryResult<Types.FindLoadCountsByDepots_Query, Types.FindLoadCountsByDepots_QueryVariables>;
 const FindLoadV2_QueryDocument = gql`
    query findLoadV2_query($filter: FilterLoadInput!) {
  findLoadV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;

/**
 * __useFindLoadV2_Query__
 *
 * To run a query within a React component, call `useFindLoadV2_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLoadV2_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLoadV2_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindLoadV2_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables> & ({ variables: Types.FindLoadV2_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables>(FindLoadV2_QueryDocument, options);
      }
export function useFindLoadV2_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables>(FindLoadV2_QueryDocument, options);
        }
export function useFindLoadV2_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables>(FindLoadV2_QueryDocument, options);
        }
export type FindLoadV2_QueryHookResult = ReturnType<typeof useFindLoadV2_Query>;
export type FindLoadV2_QueryLazyQueryHookResult = ReturnType<typeof useFindLoadV2_QueryLazyQuery>;
export type FindLoadV2_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLoadV2_QuerySuspenseQuery>;
export type FindLoadV2_QueryQueryResult = Apollo.QueryResult<Types.FindLoadV2_Query, Types.FindLoadV2_QueryVariables>;
 const FindLoadsByExternalReferencesV2_QueryDocument = gql`
    query findLoadsByExternalReferencesV2_query($externalReferences: [String!]!) {
  findLoadsByExternalReferencesV2(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindLoadsByExternalReferencesV2_Query__
 *
 * To run a query within a React component, call `useFindLoadsByExternalReferencesV2_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLoadsByExternalReferencesV2_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLoadsByExternalReferencesV2_Query({
 *   variables: {
 *      externalReferences: // value for 'externalReferences'
 *   },
 * });
 */
export function useFindLoadsByExternalReferencesV2_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables> & ({ variables: Types.FindLoadsByExternalReferencesV2_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables>(FindLoadsByExternalReferencesV2_QueryDocument, options);
      }
export function useFindLoadsByExternalReferencesV2_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables>(FindLoadsByExternalReferencesV2_QueryDocument, options);
        }
export function useFindLoadsByExternalReferencesV2_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables>(FindLoadsByExternalReferencesV2_QueryDocument, options);
        }
export type FindLoadsByExternalReferencesV2_QueryHookResult = ReturnType<typeof useFindLoadsByExternalReferencesV2_Query>;
export type FindLoadsByExternalReferencesV2_QueryLazyQueryHookResult = ReturnType<typeof useFindLoadsByExternalReferencesV2_QueryLazyQuery>;
export type FindLoadsByExternalReferencesV2_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLoadsByExternalReferencesV2_QuerySuspenseQuery>;
export type FindLoadsByExternalReferencesV2_QueryQueryResult = Apollo.QueryResult<Types.FindLoadsByExternalReferencesV2_Query, Types.FindLoadsByExternalReferencesV2_QueryVariables>;
 const FindLoadsCount_QueryDocument = gql`
    query findLoadsCount_query($query: QueryLoadsInput!) {
  findLoadsCount(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindLoadsCount_Query__
 *
 * To run a query within a React component, call `useFindLoadsCount_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLoadsCount_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLoadsCount_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindLoadsCount_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables> & ({ variables: Types.FindLoadsCount_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables>(FindLoadsCount_QueryDocument, options);
      }
export function useFindLoadsCount_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables>(FindLoadsCount_QueryDocument, options);
        }
export function useFindLoadsCount_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables>(FindLoadsCount_QueryDocument, options);
        }
export type FindLoadsCount_QueryHookResult = ReturnType<typeof useFindLoadsCount_Query>;
export type FindLoadsCount_QueryLazyQueryHookResult = ReturnType<typeof useFindLoadsCount_QueryLazyQuery>;
export type FindLoadsCount_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLoadsCount_QuerySuspenseQuery>;
export type FindLoadsCount_QueryQueryResult = Apollo.QueryResult<Types.FindLoadsCount_Query, Types.FindLoadsCount_QueryVariables>;
 const FindLoadsV2_QueryDocument = gql`
    query findLoadsV2_query($query: QueryLoadsInput!) {
  findLoadsV2(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
        order {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          deadline
          type
          status
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            totalQuantity
            totalLoadingMillimeter
            totalWeightInKg
            deadline
          }
          customerOrderReference
          customerComment
          internalComment
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindLoadsV2_Query__
 *
 * To run a query within a React component, call `useFindLoadsV2_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLoadsV2_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLoadsV2_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindLoadsV2_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables> & ({ variables: Types.FindLoadsV2_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables>(FindLoadsV2_QueryDocument, options);
      }
export function useFindLoadsV2_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables>(FindLoadsV2_QueryDocument, options);
        }
export function useFindLoadsV2_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables>(FindLoadsV2_QueryDocument, options);
        }
export type FindLoadsV2_QueryHookResult = ReturnType<typeof useFindLoadsV2_Query>;
export type FindLoadsV2_QueryLazyQueryHookResult = ReturnType<typeof useFindLoadsV2_QueryLazyQuery>;
export type FindLoadsV2_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLoadsV2_QuerySuspenseQuery>;
export type FindLoadsV2_QueryQueryResult = Apollo.QueryResult<Types.FindLoadsV2_Query, Types.FindLoadsV2_QueryVariables>;
 const FindLocationV2_QueryDocument = gql`
    query findLocationV2_query($filter: FilterLocationInput!) {
  findLocationV2(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;

/**
 * __useFindLocationV2_Query__
 *
 * To run a query within a React component, call `useFindLocationV2_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationV2_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationV2_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindLocationV2_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables> & ({ variables: Types.FindLocationV2_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables>(FindLocationV2_QueryDocument, options);
      }
export function useFindLocationV2_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables>(FindLocationV2_QueryDocument, options);
        }
export function useFindLocationV2_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables>(FindLocationV2_QueryDocument, options);
        }
export type FindLocationV2_QueryHookResult = ReturnType<typeof useFindLocationV2_Query>;
export type FindLocationV2_QueryLazyQueryHookResult = ReturnType<typeof useFindLocationV2_QueryLazyQuery>;
export type FindLocationV2_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLocationV2_QuerySuspenseQuery>;
export type FindLocationV2_QueryQueryResult = Apollo.QueryResult<Types.FindLocationV2_Query, Types.FindLocationV2_QueryVariables>;
 const FindLocationsByExternalReferencesV2_QueryDocument = gql`
    query findLocationsByExternalReferencesV2_query($externalReferences: [String!]!) {
  findLocationsByExternalReferencesV2(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useFindLocationsByExternalReferencesV2_Query__
 *
 * To run a query within a React component, call `useFindLocationsByExternalReferencesV2_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationsByExternalReferencesV2_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationsByExternalReferencesV2_Query({
 *   variables: {
 *      externalReferences: // value for 'externalReferences'
 *   },
 * });
 */
export function useFindLocationsByExternalReferencesV2_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables> & ({ variables: Types.FindLocationsByExternalReferencesV2_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables>(FindLocationsByExternalReferencesV2_QueryDocument, options);
      }
export function useFindLocationsByExternalReferencesV2_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables>(FindLocationsByExternalReferencesV2_QueryDocument, options);
        }
export function useFindLocationsByExternalReferencesV2_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables>(FindLocationsByExternalReferencesV2_QueryDocument, options);
        }
export type FindLocationsByExternalReferencesV2_QueryHookResult = ReturnType<typeof useFindLocationsByExternalReferencesV2_Query>;
export type FindLocationsByExternalReferencesV2_QueryLazyQueryHookResult = ReturnType<typeof useFindLocationsByExternalReferencesV2_QueryLazyQuery>;
export type FindLocationsByExternalReferencesV2_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLocationsByExternalReferencesV2_QuerySuspenseQuery>;
export type FindLocationsByExternalReferencesV2_QueryQueryResult = Apollo.QueryResult<Types.FindLocationsByExternalReferencesV2_Query, Types.FindLocationsByExternalReferencesV2_QueryVariables>;
 const FindLocationsV2_QueryDocument = gql`
    query findLocationsV2_query($query: QueryLocationsInput!) {
  findLocationsV2(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useFindLocationsV2_Query__
 *
 * To run a query within a React component, call `useFindLocationsV2_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationsV2_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationsV2_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindLocationsV2_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables> & ({ variables: Types.FindLocationsV2_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables>(FindLocationsV2_QueryDocument, options);
      }
export function useFindLocationsV2_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables>(FindLocationsV2_QueryDocument, options);
        }
export function useFindLocationsV2_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables>(FindLocationsV2_QueryDocument, options);
        }
export type FindLocationsV2_QueryHookResult = ReturnType<typeof useFindLocationsV2_Query>;
export type FindLocationsV2_QueryLazyQueryHookResult = ReturnType<typeof useFindLocationsV2_QueryLazyQuery>;
export type FindLocationsV2_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLocationsV2_QuerySuspenseQuery>;
export type FindLocationsV2_QueryQueryResult = Apollo.QueryResult<Types.FindLocationsV2_Query, Types.FindLocationsV2_QueryVariables>;
 const FindOrder_QueryDocument = gql`
    query findOrder_query($filter: FilterOrderInput!) {
  findOrder(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;

/**
 * __useFindOrder_Query__
 *
 * To run a query within a React component, call `useFindOrder_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindOrder_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrder_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindOrder_Query(baseOptions: Apollo.QueryHookOptions<Types.FindOrder_Query, Types.FindOrder_QueryVariables> & ({ variables: Types.FindOrder_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindOrder_Query, Types.FindOrder_QueryVariables>(FindOrder_QueryDocument, options);
      }
export function useFindOrder_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindOrder_Query, Types.FindOrder_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindOrder_Query, Types.FindOrder_QueryVariables>(FindOrder_QueryDocument, options);
        }
export function useFindOrder_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindOrder_Query, Types.FindOrder_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindOrder_Query, Types.FindOrder_QueryVariables>(FindOrder_QueryDocument, options);
        }
export type FindOrder_QueryHookResult = ReturnType<typeof useFindOrder_Query>;
export type FindOrder_QueryLazyQueryHookResult = ReturnType<typeof useFindOrder_QueryLazyQuery>;
export type FindOrder_QuerySuspenseQueryHookResult = ReturnType<typeof useFindOrder_QuerySuspenseQuery>;
export type FindOrder_QueryQueryResult = Apollo.QueryResult<Types.FindOrder_Query, Types.FindOrder_QueryVariables>;
 const FindOrders_QueryDocument = gql`
    query findOrders_query($query: QueryOrdersInput!) {
  findOrders(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      deadline
      type
      status
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        totalQuantity
        totalLoadingMillimeter
        totalWeightInKg
        deadline
      }
      loads {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        content
        loadingMillimeter
        weightInKg
        transportRequirements
        additionalInfo
        status
        statusChangedAt
        plannedFor
        pickUp {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        dropOff {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
            }
          }
        }
      }
      customerOrderReference
      customerComment
      internalComment
    }
  }
}
    `;

/**
 * __useFindOrders_Query__
 *
 * To run a query within a React component, call `useFindOrders_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindOrders_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrders_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindOrders_Query(baseOptions: Apollo.QueryHookOptions<Types.FindOrders_Query, Types.FindOrders_QueryVariables> & ({ variables: Types.FindOrders_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindOrders_Query, Types.FindOrders_QueryVariables>(FindOrders_QueryDocument, options);
      }
export function useFindOrders_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindOrders_Query, Types.FindOrders_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindOrders_Query, Types.FindOrders_QueryVariables>(FindOrders_QueryDocument, options);
        }
export function useFindOrders_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindOrders_Query, Types.FindOrders_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindOrders_Query, Types.FindOrders_QueryVariables>(FindOrders_QueryDocument, options);
        }
export type FindOrders_QueryHookResult = ReturnType<typeof useFindOrders_Query>;
export type FindOrders_QueryLazyQueryHookResult = ReturnType<typeof useFindOrders_QueryLazyQuery>;
export type FindOrders_QuerySuspenseQueryHookResult = ReturnType<typeof useFindOrders_QuerySuspenseQuery>;
export type FindOrders_QueryQueryResult = Apollo.QueryResult<Types.FindOrders_Query, Types.FindOrders_QueryVariables>;
 const FindOrdersByExternalReferences_QueryDocument = gql`
    query findOrdersByExternalReferences_query($externalReferences: [String!]!) {
  findOrdersByExternalReferences(externalReferences: $externalReferences) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      deadline
      type
      status
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        totalQuantity
        totalLoadingMillimeter
        totalWeightInKg
        deadline
      }
      loads {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        content
        loadingMillimeter
        weightInKg
        transportRequirements
        additionalInfo
        status
        statusChangedAt
        plannedFor
        pickUp {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        dropOff {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
            }
          }
        }
      }
      customerOrderReference
      customerComment
      internalComment
    }
  }
}
    `;

/**
 * __useFindOrdersByExternalReferences_Query__
 *
 * To run a query within a React component, call `useFindOrdersByExternalReferences_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindOrdersByExternalReferences_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrdersByExternalReferences_Query({
 *   variables: {
 *      externalReferences: // value for 'externalReferences'
 *   },
 * });
 */
export function useFindOrdersByExternalReferences_Query(baseOptions: Apollo.QueryHookOptions<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables> & ({ variables: Types.FindOrdersByExternalReferences_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables>(FindOrdersByExternalReferences_QueryDocument, options);
      }
export function useFindOrdersByExternalReferences_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables>(FindOrdersByExternalReferences_QueryDocument, options);
        }
export function useFindOrdersByExternalReferences_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables>(FindOrdersByExternalReferences_QueryDocument, options);
        }
export type FindOrdersByExternalReferences_QueryHookResult = ReturnType<typeof useFindOrdersByExternalReferences_Query>;
export type FindOrdersByExternalReferences_QueryLazyQueryHookResult = ReturnType<typeof useFindOrdersByExternalReferences_QueryLazyQuery>;
export type FindOrdersByExternalReferences_QuerySuspenseQueryHookResult = ReturnType<typeof useFindOrdersByExternalReferences_QuerySuspenseQuery>;
export type FindOrdersByExternalReferences_QueryQueryResult = Apollo.QueryResult<Types.FindOrdersByExternalReferences_Query, Types.FindOrdersByExternalReferences_QueryVariables>;
 const FindPackages_QueryDocument = gql`
    query findPackages_query($query: QueryPackagingInput!) {
  findPackages(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      packagingCode
      packagingDescription
      articlesPerPackage
      maxStackSize
      dimensions {
        weight
        height
        width
        length
      }
      liftingSide
      parent {
        packaging {
          packagingCode
          packagingDescription
          articlesPerPackage
          maxStackSize
          dimensions {
            weight
            height
            width
            length
          }
          liftingSide
        }
        quantityChildrenPerParent
      }
      tenantId
    }
  }
}
    `;

/**
 * __useFindPackages_Query__
 *
 * To run a query within a React component, call `useFindPackages_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindPackages_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPackages_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindPackages_Query(baseOptions: Apollo.QueryHookOptions<Types.FindPackages_Query, Types.FindPackages_QueryVariables> & ({ variables: Types.FindPackages_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindPackages_Query, Types.FindPackages_QueryVariables>(FindPackages_QueryDocument, options);
      }
export function useFindPackages_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindPackages_Query, Types.FindPackages_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindPackages_Query, Types.FindPackages_QueryVariables>(FindPackages_QueryDocument, options);
        }
export function useFindPackages_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindPackages_Query, Types.FindPackages_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindPackages_Query, Types.FindPackages_QueryVariables>(FindPackages_QueryDocument, options);
        }
export type FindPackages_QueryHookResult = ReturnType<typeof useFindPackages_Query>;
export type FindPackages_QueryLazyQueryHookResult = ReturnType<typeof useFindPackages_QueryLazyQuery>;
export type FindPackages_QuerySuspenseQueryHookResult = ReturnType<typeof useFindPackages_QuerySuspenseQuery>;
export type FindPackages_QueryQueryResult = Apollo.QueryResult<Types.FindPackages_Query, Types.FindPackages_QueryVariables>;
 const GetLocationMasterDataInfo_QueryDocument = gql`
    query getLocationMasterDataInfo_query($filter: FilterLocationMasterDataInput!) {
  getLocationMasterDataInfo(filter: $filter) {
    infoType
    count
  }
}
    `;

/**
 * __useGetLocationMasterDataInfo_Query__
 *
 * To run a query within a React component, call `useGetLocationMasterDataInfo_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationMasterDataInfo_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationMasterDataInfo_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLocationMasterDataInfo_Query(baseOptions: Apollo.QueryHookOptions<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables> & ({ variables: Types.GetLocationMasterDataInfo_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables>(GetLocationMasterDataInfo_QueryDocument, options);
      }
export function useGetLocationMasterDataInfo_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables>(GetLocationMasterDataInfo_QueryDocument, options);
        }
export function useGetLocationMasterDataInfo_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables>(GetLocationMasterDataInfo_QueryDocument, options);
        }
export type GetLocationMasterDataInfo_QueryHookResult = ReturnType<typeof useGetLocationMasterDataInfo_Query>;
export type GetLocationMasterDataInfo_QueryLazyQueryHookResult = ReturnType<typeof useGetLocationMasterDataInfo_QueryLazyQuery>;
export type GetLocationMasterDataInfo_QuerySuspenseQueryHookResult = ReturnType<typeof useGetLocationMasterDataInfo_QuerySuspenseQuery>;
export type GetLocationMasterDataInfo_QueryQueryResult = Apollo.QueryResult<Types.GetLocationMasterDataInfo_Query, Types.GetLocationMasterDataInfo_QueryVariables>;
 const ImportArticles_MutationDocument = gql`
    mutation importArticles_mutation($articlesInput: [CreateArticleInput!]!) {
  importArticles(articlesInput: $articlesInput) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportArticles_MutationMutationFn = Apollo.MutationFunction<Types.ImportArticles_Mutation, Types.ImportArticles_MutationVariables>;

/**
 * __useImportArticles_Mutation__
 *
 * To run a mutation, you first call `useImportArticles_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportArticles_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importArticlesMutation, { data, loading, error }] = useImportArticles_Mutation({
 *   variables: {
 *      articlesInput: // value for 'articlesInput'
 *   },
 * });
 */
export function useImportArticles_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportArticles_Mutation, Types.ImportArticles_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportArticles_Mutation, Types.ImportArticles_MutationVariables>(ImportArticles_MutationDocument, options);
      }
export type ImportArticles_MutationHookResult = ReturnType<typeof useImportArticles_Mutation>;
export type ImportArticles_MutationMutationResult = Apollo.MutationResult<Types.ImportArticles_Mutation>;
export type ImportArticles_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportArticles_Mutation, Types.ImportArticles_MutationVariables>;
 const ImportLoadLocations_MutationDocument = gql`
    mutation importLoadLocations_mutation($locationsImport: [LoadLocationImportInput!]!) {
  importLoadLocations(locationsImport: $locationsImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportLoadLocations_MutationMutationFn = Apollo.MutationFunction<Types.ImportLoadLocations_Mutation, Types.ImportLoadLocations_MutationVariables>;

/**
 * __useImportLoadLocations_Mutation__
 *
 * To run a mutation, you first call `useImportLoadLocations_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLoadLocations_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLoadLocationsMutation, { data, loading, error }] = useImportLoadLocations_Mutation({
 *   variables: {
 *      locationsImport: // value for 'locationsImport'
 *   },
 * });
 */
export function useImportLoadLocations_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportLoadLocations_Mutation, Types.ImportLoadLocations_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportLoadLocations_Mutation, Types.ImportLoadLocations_MutationVariables>(ImportLoadLocations_MutationDocument, options);
      }
export type ImportLoadLocations_MutationHookResult = ReturnType<typeof useImportLoadLocations_Mutation>;
export type ImportLoadLocations_MutationMutationResult = Apollo.MutationResult<Types.ImportLoadLocations_Mutation>;
export type ImportLoadLocations_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportLoadLocations_Mutation, Types.ImportLoadLocations_MutationVariables>;
 const ImportLoadsV2_MutationDocument = gql`
    mutation importLoadsV2_mutation($loadsImport: [LoadImportInput!]!) {
  importLoadsV2(loadsImport: $loadsImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportLoadsV2_MutationMutationFn = Apollo.MutationFunction<Types.ImportLoadsV2_Mutation, Types.ImportLoadsV2_MutationVariables>;

/**
 * __useImportLoadsV2_Mutation__
 *
 * To run a mutation, you first call `useImportLoadsV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLoadsV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLoadsV2Mutation, { data, loading, error }] = useImportLoadsV2_Mutation({
 *   variables: {
 *      loadsImport: // value for 'loadsImport'
 *   },
 * });
 */
export function useImportLoadsV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportLoadsV2_Mutation, Types.ImportLoadsV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportLoadsV2_Mutation, Types.ImportLoadsV2_MutationVariables>(ImportLoadsV2_MutationDocument, options);
      }
export type ImportLoadsV2_MutationHookResult = ReturnType<typeof useImportLoadsV2_Mutation>;
export type ImportLoadsV2_MutationMutationResult = Apollo.MutationResult<Types.ImportLoadsV2_Mutation>;
export type ImportLoadsV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportLoadsV2_Mutation, Types.ImportLoadsV2_MutationVariables>;
 const ImportLocationsV2_MutationDocument = gql`
    mutation importLocationsV2_mutation($locationsImport: [LocationImportWithIndexInput!]!) {
  importLocationsV2(locationsImport: $locationsImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportLocationsV2_MutationMutationFn = Apollo.MutationFunction<Types.ImportLocationsV2_Mutation, Types.ImportLocationsV2_MutationVariables>;

/**
 * __useImportLocationsV2_Mutation__
 *
 * To run a mutation, you first call `useImportLocationsV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLocationsV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLocationsV2Mutation, { data, loading, error }] = useImportLocationsV2_Mutation({
 *   variables: {
 *      locationsImport: // value for 'locationsImport'
 *   },
 * });
 */
export function useImportLocationsV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportLocationsV2_Mutation, Types.ImportLocationsV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportLocationsV2_Mutation, Types.ImportLocationsV2_MutationVariables>(ImportLocationsV2_MutationDocument, options);
      }
export type ImportLocationsV2_MutationHookResult = ReturnType<typeof useImportLocationsV2_Mutation>;
export type ImportLocationsV2_MutationMutationResult = Apollo.MutationResult<Types.ImportLocationsV2_Mutation>;
export type ImportLocationsV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportLocationsV2_Mutation, Types.ImportLocationsV2_MutationVariables>;
 const ImportOrders_MutationDocument = gql`
    mutation importOrders_mutation($ordersImport: [OrderImportInput!]!) {
  importOrders(ordersImport: $ordersImport) {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportOrders_MutationMutationFn = Apollo.MutationFunction<Types.ImportOrders_Mutation, Types.ImportOrders_MutationVariables>;

/**
 * __useImportOrders_Mutation__
 *
 * To run a mutation, you first call `useImportOrders_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOrders_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOrdersMutation, { data, loading, error }] = useImportOrders_Mutation({
 *   variables: {
 *      ordersImport: // value for 'ordersImport'
 *   },
 * });
 */
export function useImportOrders_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportOrders_Mutation, Types.ImportOrders_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportOrders_Mutation, Types.ImportOrders_MutationVariables>(ImportOrders_MutationDocument, options);
      }
export type ImportOrders_MutationHookResult = ReturnType<typeof useImportOrders_Mutation>;
export type ImportOrders_MutationMutationResult = Apollo.MutationResult<Types.ImportOrders_Mutation>;
export type ImportOrders_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportOrders_Mutation, Types.ImportOrders_MutationVariables>;
 const ImportPackaging_MutationDocument = gql`
    mutation importPackaging_mutation($input: [ArticleUnitInput!]!) {
  importPackaging(input: $input) {
    successfulCount
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type ImportPackaging_MutationMutationFn = Apollo.MutationFunction<Types.ImportPackaging_Mutation, Types.ImportPackaging_MutationVariables>;

/**
 * __useImportPackaging_Mutation__
 *
 * To run a mutation, you first call `useImportPackaging_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPackaging_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPackagingMutation, { data, loading, error }] = useImportPackaging_Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportPackaging_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportPackaging_Mutation, Types.ImportPackaging_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportPackaging_Mutation, Types.ImportPackaging_MutationVariables>(ImportPackaging_MutationDocument, options);
      }
export type ImportPackaging_MutationHookResult = ReturnType<typeof useImportPackaging_Mutation>;
export type ImportPackaging_MutationMutationResult = Apollo.MutationResult<Types.ImportPackaging_Mutation>;
export type ImportPackaging_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ImportPackaging_Mutation, Types.ImportPackaging_MutationVariables>;
 const MatchOrder_MutationDocument = gql`
    mutation matchOrder_mutation($filter: FilterOrderInput!, $matchInput: MatchOrderInput!) {
  matchOrder(filter: $filter, matchInput: $matchInput) {
    order {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      deadline
      type
      status
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        totalQuantity
        totalLoadingMillimeter
        totalWeightInKg
        deadline
      }
      loads {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        content
        loadingMillimeter
        weightInKg
        transportRequirements
        additionalInfo
        status
        statusChangedAt
        plannedFor
        pickUp {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        dropOff {
          location {
            id
            version
            createdAt
            updatedAt
            deletedAt
            tenantId
            externalReference
            owned
            company
            description
            loadingRequirements
            serviceTime
            address {
              street
              city
              zipCode
              country
              coordinates {
                latitude
                longitude
              }
            }
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            openingHours {
              openingHoursType
              timezone
              openingHoursPerWeekDay {
                weekday
                from
                to
              }
            }
          }
          timeWindow {
            start
            end
          }
          articles {
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            loadedQuantity
          }
        }
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
            }
          }
        }
      }
      customerOrderReference
      customerComment
      internalComment
    }
    loadIds
  }
}
    `;
export type MatchOrder_MutationMutationFn = Apollo.MutationFunction<Types.MatchOrder_Mutation, Types.MatchOrder_MutationVariables>;

/**
 * __useMatchOrder_Mutation__
 *
 * To run a mutation, you first call `useMatchOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchOrderMutation, { data, loading, error }] = useMatchOrder_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      matchInput: // value for 'matchInput'
 *   },
 * });
 */
export function useMatchOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MatchOrder_Mutation, Types.MatchOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MatchOrder_Mutation, Types.MatchOrder_MutationVariables>(MatchOrder_MutationDocument, options);
      }
export type MatchOrder_MutationHookResult = ReturnType<typeof useMatchOrder_Mutation>;
export type MatchOrder_MutationMutationResult = Apollo.MutationResult<Types.MatchOrder_Mutation>;
export type MatchOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MatchOrder_Mutation, Types.MatchOrder_MutationVariables>;
 const SeedLoads_MutationDocument = gql`
    mutation seedLoads_mutation {
  seedLoads {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type SeedLoads_MutationMutationFn = Apollo.MutationFunction<Types.SeedLoads_Mutation, Types.SeedLoads_MutationVariables>;

/**
 * __useSeedLoads_Mutation__
 *
 * To run a mutation, you first call `useSeedLoads_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedLoads_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedLoadsMutation, { data, loading, error }] = useSeedLoads_Mutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedLoads_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SeedLoads_Mutation, Types.SeedLoads_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeedLoads_Mutation, Types.SeedLoads_MutationVariables>(SeedLoads_MutationDocument, options);
      }
export type SeedLoads_MutationHookResult = ReturnType<typeof useSeedLoads_Mutation>;
export type SeedLoads_MutationMutationResult = Apollo.MutationResult<Types.SeedLoads_Mutation>;
export type SeedLoads_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SeedLoads_Mutation, Types.SeedLoads_MutationVariables>;
 const SeedLocations_MutationDocument = gql`
    mutation seedLocations_mutation {
  seedLocations {
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  }
}
    `;
export type SeedLocations_MutationMutationFn = Apollo.MutationFunction<Types.SeedLocations_Mutation, Types.SeedLocations_MutationVariables>;

/**
 * __useSeedLocations_Mutation__
 *
 * To run a mutation, you first call `useSeedLocations_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedLocations_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedLocationsMutation, { data, loading, error }] = useSeedLocations_Mutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedLocations_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SeedLocations_Mutation, Types.SeedLocations_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeedLocations_Mutation, Types.SeedLocations_MutationVariables>(SeedLocations_MutationDocument, options);
      }
export type SeedLocations_MutationHookResult = ReturnType<typeof useSeedLocations_Mutation>;
export type SeedLocations_MutationMutationResult = Apollo.MutationResult<Types.SeedLocations_Mutation>;
export type SeedLocations_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SeedLocations_Mutation, Types.SeedLocations_MutationVariables>;
 const UnmatchOrder_MutationDocument = gql`
    mutation unmatchOrder_mutation($filter: FilterOrderInput!) {
  unmatchOrder(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
export type UnmatchOrder_MutationMutationFn = Apollo.MutationFunction<Types.UnmatchOrder_Mutation, Types.UnmatchOrder_MutationVariables>;

/**
 * __useUnmatchOrder_Mutation__
 *
 * To run a mutation, you first call `useUnmatchOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmatchOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmatchOrderMutation, { data, loading, error }] = useUnmatchOrder_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUnmatchOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UnmatchOrder_Mutation, Types.UnmatchOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnmatchOrder_Mutation, Types.UnmatchOrder_MutationVariables>(UnmatchOrder_MutationDocument, options);
      }
export type UnmatchOrder_MutationHookResult = ReturnType<typeof useUnmatchOrder_Mutation>;
export type UnmatchOrder_MutationMutationResult = Apollo.MutationResult<Types.UnmatchOrder_Mutation>;
export type UnmatchOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UnmatchOrder_Mutation, Types.UnmatchOrder_MutationVariables>;
 const UpdateArticle_MutationDocument = gql`
    mutation updateArticle_mutation($filter: FilterArticleInput!, $articleInput: UpdateArticleInput!) {
  updateArticle(filter: $filter, articleInput: $articleInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    name
    weightInKgPerUnit
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
  }
}
    `;
export type UpdateArticle_MutationMutationFn = Apollo.MutationFunction<Types.UpdateArticle_Mutation, Types.UpdateArticle_MutationVariables>;

/**
 * __useUpdateArticle_Mutation__
 *
 * To run a mutation, you first call `useUpdateArticle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      articleInput: // value for 'articleInput'
 *   },
 * });
 */
export function useUpdateArticle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateArticle_Mutation, Types.UpdateArticle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateArticle_Mutation, Types.UpdateArticle_MutationVariables>(UpdateArticle_MutationDocument, options);
      }
export type UpdateArticle_MutationHookResult = ReturnType<typeof useUpdateArticle_Mutation>;
export type UpdateArticle_MutationMutationResult = Apollo.MutationResult<Types.UpdateArticle_Mutation>;
export type UpdateArticle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateArticle_Mutation, Types.UpdateArticle_MutationVariables>;
 const UpdateLoadV2_MutationDocument = gql`
    mutation updateLoadV2_mutation($filter: FilterLoadInput!, $loadInput: UpdateLoadInputV2!) {
  updateLoadV2(filter: $filter, loadInput: $loadInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    content
    loadingMillimeter
    weightInKg
    transportRequirements
    additionalInfo
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    dropOff {
      location {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        owned
        company
        description
        loadingRequirements
        serviceTime
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        loadedQuantity
      }
      order {
        id
        version
        createdAt
        updatedAt
        deletedAt
        tenantId
        externalReference
        deadline
        type
        status
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
          deadline
        }
        customerOrderReference
        customerComment
        internalComment
      }
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
  }
}
    `;
export type UpdateLoadV2_MutationMutationFn = Apollo.MutationFunction<Types.UpdateLoadV2_Mutation, Types.UpdateLoadV2_MutationVariables>;

/**
 * __useUpdateLoadV2_Mutation__
 *
 * To run a mutation, you first call `useUpdateLoadV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoadV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoadV2Mutation, { data, loading, error }] = useUpdateLoadV2_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      loadInput: // value for 'loadInput'
 *   },
 * });
 */
export function useUpdateLoadV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLoadV2_Mutation, Types.UpdateLoadV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLoadV2_Mutation, Types.UpdateLoadV2_MutationVariables>(UpdateLoadV2_MutationDocument, options);
      }
export type UpdateLoadV2_MutationHookResult = ReturnType<typeof useUpdateLoadV2_Mutation>;
export type UpdateLoadV2_MutationMutationResult = Apollo.MutationResult<Types.UpdateLoadV2_Mutation>;
export type UpdateLoadV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLoadV2_Mutation, Types.UpdateLoadV2_MutationVariables>;
 const UpdateLocationV2_MutationDocument = gql`
    mutation updateLocationV2_mutation($filter: FilterLocationInput!, $locationInput: UpdateLocationInputV2!) {
  updateLocationV2(filter: $filter, locationInput: $locationInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    owned
    company
    description
    loadingRequirements
    serviceTime
    address {
      street
      city
      zipCode
      country
      coordinates {
        latitude
        longitude
      }
    }
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    openingHours {
      openingHoursType
      timezone
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
    }
  }
}
    `;
export type UpdateLocationV2_MutationMutationFn = Apollo.MutationFunction<Types.UpdateLocationV2_Mutation, Types.UpdateLocationV2_MutationVariables>;

/**
 * __useUpdateLocationV2_Mutation__
 *
 * To run a mutation, you first call `useUpdateLocationV2_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationV2_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationV2Mutation, { data, loading, error }] = useUpdateLocationV2_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      locationInput: // value for 'locationInput'
 *   },
 * });
 */
export function useUpdateLocationV2_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLocationV2_Mutation, Types.UpdateLocationV2_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLocationV2_Mutation, Types.UpdateLocationV2_MutationVariables>(UpdateLocationV2_MutationDocument, options);
      }
export type UpdateLocationV2_MutationHookResult = ReturnType<typeof useUpdateLocationV2_Mutation>;
export type UpdateLocationV2_MutationMutationResult = Apollo.MutationResult<Types.UpdateLocationV2_Mutation>;
export type UpdateLocationV2_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLocationV2_Mutation, Types.UpdateLocationV2_MutationVariables>;
 const UpdateOrder_MutationDocument = gql`
    mutation updateOrder_mutation($filter: FilterOrderInput!, $orderInput: UpdateOrderInput!) {
  updateOrder(filter: $filter, orderInput: $orderInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    externalReference
    deadline
    type
    status
    location {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      owned
      company
      description
      loadingRequirements
      serviceTime
      address {
        street
        city
        zipCode
        country
        coordinates {
          latitude
          longitude
        }
      }
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      openingHours {
        openingHoursType
        timezone
        openingHoursPerWeekDay {
          weekday
          from
          to
        }
      }
    }
    articles {
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
      deadline
    }
    loads {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      externalReference
      content
      loadingMillimeter
      weightInKg
      transportRequirements
      additionalInfo
      status
      statusChangedAt
      plannedFor
      pickUp {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      dropOff {
        location {
          id
          version
          createdAt
          updatedAt
          deletedAt
          tenantId
          externalReference
          owned
          company
          description
          loadingRequirements
          serviceTime
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        articles {
          article {
            id
            packagingOptions {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                parent {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    liftingSide
                  }
                  quantityChildrenPerParent
                }
                liftingSide
              }
              maxStackSize
              articlesPerPackage
            }
            externalReference
            name
            weightInKgPerUnit
          }
          loadedQuantity
        }
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
    }
    customerOrderReference
    customerComment
    internalComment
  }
}
    `;
export type UpdateOrder_MutationMutationFn = Apollo.MutationFunction<Types.UpdateOrder_Mutation, Types.UpdateOrder_MutationVariables>;

/**
 * __useUpdateOrder_Mutation__
 *
 * To run a mutation, you first call `useUpdateOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrder_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderInput: // value for 'orderInput'
 *   },
 * });
 */
export function useUpdateOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrder_Mutation, Types.UpdateOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrder_Mutation, Types.UpdateOrder_MutationVariables>(UpdateOrder_MutationDocument, options);
      }
export type UpdateOrder_MutationHookResult = ReturnType<typeof useUpdateOrder_Mutation>;
export type UpdateOrder_MutationMutationResult = Apollo.MutationResult<Types.UpdateOrder_Mutation>;
export type UpdateOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrder_Mutation, Types.UpdateOrder_MutationVariables>;
 const CreateOrderPlanningVehicle_MutationDocument = gql`
    mutation createOrderPlanningVehicle_mutation($orderPlanningVehicleInput: CreateOrderPlanningVehicleInput!) {
  createOrderPlanningVehicle(
    orderPlanningVehicleInput: $orderPlanningVehicleInput
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
export type CreateOrderPlanningVehicle_MutationMutationFn = Apollo.MutationFunction<Types.CreateOrderPlanningVehicle_Mutation, Types.CreateOrderPlanningVehicle_MutationVariables>;

/**
 * __useCreateOrderPlanningVehicle_Mutation__
 *
 * To run a mutation, you first call `useCreateOrderPlanningVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderPlanningVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderPlanningVehicleMutation, { data, loading, error }] = useCreateOrderPlanningVehicle_Mutation({
 *   variables: {
 *      orderPlanningVehicleInput: // value for 'orderPlanningVehicleInput'
 *   },
 * });
 */
export function useCreateOrderPlanningVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrderPlanningVehicle_Mutation, Types.CreateOrderPlanningVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrderPlanningVehicle_Mutation, Types.CreateOrderPlanningVehicle_MutationVariables>(CreateOrderPlanningVehicle_MutationDocument, options);
      }
export type CreateOrderPlanningVehicle_MutationHookResult = ReturnType<typeof useCreateOrderPlanningVehicle_Mutation>;
export type CreateOrderPlanningVehicle_MutationMutationResult = Apollo.MutationResult<Types.CreateOrderPlanningVehicle_Mutation>;
export type CreateOrderPlanningVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderPlanningVehicle_Mutation, Types.CreateOrderPlanningVehicle_MutationVariables>;
 const DeleteOrderPlanningVehicle_MutationDocument = gql`
    mutation deleteOrderPlanningVehicle_mutation($filter: FilterOrderPlanningVehicleInput!) {
  deleteOrderPlanningVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
export type DeleteOrderPlanningVehicle_MutationMutationFn = Apollo.MutationFunction<Types.DeleteOrderPlanningVehicle_Mutation, Types.DeleteOrderPlanningVehicle_MutationVariables>;

/**
 * __useDeleteOrderPlanningVehicle_Mutation__
 *
 * To run a mutation, you first call `useDeleteOrderPlanningVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderPlanningVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderPlanningVehicleMutation, { data, loading, error }] = useDeleteOrderPlanningVehicle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteOrderPlanningVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrderPlanningVehicle_Mutation, Types.DeleteOrderPlanningVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrderPlanningVehicle_Mutation, Types.DeleteOrderPlanningVehicle_MutationVariables>(DeleteOrderPlanningVehicle_MutationDocument, options);
      }
export type DeleteOrderPlanningVehicle_MutationHookResult = ReturnType<typeof useDeleteOrderPlanningVehicle_Mutation>;
export type DeleteOrderPlanningVehicle_MutationMutationResult = Apollo.MutationResult<Types.DeleteOrderPlanningVehicle_Mutation>;
export type DeleteOrderPlanningVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderPlanningVehicle_Mutation, Types.DeleteOrderPlanningVehicle_MutationVariables>;
 const FindOrderPlanningVehicle_QueryDocument = gql`
    query findOrderPlanningVehicle_query($filter: FilterOrderPlanningVehicleInput!) {
  findOrderPlanningVehicle(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;

/**
 * __useFindOrderPlanningVehicle_Query__
 *
 * To run a query within a React component, call `useFindOrderPlanningVehicle_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderPlanningVehicle_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderPlanningVehicle_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindOrderPlanningVehicle_Query(baseOptions: Apollo.QueryHookOptions<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables> & ({ variables: Types.FindOrderPlanningVehicle_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables>(FindOrderPlanningVehicle_QueryDocument, options);
      }
export function useFindOrderPlanningVehicle_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables>(FindOrderPlanningVehicle_QueryDocument, options);
        }
export function useFindOrderPlanningVehicle_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables>(FindOrderPlanningVehicle_QueryDocument, options);
        }
export type FindOrderPlanningVehicle_QueryHookResult = ReturnType<typeof useFindOrderPlanningVehicle_Query>;
export type FindOrderPlanningVehicle_QueryLazyQueryHookResult = ReturnType<typeof useFindOrderPlanningVehicle_QueryLazyQuery>;
export type FindOrderPlanningVehicle_QuerySuspenseQueryHookResult = ReturnType<typeof useFindOrderPlanningVehicle_QuerySuspenseQuery>;
export type FindOrderPlanningVehicle_QueryQueryResult = Apollo.QueryResult<Types.FindOrderPlanningVehicle_Query, Types.FindOrderPlanningVehicle_QueryVariables>;
 const FindOrderPlanningVehicles_QueryDocument = gql`
    query findOrderPlanningVehicles_query($query: QueryOrderPlanningVehiclesInput!) {
  findOrderPlanningVehicles(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      tenantId
      name
      totalCapacity {
        loadingMillimeter
        weightInKg
      }
      loadIds
      pickUpLocationId
      tourStartTime
      calendarWeek
      status
      dropOffStops {
        locationId
        plannedArrivalTime
      }
      carrier {
        name
        cost
        comment
      }
      exportedAt
    }
  }
}
    `;

/**
 * __useFindOrderPlanningVehicles_Query__
 *
 * To run a query within a React component, call `useFindOrderPlanningVehicles_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderPlanningVehicles_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderPlanningVehicles_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindOrderPlanningVehicles_Query(baseOptions: Apollo.QueryHookOptions<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables> & ({ variables: Types.FindOrderPlanningVehicles_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables>(FindOrderPlanningVehicles_QueryDocument, options);
      }
export function useFindOrderPlanningVehicles_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables>(FindOrderPlanningVehicles_QueryDocument, options);
        }
export function useFindOrderPlanningVehicles_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables>(FindOrderPlanningVehicles_QueryDocument, options);
        }
export type FindOrderPlanningVehicles_QueryHookResult = ReturnType<typeof useFindOrderPlanningVehicles_Query>;
export type FindOrderPlanningVehicles_QueryLazyQueryHookResult = ReturnType<typeof useFindOrderPlanningVehicles_QueryLazyQuery>;
export type FindOrderPlanningVehicles_QuerySuspenseQueryHookResult = ReturnType<typeof useFindOrderPlanningVehicles_QuerySuspenseQuery>;
export type FindOrderPlanningVehicles_QueryQueryResult = Apollo.QueryResult<Types.FindOrderPlanningVehicles_Query, Types.FindOrderPlanningVehicles_QueryVariables>;
 const GetOrderPlanningLoadsInfo_QueryDocument = gql`
    query getOrderPlanningLoadsInfo_query($loadIds: [String!]!) {
  getOrderPlanningLoadsInfo(loadIds: $loadIds) {
    loadId
    loadStatus
    exportedAt
  }
}
    `;

/**
 * __useGetOrderPlanningLoadsInfo_Query__
 *
 * To run a query within a React component, call `useGetOrderPlanningLoadsInfo_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPlanningLoadsInfo_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPlanningLoadsInfo_Query({
 *   variables: {
 *      loadIds: // value for 'loadIds'
 *   },
 * });
 */
export function useGetOrderPlanningLoadsInfo_Query(baseOptions: Apollo.QueryHookOptions<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables> & ({ variables: Types.GetOrderPlanningLoadsInfo_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables>(GetOrderPlanningLoadsInfo_QueryDocument, options);
      }
export function useGetOrderPlanningLoadsInfo_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables>(GetOrderPlanningLoadsInfo_QueryDocument, options);
        }
export function useGetOrderPlanningLoadsInfo_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables>(GetOrderPlanningLoadsInfo_QueryDocument, options);
        }
export type GetOrderPlanningLoadsInfo_QueryHookResult = ReturnType<typeof useGetOrderPlanningLoadsInfo_Query>;
export type GetOrderPlanningLoadsInfo_QueryLazyQueryHookResult = ReturnType<typeof useGetOrderPlanningLoadsInfo_QueryLazyQuery>;
export type GetOrderPlanningLoadsInfo_QuerySuspenseQueryHookResult = ReturnType<typeof useGetOrderPlanningLoadsInfo_QuerySuspenseQuery>;
export type GetOrderPlanningLoadsInfo_QueryQueryResult = Apollo.QueryResult<Types.GetOrderPlanningLoadsInfo_Query, Types.GetOrderPlanningLoadsInfo_QueryVariables>;
 const UpdateOrderPlanningVehicle_MutationDocument = gql`
    mutation updateOrderPlanningVehicle_mutation($filter: FilterOrderPlanningVehicleInput!, $orderPlanningVehicleInput: UpdateOrderPlanningVehicleInput!) {
  updateOrderPlanningVehicle(
    filter: $filter
    orderPlanningVehicleInput: $orderPlanningVehicleInput
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    tenantId
    name
    totalCapacity {
      loadingMillimeter
      weightInKg
    }
    loadIds
    pickUpLocationId
    tourStartTime
    calendarWeek
    status
    dropOffStops {
      locationId
      plannedArrivalTime
    }
    carrier {
      name
      cost
      comment
    }
    exportedAt
  }
}
    `;
export type UpdateOrderPlanningVehicle_MutationMutationFn = Apollo.MutationFunction<Types.UpdateOrderPlanningVehicle_Mutation, Types.UpdateOrderPlanningVehicle_MutationVariables>;

/**
 * __useUpdateOrderPlanningVehicle_Mutation__
 *
 * To run a mutation, you first call `useUpdateOrderPlanningVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderPlanningVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderPlanningVehicleMutation, { data, loading, error }] = useUpdateOrderPlanningVehicle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderPlanningVehicleInput: // value for 'orderPlanningVehicleInput'
 *   },
 * });
 */
export function useUpdateOrderPlanningVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrderPlanningVehicle_Mutation, Types.UpdateOrderPlanningVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrderPlanningVehicle_Mutation, Types.UpdateOrderPlanningVehicle_MutationVariables>(UpdateOrderPlanningVehicle_MutationDocument, options);
      }
export type UpdateOrderPlanningVehicle_MutationHookResult = ReturnType<typeof useUpdateOrderPlanningVehicle_Mutation>;
export type UpdateOrderPlanningVehicle_MutationMutationResult = Apollo.MutationResult<Types.UpdateOrderPlanningVehicle_Mutation>;
export type UpdateOrderPlanningVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderPlanningVehicle_Mutation, Types.UpdateOrderPlanningVehicle_MutationVariables>;
 const BookCargoboardOrder_MutationDocument = gql`
    mutation bookCargoboardOrder_mutation($shipmentId: String!, $loadingType: LoadingUnloadingTypes) {
  bookCargoboardOrder(shipmentId: $shipmentId, loadingType: $loadingType) {
    id
    product
    truckType
    price {
      amount
      currency
    }
    priceStandard {
      amount
      currency
    }
    pickupOn
    pickupAtFrom
    pickupAtUntil
    runtime {
      daysMin
      daysMax
    }
    delivery {
      earliest
      latest
    }
    costItems {
      description
      type
      subtype
      price {
        amount
        currency
      }
    }
    co2Emission {
      amount
      value
      unit
    }
    reference
  }
}
    `;
export type BookCargoboardOrder_MutationMutationFn = Apollo.MutationFunction<Types.BookCargoboardOrder_Mutation, Types.BookCargoboardOrder_MutationVariables>;

/**
 * __useBookCargoboardOrder_Mutation__
 *
 * To run a mutation, you first call `useBookCargoboardOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookCargoboardOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookCargoboardOrderMutation, { data, loading, error }] = useBookCargoboardOrder_Mutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      loadingType: // value for 'loadingType'
 *   },
 * });
 */
export function useBookCargoboardOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.BookCargoboardOrder_Mutation, Types.BookCargoboardOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BookCargoboardOrder_Mutation, Types.BookCargoboardOrder_MutationVariables>(BookCargoboardOrder_MutationDocument, options);
      }
export type BookCargoboardOrder_MutationHookResult = ReturnType<typeof useBookCargoboardOrder_Mutation>;
export type BookCargoboardOrder_MutationMutationResult = Apollo.MutationResult<Types.BookCargoboardOrder_Mutation>;
export type BookCargoboardOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.BookCargoboardOrder_Mutation, Types.BookCargoboardOrder_MutationVariables>;
 const CancelCargoboardOrder_MutationDocument = gql`
    mutation cancelCargoboardOrder_mutation($shipmentId: String!, $cargoboardId: String!) {
  cancelCargoboardOrder(shipmentId: $shipmentId, cargoboardId: $cargoboardId)
}
    `;
export type CancelCargoboardOrder_MutationMutationFn = Apollo.MutationFunction<Types.CancelCargoboardOrder_Mutation, Types.CancelCargoboardOrder_MutationVariables>;

/**
 * __useCancelCargoboardOrder_Mutation__
 *
 * To run a mutation, you first call `useCancelCargoboardOrder_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCargoboardOrder_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCargoboardOrderMutation, { data, loading, error }] = useCancelCargoboardOrder_Mutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      cargoboardId: // value for 'cargoboardId'
 *   },
 * });
 */
export function useCancelCargoboardOrder_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CancelCargoboardOrder_Mutation, Types.CancelCargoboardOrder_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CancelCargoboardOrder_Mutation, Types.CancelCargoboardOrder_MutationVariables>(CancelCargoboardOrder_MutationDocument, options);
      }
export type CancelCargoboardOrder_MutationHookResult = ReturnType<typeof useCancelCargoboardOrder_Mutation>;
export type CancelCargoboardOrder_MutationMutationResult = Apollo.MutationResult<Types.CancelCargoboardOrder_Mutation>;
export type CancelCargoboardOrder_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CancelCargoboardOrder_Mutation, Types.CancelCargoboardOrder_MutationVariables>;
 const CountShipmentByStatus_QueryDocument = gql`
    query countShipmentByStatus_query($filter: ShipmentStatusCountFilterInput!) {
  countShipmentByStatus(filter: $filter) {
    status
    count
  }
}
    `;

/**
 * __useCountShipmentByStatus_Query__
 *
 * To run a query within a React component, call `useCountShipmentByStatus_Query` and pass it any options that fit your needs.
 * When your component renders, `useCountShipmentByStatus_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountShipmentByStatus_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountShipmentByStatus_Query(baseOptions: Apollo.QueryHookOptions<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables> & ({ variables: Types.CountShipmentByStatus_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables>(CountShipmentByStatus_QueryDocument, options);
      }
export function useCountShipmentByStatus_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables>(CountShipmentByStatus_QueryDocument, options);
        }
export function useCountShipmentByStatus_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables>(CountShipmentByStatus_QueryDocument, options);
        }
export type CountShipmentByStatus_QueryHookResult = ReturnType<typeof useCountShipmentByStatus_Query>;
export type CountShipmentByStatus_QueryLazyQueryHookResult = ReturnType<typeof useCountShipmentByStatus_QueryLazyQuery>;
export type CountShipmentByStatus_QuerySuspenseQueryHookResult = ReturnType<typeof useCountShipmentByStatus_QuerySuspenseQuery>;
export type CountShipmentByStatus_QueryQueryResult = Apollo.QueryResult<Types.CountShipmentByStatus_Query, Types.CountShipmentByStatus_QueryVariables>;
 const CreateShipment_MutationDocument = gql`
    mutation createShipment_mutation($shipmentInput: CreateShipmentInput!) {
  createShipment(shipmentInput: $shipmentInput) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type CreateShipment_MutationMutationFn = Apollo.MutationFunction<Types.CreateShipment_Mutation, Types.CreateShipment_MutationVariables>;

/**
 * __useCreateShipment_Mutation__
 *
 * To run a mutation, you first call `useCreateShipment_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipment_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipment_Mutation({
 *   variables: {
 *      shipmentInput: // value for 'shipmentInput'
 *   },
 * });
 */
export function useCreateShipment_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateShipment_Mutation, Types.CreateShipment_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateShipment_Mutation, Types.CreateShipment_MutationVariables>(CreateShipment_MutationDocument, options);
      }
export type CreateShipment_MutationHookResult = ReturnType<typeof useCreateShipment_Mutation>;
export type CreateShipment_MutationMutationResult = Apollo.MutationResult<Types.CreateShipment_Mutation>;
export type CreateShipment_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateShipment_Mutation, Types.CreateShipment_MutationVariables>;
 const DeleteShipment_MutationDocument = gql`
    mutation deleteShipment_mutation($filter: FilterShipmentInput!) {
  deleteShipment(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type DeleteShipment_MutationMutationFn = Apollo.MutationFunction<Types.DeleteShipment_Mutation, Types.DeleteShipment_MutationVariables>;

/**
 * __useDeleteShipment_Mutation__
 *
 * To run a mutation, you first call `useDeleteShipment_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipment_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentMutation, { data, loading, error }] = useDeleteShipment_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteShipment_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteShipment_Mutation, Types.DeleteShipment_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteShipment_Mutation, Types.DeleteShipment_MutationVariables>(DeleteShipment_MutationDocument, options);
      }
export type DeleteShipment_MutationHookResult = ReturnType<typeof useDeleteShipment_Mutation>;
export type DeleteShipment_MutationMutationResult = Apollo.MutationResult<Types.DeleteShipment_Mutation>;
export type DeleteShipment_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteShipment_Mutation, Types.DeleteShipment_MutationVariables>;
 const FindCargoboardQuotation_QueryDocument = gql`
    query findCargoboardQuotation_query($filter: FilterShipmentInput!) {
  findCargoboardQuotation(filter: $filter) {
    loadingType
    quotationId
    costItems {
      description
      type
      amount
    }
    amount
    currency
  }
}
    `;

/**
 * __useFindCargoboardQuotation_Query__
 *
 * To run a query within a React component, call `useFindCargoboardQuotation_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindCargoboardQuotation_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCargoboardQuotation_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindCargoboardQuotation_Query(baseOptions: Apollo.QueryHookOptions<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables> & ({ variables: Types.FindCargoboardQuotation_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables>(FindCargoboardQuotation_QueryDocument, options);
      }
export function useFindCargoboardQuotation_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables>(FindCargoboardQuotation_QueryDocument, options);
        }
export function useFindCargoboardQuotation_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables>(FindCargoboardQuotation_QueryDocument, options);
        }
export type FindCargoboardQuotation_QueryHookResult = ReturnType<typeof useFindCargoboardQuotation_Query>;
export type FindCargoboardQuotation_QueryLazyQueryHookResult = ReturnType<typeof useFindCargoboardQuotation_QueryLazyQuery>;
export type FindCargoboardQuotation_QuerySuspenseQueryHookResult = ReturnType<typeof useFindCargoboardQuotation_QuerySuspenseQuery>;
export type FindCargoboardQuotation_QueryQueryResult = Apollo.QueryResult<Types.FindCargoboardQuotation_Query, Types.FindCargoboardQuotation_QueryVariables>;
 const FindCustomerShipmentTracking_QueryDocument = gql`
    query findCustomerShipmentTracking_query($filter: FilterShipmentStopInput!) {
  findCustomerShipmentTracking(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;

/**
 * __useFindCustomerShipmentTracking_Query__
 *
 * To run a query within a React component, call `useFindCustomerShipmentTracking_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindCustomerShipmentTracking_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCustomerShipmentTracking_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindCustomerShipmentTracking_Query(baseOptions: Apollo.QueryHookOptions<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables> & ({ variables: Types.FindCustomerShipmentTracking_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables>(FindCustomerShipmentTracking_QueryDocument, options);
      }
export function useFindCustomerShipmentTracking_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables>(FindCustomerShipmentTracking_QueryDocument, options);
        }
export function useFindCustomerShipmentTracking_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables>(FindCustomerShipmentTracking_QueryDocument, options);
        }
export type FindCustomerShipmentTracking_QueryHookResult = ReturnType<typeof useFindCustomerShipmentTracking_Query>;
export type FindCustomerShipmentTracking_QueryLazyQueryHookResult = ReturnType<typeof useFindCustomerShipmentTracking_QueryLazyQuery>;
export type FindCustomerShipmentTracking_QuerySuspenseQueryHookResult = ReturnType<typeof useFindCustomerShipmentTracking_QuerySuspenseQuery>;
export type FindCustomerShipmentTracking_QueryQueryResult = Apollo.QueryResult<Types.FindCustomerShipmentTracking_Query, Types.FindCustomerShipmentTracking_QueryVariables>;
 const FindShipment_QueryDocument = gql`
    query findShipment_query($filter: FilterShipmentInput!) {
  findShipment(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;

/**
 * __useFindShipment_Query__
 *
 * To run a query within a React component, call `useFindShipment_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindShipment_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindShipment_Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindShipment_Query(baseOptions: Apollo.QueryHookOptions<Types.FindShipment_Query, Types.FindShipment_QueryVariables> & ({ variables: Types.FindShipment_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindShipment_Query, Types.FindShipment_QueryVariables>(FindShipment_QueryDocument, options);
      }
export function useFindShipment_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindShipment_Query, Types.FindShipment_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindShipment_Query, Types.FindShipment_QueryVariables>(FindShipment_QueryDocument, options);
        }
export function useFindShipment_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindShipment_Query, Types.FindShipment_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindShipment_Query, Types.FindShipment_QueryVariables>(FindShipment_QueryDocument, options);
        }
export type FindShipment_QueryHookResult = ReturnType<typeof useFindShipment_Query>;
export type FindShipment_QueryLazyQueryHookResult = ReturnType<typeof useFindShipment_QueryLazyQuery>;
export type FindShipment_QuerySuspenseQueryHookResult = ReturnType<typeof useFindShipment_QuerySuspenseQuery>;
export type FindShipment_QueryQueryResult = Apollo.QueryResult<Types.FindShipment_Query, Types.FindShipment_QueryVariables>;
 const FindShipmentOrderRequest_QueryDocument = gql`
    query findShipmentOrderRequest_query($data: String!) {
  findShipmentOrderRequest(data: $data) {
    shipment {
      id
      version
      createdAt
      updatedAt
      deletedAt
      assignment {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      requests {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      driver {
        name
        phone
        email
      }
      tenantId
      flagged
      status
      stops {
        id
        location {
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          loadingRequirements
          serviceTime
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        pickUp {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        dropOff {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        estimatedTimes {
          estimatedArrivalTime
          estimatedDepartureTime
          comment
        }
        status
        completion {
          actualDepartureTime
          inFull
          comment
        }
        actualArrivalTime
        plannedTimes {
          plannedArrivalTime
          plannedDepartureTime
        }
        proofOfDeliveryUrl
      }
      transportRequirements {
        requiredPalletCapacity
        requiredWeightCapacity
        requiredLdmCapacity
        loadingRequirements
      }
      incidents {
        id
        userId
        tenantId
        timestamp
        comment
        stopId
      }
      referenceId
      distance
      vehicle {
        referenceId
        vehicleType
        vehicleLicense
        trailerLicense
        dimension {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        name
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      enRoute {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      anonymousLink
      transportAllocationId
      cargoboardId
      transportOrderdocuments
      applicationDeadline
    }
    shipper {
      id
      name
      address {
        street
        houseNumber
        city
        zipCode
        country
      }
      contact {
        name
        mobile
        phone
        email
      }
      language
      taxId
    }
    expiresAt
    logoUri
    carrierReferenceId
  }
}
    `;

/**
 * __useFindShipmentOrderRequest_Query__
 *
 * To run a query within a React component, call `useFindShipmentOrderRequest_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindShipmentOrderRequest_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindShipmentOrderRequest_Query({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFindShipmentOrderRequest_Query(baseOptions: Apollo.QueryHookOptions<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables> & ({ variables: Types.FindShipmentOrderRequest_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables>(FindShipmentOrderRequest_QueryDocument, options);
      }
export function useFindShipmentOrderRequest_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables>(FindShipmentOrderRequest_QueryDocument, options);
        }
export function useFindShipmentOrderRequest_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables>(FindShipmentOrderRequest_QueryDocument, options);
        }
export type FindShipmentOrderRequest_QueryHookResult = ReturnType<typeof useFindShipmentOrderRequest_Query>;
export type FindShipmentOrderRequest_QueryLazyQueryHookResult = ReturnType<typeof useFindShipmentOrderRequest_QueryLazyQuery>;
export type FindShipmentOrderRequest_QuerySuspenseQueryHookResult = ReturnType<typeof useFindShipmentOrderRequest_QuerySuspenseQuery>;
export type FindShipmentOrderRequest_QueryQueryResult = Apollo.QueryResult<Types.FindShipmentOrderRequest_Query, Types.FindShipmentOrderRequest_QueryVariables>;
 const FindShipments_QueryDocument = gql`
    query findShipments_query($query: QueryShipmentsInput!) {
  findShipments(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      version
      createdAt
      updatedAt
      deletedAt
      assignment {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      requests {
        carrier {
          name
          address {
            street
            houseNumber
            city
            zipCode
            country
          }
          contact {
            name
            mobile
            phone
            email
          }
        }
        dispatcher {
          contact {
            name
            mobile
            phone
            email
          }
        }
        referenceId
        rate {
          perKm {
            minDistance
            costPerKm
          }
          unloadingCharges {
            costPerAdditionalStop
            isAppliedAtDepot
          }
          laneBased {
            id
            pickUp {
              country
              zipCode
            }
            dropOff {
              country
              zipCode
            }
            cost
            costWeight {
              valueFromLimit
              valueToLimit
              costMin
              costMax
              cost
            }
          }
          equipmentCharges {
            equipment
            rateType
            costPerEquipment
          }
          calculatedTotalCost
          agreedTotalCost
        }
        costAdjustment {
          type
          amount
        }
        assignedAt
        preferredLanguage
        status
      }
      driver {
        name
        phone
        email
      }
      tenantId
      flagged
      status
      stops {
        id
        location {
          address {
            street
            city
            zipCode
            country
            coordinates {
              latitude
              longitude
            }
          }
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          loadingRequirements
          serviceTime
          openingHours {
            openingHoursType
            timezone
            openingHoursPerWeekDay {
              weekday
              from
              to
            }
          }
        }
        timeWindow {
          start
          end
        }
        pickUp {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        dropOff {
          referenceId
          customerReference
          content
          article
          pallets
          weight
          ldmm
        }
        estimatedTimes {
          estimatedArrivalTime
          estimatedDepartureTime
          comment
        }
        status
        completion {
          actualDepartureTime
          inFull
          comment
        }
        actualArrivalTime
        plannedTimes {
          plannedArrivalTime
          plannedDepartureTime
        }
        proofOfDeliveryUrl
      }
      transportRequirements {
        requiredPalletCapacity
        requiredWeightCapacity
        requiredLdmCapacity
        loadingRequirements
      }
      incidents {
        id
        userId
        tenantId
        timestamp
        comment
        stopId
      }
      referenceId
      distance
      vehicle {
        referenceId
        vehicleType
        vehicleLicense
        trailerLicense
        dimension {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        name
      }
      route {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      enRoute {
        sections {
          polyline
          summary {
            duration
            length
            consumption
            co2Emission
          }
          aggregateTolls {
            countryCode
            tollSystem
            currency
          }
        }
      }
      anonymousLink
      transportAllocationId
      cargoboardId
      transportOrderdocuments
      applicationDeadline
    }
  }
}
    `;

/**
 * __useFindShipments_Query__
 *
 * To run a query within a React component, call `useFindShipments_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindShipments_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindShipments_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindShipments_Query(baseOptions: Apollo.QueryHookOptions<Types.FindShipments_Query, Types.FindShipments_QueryVariables> & ({ variables: Types.FindShipments_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindShipments_Query, Types.FindShipments_QueryVariables>(FindShipments_QueryDocument, options);
      }
export function useFindShipments_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindShipments_Query, Types.FindShipments_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindShipments_Query, Types.FindShipments_QueryVariables>(FindShipments_QueryDocument, options);
        }
export function useFindShipments_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindShipments_Query, Types.FindShipments_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindShipments_Query, Types.FindShipments_QueryVariables>(FindShipments_QueryDocument, options);
        }
export type FindShipments_QueryHookResult = ReturnType<typeof useFindShipments_Query>;
export type FindShipments_QueryLazyQueryHookResult = ReturnType<typeof useFindShipments_QueryLazyQuery>;
export type FindShipments_QuerySuspenseQueryHookResult = ReturnType<typeof useFindShipments_QuerySuspenseQuery>;
export type FindShipments_QueryQueryResult = Apollo.QueryResult<Types.FindShipments_Query, Types.FindShipments_QueryVariables>;
 const LoginWithApi_MutationDocument = gql`
    mutation loginWithApi_mutation($apiKey: String!) {
  loginWithApi(apiKey: $apiKey)
}
    `;
export type LoginWithApi_MutationMutationFn = Apollo.MutationFunction<Types.LoginWithApi_Mutation, Types.LoginWithApi_MutationVariables>;

/**
 * __useLoginWithApi_Mutation__
 *
 * To run a mutation, you first call `useLoginWithApi_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithApi_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithApiMutation, { data, loading, error }] = useLoginWithApi_Mutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useLoginWithApi_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.LoginWithApi_Mutation, Types.LoginWithApi_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LoginWithApi_Mutation, Types.LoginWithApi_MutationVariables>(LoginWithApi_MutationDocument, options);
      }
export type LoginWithApi_MutationHookResult = ReturnType<typeof useLoginWithApi_Mutation>;
export type LoginWithApi_MutationMutationResult = Apollo.MutationResult<Types.LoginWithApi_Mutation>;
export type LoginWithApi_MutationMutationOptions = Apollo.BaseMutationOptions<Types.LoginWithApi_Mutation, Types.LoginWithApi_MutationVariables>;
 const RegisterCargoboardCompany_MutationDocument = gql`
    mutation registerCargoboardCompany_mutation($registerInput: CargoboardRegisterInput!) {
  registerCargoboardCompany(registerInput: $registerInput) {
    companyName
    apiKey
  }
}
    `;
export type RegisterCargoboardCompany_MutationMutationFn = Apollo.MutationFunction<Types.RegisterCargoboardCompany_Mutation, Types.RegisterCargoboardCompany_MutationVariables>;

/**
 * __useRegisterCargoboardCompany_Mutation__
 *
 * To run a mutation, you first call `useRegisterCargoboardCompany_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCargoboardCompany_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCargoboardCompanyMutation, { data, loading, error }] = useRegisterCargoboardCompany_Mutation({
 *   variables: {
 *      registerInput: // value for 'registerInput'
 *   },
 * });
 */
export function useRegisterCargoboardCompany_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.RegisterCargoboardCompany_Mutation, Types.RegisterCargoboardCompany_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RegisterCargoboardCompany_Mutation, Types.RegisterCargoboardCompany_MutationVariables>(RegisterCargoboardCompany_MutationDocument, options);
      }
export type RegisterCargoboardCompany_MutationHookResult = ReturnType<typeof useRegisterCargoboardCompany_Mutation>;
export type RegisterCargoboardCompany_MutationMutationResult = Apollo.MutationResult<Types.RegisterCargoboardCompany_Mutation>;
export type RegisterCargoboardCompany_MutationMutationOptions = Apollo.BaseMutationOptions<Types.RegisterCargoboardCompany_Mutation, Types.RegisterCargoboardCompany_MutationVariables>;
 const ReportIncident_MutationDocument = gql`
    mutation reportIncident_mutation($filter: FilterShipmentOptionalStopInput!, $incident: ShipmentIncidentInput!) {
  reportIncident(filter: $filter, incident: $incident) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type ReportIncident_MutationMutationFn = Apollo.MutationFunction<Types.ReportIncident_Mutation, Types.ReportIncident_MutationVariables>;

/**
 * __useReportIncident_Mutation__
 *
 * To run a mutation, you first call `useReportIncident_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportIncident_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportIncidentMutation, { data, loading, error }] = useReportIncident_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      incident: // value for 'incident'
 *   },
 * });
 */
export function useReportIncident_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportIncident_Mutation, Types.ReportIncident_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportIncident_Mutation, Types.ReportIncident_MutationVariables>(ReportIncident_MutationDocument, options);
      }
export type ReportIncident_MutationHookResult = ReturnType<typeof useReportIncident_Mutation>;
export type ReportIncident_MutationMutationResult = Apollo.MutationResult<Types.ReportIncident_Mutation>;
export type ReportIncident_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ReportIncident_Mutation, Types.ReportIncident_MutationVariables>;
 const SetRequestAccepted_MutationDocument = gql`
    mutation setRequestAccepted_mutation($decyptedInput: String!, $filter: FilterShipmentInput!, $assignment: ShipmentAssignmentInput!, $isAccept: Boolean!) {
  setRequestAccepted(
    decyptedInput: $decyptedInput
    filter: $filter
    assignment: $assignment
    isAccept: $isAccept
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetRequestAccepted_MutationMutationFn = Apollo.MutationFunction<Types.SetRequestAccepted_Mutation, Types.SetRequestAccepted_MutationVariables>;

/**
 * __useSetRequestAccepted_Mutation__
 *
 * To run a mutation, you first call `useSetRequestAccepted_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRequestAccepted_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRequestAcceptedMutation, { data, loading, error }] = useSetRequestAccepted_Mutation({
 *   variables: {
 *      decyptedInput: // value for 'decyptedInput'
 *      filter: // value for 'filter'
 *      assignment: // value for 'assignment'
 *      isAccept: // value for 'isAccept'
 *   },
 * });
 */
export function useSetRequestAccepted_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetRequestAccepted_Mutation, Types.SetRequestAccepted_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetRequestAccepted_Mutation, Types.SetRequestAccepted_MutationVariables>(SetRequestAccepted_MutationDocument, options);
      }
export type SetRequestAccepted_MutationHookResult = ReturnType<typeof useSetRequestAccepted_Mutation>;
export type SetRequestAccepted_MutationMutationResult = Apollo.MutationResult<Types.SetRequestAccepted_Mutation>;
export type SetRequestAccepted_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetRequestAccepted_Mutation, Types.SetRequestAccepted_MutationVariables>;
 const SetShipmentStatusAllocatedDirectly_MutationDocument = gql`
    mutation setShipmentStatusAllocatedDirectly_mutation($filter: FilterShipmentInput!, $assignment: ShipmentAssignmentInput!, $shipper: ShipperInput!) {
  setShipmentStatusAllocatedDirectly(
    filter: $filter
    assignment: $assignment
    shipper: $shipper
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusAllocatedDirectly_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusAllocatedDirectly_Mutation, Types.SetShipmentStatusAllocatedDirectly_MutationVariables>;

/**
 * __useSetShipmentStatusAllocatedDirectly_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusAllocatedDirectly_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusAllocatedDirectly_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusAllocatedDirectlyMutation, { data, loading, error }] = useSetShipmentStatusAllocatedDirectly_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      assignment: // value for 'assignment'
 *      shipper: // value for 'shipper'
 *   },
 * });
 */
export function useSetShipmentStatusAllocatedDirectly_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusAllocatedDirectly_Mutation, Types.SetShipmentStatusAllocatedDirectly_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusAllocatedDirectly_Mutation, Types.SetShipmentStatusAllocatedDirectly_MutationVariables>(SetShipmentStatusAllocatedDirectly_MutationDocument, options);
      }
export type SetShipmentStatusAllocatedDirectly_MutationHookResult = ReturnType<typeof useSetShipmentStatusAllocatedDirectly_Mutation>;
export type SetShipmentStatusAllocatedDirectly_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusAllocatedDirectly_Mutation>;
export type SetShipmentStatusAllocatedDirectly_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusAllocatedDirectly_Mutation, Types.SetShipmentStatusAllocatedDirectly_MutationVariables>;
 const SetShipmentStatusCancelled_MutationDocument = gql`
    mutation setShipmentStatusCancelled_mutation($filter: FilterShipmentInput!, $comment: String) {
  setShipmentStatusCancelled(filter: $filter, comment: $comment) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusCancelled_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusCancelled_Mutation, Types.SetShipmentStatusCancelled_MutationVariables>;

/**
 * __useSetShipmentStatusCancelled_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusCancelled_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusCancelled_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusCancelledMutation, { data, loading, error }] = useSetShipmentStatusCancelled_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetShipmentStatusCancelled_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusCancelled_Mutation, Types.SetShipmentStatusCancelled_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusCancelled_Mutation, Types.SetShipmentStatusCancelled_MutationVariables>(SetShipmentStatusCancelled_MutationDocument, options);
      }
export type SetShipmentStatusCancelled_MutationHookResult = ReturnType<typeof useSetShipmentStatusCancelled_Mutation>;
export type SetShipmentStatusCancelled_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusCancelled_Mutation>;
export type SetShipmentStatusCancelled_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusCancelled_Mutation, Types.SetShipmentStatusCancelled_MutationVariables>;
 const SetShipmentStatusCompleted_MutationDocument = gql`
    mutation setShipmentStatusCompleted_mutation($filter: FilterShipmentInput!) {
  setShipmentStatusCompleted(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusCompleted_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusCompleted_Mutation, Types.SetShipmentStatusCompleted_MutationVariables>;

/**
 * __useSetShipmentStatusCompleted_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusCompleted_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusCompleted_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusCompletedMutation, { data, loading, error }] = useSetShipmentStatusCompleted_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetShipmentStatusCompleted_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusCompleted_Mutation, Types.SetShipmentStatusCompleted_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusCompleted_Mutation, Types.SetShipmentStatusCompleted_MutationVariables>(SetShipmentStatusCompleted_MutationDocument, options);
      }
export type SetShipmentStatusCompleted_MutationHookResult = ReturnType<typeof useSetShipmentStatusCompleted_Mutation>;
export type SetShipmentStatusCompleted_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusCompleted_Mutation>;
export type SetShipmentStatusCompleted_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusCompleted_Mutation, Types.SetShipmentStatusCompleted_MutationVariables>;
 const SetShipmentStatusCreated_MutationDocument = gql`
    mutation setShipmentStatusCreated_mutation($filter: FilterShipmentInput!) {
  setShipmentStatusCreated(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusCreated_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusCreated_Mutation, Types.SetShipmentStatusCreated_MutationVariables>;

/**
 * __useSetShipmentStatusCreated_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusCreated_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusCreated_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusCreatedMutation, { data, loading, error }] = useSetShipmentStatusCreated_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetShipmentStatusCreated_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusCreated_Mutation, Types.SetShipmentStatusCreated_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusCreated_Mutation, Types.SetShipmentStatusCreated_MutationVariables>(SetShipmentStatusCreated_MutationDocument, options);
      }
export type SetShipmentStatusCreated_MutationHookResult = ReturnType<typeof useSetShipmentStatusCreated_Mutation>;
export type SetShipmentStatusCreated_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusCreated_Mutation>;
export type SetShipmentStatusCreated_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusCreated_Mutation, Types.SetShipmentStatusCreated_MutationVariables>;
 const SetShipmentStatusInTransit_MutationDocument = gql`
    mutation setShipmentStatusInTransit_mutation($filter: FilterShipmentInput!) {
  setShipmentStatusInTransit(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusInTransit_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusInTransit_Mutation, Types.SetShipmentStatusInTransit_MutationVariables>;

/**
 * __useSetShipmentStatusInTransit_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusInTransit_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusInTransit_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusInTransitMutation, { data, loading, error }] = useSetShipmentStatusInTransit_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetShipmentStatusInTransit_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusInTransit_Mutation, Types.SetShipmentStatusInTransit_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusInTransit_Mutation, Types.SetShipmentStatusInTransit_MutationVariables>(SetShipmentStatusInTransit_MutationDocument, options);
      }
export type SetShipmentStatusInTransit_MutationHookResult = ReturnType<typeof useSetShipmentStatusInTransit_Mutation>;
export type SetShipmentStatusInTransit_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusInTransit_Mutation>;
export type SetShipmentStatusInTransit_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusInTransit_Mutation, Types.SetShipmentStatusInTransit_MutationVariables>;
 const SetShipmentStatusRequestRevoked_MutationDocument = gql`
    mutation setShipmentStatusRequestRevoked_mutation($filter: FilterShipmentInput!, $assignmentId: String!, $shipper: ShipperInput!) {
  setShipmentStatusRequestRevoked(
    filter: $filter
    assignmentId: $assignmentId
    shipper: $shipper
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusRequestRevoked_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusRequestRevoked_Mutation, Types.SetShipmentStatusRequestRevoked_MutationVariables>;

/**
 * __useSetShipmentStatusRequestRevoked_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusRequestRevoked_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusRequestRevoked_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusRequestRevokedMutation, { data, loading, error }] = useSetShipmentStatusRequestRevoked_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      assignmentId: // value for 'assignmentId'
 *      shipper: // value for 'shipper'
 *   },
 * });
 */
export function useSetShipmentStatusRequestRevoked_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusRequestRevoked_Mutation, Types.SetShipmentStatusRequestRevoked_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusRequestRevoked_Mutation, Types.SetShipmentStatusRequestRevoked_MutationVariables>(SetShipmentStatusRequestRevoked_MutationDocument, options);
      }
export type SetShipmentStatusRequestRevoked_MutationHookResult = ReturnType<typeof useSetShipmentStatusRequestRevoked_Mutation>;
export type SetShipmentStatusRequestRevoked_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusRequestRevoked_Mutation>;
export type SetShipmentStatusRequestRevoked_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusRequestRevoked_Mutation, Types.SetShipmentStatusRequestRevoked_MutationVariables>;
 const SetShipmentStatusRequested_MutationDocument = gql`
    mutation setShipmentStatusRequested_mutation($filter: FilterShipmentInput!, $assignments: [ShipmentAssignmentInput!]!, $shipper: ShipperInput!, $applicationDeadline: DateTime!) {
  setShipmentStatusRequested(
    filter: $filter
    assignments: $assignments
    shipper: $shipper
    applicationDeadline: $applicationDeadline
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStatusRequested_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStatusRequested_Mutation, Types.SetShipmentStatusRequested_MutationVariables>;

/**
 * __useSetShipmentStatusRequested_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStatusRequested_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStatusRequested_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStatusRequestedMutation, { data, loading, error }] = useSetShipmentStatusRequested_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      assignments: // value for 'assignments'
 *      shipper: // value for 'shipper'
 *      applicationDeadline: // value for 'applicationDeadline'
 *   },
 * });
 */
export function useSetShipmentStatusRequested_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStatusRequested_Mutation, Types.SetShipmentStatusRequested_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStatusRequested_Mutation, Types.SetShipmentStatusRequested_MutationVariables>(SetShipmentStatusRequested_MutationDocument, options);
      }
export type SetShipmentStatusRequested_MutationHookResult = ReturnType<typeof useSetShipmentStatusRequested_Mutation>;
export type SetShipmentStatusRequested_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStatusRequested_Mutation>;
export type SetShipmentStatusRequested_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStatusRequested_Mutation, Types.SetShipmentStatusRequested_MutationVariables>;
 const SetShipmentStopStatusCancelled_MutationDocument = gql`
    mutation setShipmentStopStatusCancelled_mutation($filter: FilterShipmentStopInput!, $comment: String) {
  setShipmentStopStatusCancelled(filter: $filter, comment: $comment) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStopStatusCancelled_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStopStatusCancelled_Mutation, Types.SetShipmentStopStatusCancelled_MutationVariables>;

/**
 * __useSetShipmentStopStatusCancelled_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStopStatusCancelled_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStopStatusCancelled_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStopStatusCancelledMutation, { data, loading, error }] = useSetShipmentStopStatusCancelled_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetShipmentStopStatusCancelled_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStopStatusCancelled_Mutation, Types.SetShipmentStopStatusCancelled_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStopStatusCancelled_Mutation, Types.SetShipmentStopStatusCancelled_MutationVariables>(SetShipmentStopStatusCancelled_MutationDocument, options);
      }
export type SetShipmentStopStatusCancelled_MutationHookResult = ReturnType<typeof useSetShipmentStopStatusCancelled_Mutation>;
export type SetShipmentStopStatusCancelled_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStopStatusCancelled_Mutation>;
export type SetShipmentStopStatusCancelled_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStopStatusCancelled_Mutation, Types.SetShipmentStopStatusCancelled_MutationVariables>;
 const SetShipmentStopStatusCompleted_MutationDocument = gql`
    mutation setShipmentStopStatusCompleted_mutation($filter: FilterShipmentStopInput!, $completion: ShipmentStopCompletionInput!) {
  setShipmentStopStatusCompleted(filter: $filter, completion: $completion) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type SetShipmentStopStatusCompleted_MutationMutationFn = Apollo.MutationFunction<Types.SetShipmentStopStatusCompleted_Mutation, Types.SetShipmentStopStatusCompleted_MutationVariables>;

/**
 * __useSetShipmentStopStatusCompleted_Mutation__
 *
 * To run a mutation, you first call `useSetShipmentStopStatusCompleted_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentStopStatusCompleted_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentStopStatusCompletedMutation, { data, loading, error }] = useSetShipmentStopStatusCompleted_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      completion: // value for 'completion'
 *   },
 * });
 */
export function useSetShipmentStopStatusCompleted_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SetShipmentStopStatusCompleted_Mutation, Types.SetShipmentStopStatusCompleted_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetShipmentStopStatusCompleted_Mutation, Types.SetShipmentStopStatusCompleted_MutationVariables>(SetShipmentStopStatusCompleted_MutationDocument, options);
      }
export type SetShipmentStopStatusCompleted_MutationHookResult = ReturnType<typeof useSetShipmentStopStatusCompleted_Mutation>;
export type SetShipmentStopStatusCompleted_MutationMutationResult = Apollo.MutationResult<Types.SetShipmentStopStatusCompleted_Mutation>;
export type SetShipmentStopStatusCompleted_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SetShipmentStopStatusCompleted_Mutation, Types.SetShipmentStopStatusCompleted_MutationVariables>;
 const SignedBucketUrl_QueryDocument = gql`
    query signedBucketUrl_query($url: String!) {
  signedBucketUrl(url: $url)
}
    `;

/**
 * __useSignedBucketUrl_Query__
 *
 * To run a query within a React component, call `useSignedBucketUrl_Query` and pass it any options that fit your needs.
 * When your component renders, `useSignedBucketUrl_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignedBucketUrl_Query({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSignedBucketUrl_Query(baseOptions: Apollo.QueryHookOptions<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables> & ({ variables: Types.SignedBucketUrl_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables>(SignedBucketUrl_QueryDocument, options);
      }
export function useSignedBucketUrl_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables>(SignedBucketUrl_QueryDocument, options);
        }
export function useSignedBucketUrl_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables>(SignedBucketUrl_QueryDocument, options);
        }
export type SignedBucketUrl_QueryHookResult = ReturnType<typeof useSignedBucketUrl_Query>;
export type SignedBucketUrl_QueryLazyQueryHookResult = ReturnType<typeof useSignedBucketUrl_QueryLazyQuery>;
export type SignedBucketUrl_QuerySuspenseQueryHookResult = ReturnType<typeof useSignedBucketUrl_QuerySuspenseQuery>;
export type SignedBucketUrl_QueryQueryResult = Apollo.QueryResult<Types.SignedBucketUrl_Query, Types.SignedBucketUrl_QueryVariables>;
 const UnassignCarrier_MutationDocument = gql`
    mutation unassignCarrier_mutation($filter: FilterShipmentInput!) {
  unassignCarrier(filter: $filter) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type UnassignCarrier_MutationMutationFn = Apollo.MutationFunction<Types.UnassignCarrier_Mutation, Types.UnassignCarrier_MutationVariables>;

/**
 * __useUnassignCarrier_Mutation__
 *
 * To run a mutation, you first call `useUnassignCarrier_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignCarrier_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignCarrierMutation, { data, loading, error }] = useUnassignCarrier_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUnassignCarrier_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UnassignCarrier_Mutation, Types.UnassignCarrier_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnassignCarrier_Mutation, Types.UnassignCarrier_MutationVariables>(UnassignCarrier_MutationDocument, options);
      }
export type UnassignCarrier_MutationHookResult = ReturnType<typeof useUnassignCarrier_Mutation>;
export type UnassignCarrier_MutationMutationResult = Apollo.MutationResult<Types.UnassignCarrier_Mutation>;
export type UnassignCarrier_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UnassignCarrier_Mutation, Types.UnassignCarrier_MutationVariables>;
 const UpdateReferenceId_MutationDocument = gql`
    mutation updateReferenceId_mutation($filter: FilterShipmentInput!, $referenceId: String!) {
  updateReferenceId(filter: $filter, referenceId: $referenceId) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type UpdateReferenceId_MutationMutationFn = Apollo.MutationFunction<Types.UpdateReferenceId_Mutation, Types.UpdateReferenceId_MutationVariables>;

/**
 * __useUpdateReferenceId_Mutation__
 *
 * To run a mutation, you first call `useUpdateReferenceId_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceId_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceIdMutation, { data, loading, error }] = useUpdateReferenceId_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useUpdateReferenceId_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateReferenceId_Mutation, Types.UpdateReferenceId_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateReferenceId_Mutation, Types.UpdateReferenceId_MutationVariables>(UpdateReferenceId_MutationDocument, options);
      }
export type UpdateReferenceId_MutationHookResult = ReturnType<typeof useUpdateReferenceId_Mutation>;
export type UpdateReferenceId_MutationMutationResult = Apollo.MutationResult<Types.UpdateReferenceId_Mutation>;
export type UpdateReferenceId_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateReferenceId_Mutation, Types.UpdateReferenceId_MutationVariables>;
 const UpdateShipmentDriver_MutationDocument = gql`
    mutation updateShipmentDriver_mutation($filter: FilterShipmentInput!, $driver: ShipmentDriverInput!) {
  updateShipmentDriver(filter: $filter, driver: $driver) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type UpdateShipmentDriver_MutationMutationFn = Apollo.MutationFunction<Types.UpdateShipmentDriver_Mutation, Types.UpdateShipmentDriver_MutationVariables>;

/**
 * __useUpdateShipmentDriver_Mutation__
 *
 * To run a mutation, you first call `useUpdateShipmentDriver_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentDriver_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentDriverMutation, { data, loading, error }] = useUpdateShipmentDriver_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      driver: // value for 'driver'
 *   },
 * });
 */
export function useUpdateShipmentDriver_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipmentDriver_Mutation, Types.UpdateShipmentDriver_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipmentDriver_Mutation, Types.UpdateShipmentDriver_MutationVariables>(UpdateShipmentDriver_MutationDocument, options);
      }
export type UpdateShipmentDriver_MutationHookResult = ReturnType<typeof useUpdateShipmentDriver_Mutation>;
export type UpdateShipmentDriver_MutationMutationResult = Apollo.MutationResult<Types.UpdateShipmentDriver_Mutation>;
export type UpdateShipmentDriver_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipmentDriver_Mutation, Types.UpdateShipmentDriver_MutationVariables>;
 const UpdateShipmentStopActualArrivalTime_MutationDocument = gql`
    mutation updateShipmentStopActualArrivalTime_mutation($filter: FilterShipmentStopInput!, $actualArrivalTime: DateTime!, $comment: String) {
  updateShipmentStopActualArrivalTime(
    filter: $filter
    actualArrivalTime: $actualArrivalTime
    comment: $comment
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type UpdateShipmentStopActualArrivalTime_MutationMutationFn = Apollo.MutationFunction<Types.UpdateShipmentStopActualArrivalTime_Mutation, Types.UpdateShipmentStopActualArrivalTime_MutationVariables>;

/**
 * __useUpdateShipmentStopActualArrivalTime_Mutation__
 *
 * To run a mutation, you first call `useUpdateShipmentStopActualArrivalTime_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentStopActualArrivalTime_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentStopActualArrivalTimeMutation, { data, loading, error }] = useUpdateShipmentStopActualArrivalTime_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      actualArrivalTime: // value for 'actualArrivalTime'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateShipmentStopActualArrivalTime_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipmentStopActualArrivalTime_Mutation, Types.UpdateShipmentStopActualArrivalTime_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipmentStopActualArrivalTime_Mutation, Types.UpdateShipmentStopActualArrivalTime_MutationVariables>(UpdateShipmentStopActualArrivalTime_MutationDocument, options);
      }
export type UpdateShipmentStopActualArrivalTime_MutationHookResult = ReturnType<typeof useUpdateShipmentStopActualArrivalTime_Mutation>;
export type UpdateShipmentStopActualArrivalTime_MutationMutationResult = Apollo.MutationResult<Types.UpdateShipmentStopActualArrivalTime_Mutation>;
export type UpdateShipmentStopActualArrivalTime_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipmentStopActualArrivalTime_Mutation, Types.UpdateShipmentStopActualArrivalTime_MutationVariables>;
 const UpdateShipmentStopsEstimatedTimes_MutationDocument = gql`
    mutation updateShipmentStopsEstimatedTimes_mutation($filter: FilterShipmentOptionalStopInput!, $estimatedTimes: ShipmentStopEstimatedTimesInput) {
  updateShipmentStopsEstimatedTimes(
    filter: $filter
    estimatedTimes: $estimatedTimes
  ) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type UpdateShipmentStopsEstimatedTimes_MutationMutationFn = Apollo.MutationFunction<Types.UpdateShipmentStopsEstimatedTimes_Mutation, Types.UpdateShipmentStopsEstimatedTimes_MutationVariables>;

/**
 * __useUpdateShipmentStopsEstimatedTimes_Mutation__
 *
 * To run a mutation, you first call `useUpdateShipmentStopsEstimatedTimes_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentStopsEstimatedTimes_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentStopsEstimatedTimesMutation, { data, loading, error }] = useUpdateShipmentStopsEstimatedTimes_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      estimatedTimes: // value for 'estimatedTimes'
 *   },
 * });
 */
export function useUpdateShipmentStopsEstimatedTimes_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipmentStopsEstimatedTimes_Mutation, Types.UpdateShipmentStopsEstimatedTimes_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipmentStopsEstimatedTimes_Mutation, Types.UpdateShipmentStopsEstimatedTimes_MutationVariables>(UpdateShipmentStopsEstimatedTimes_MutationDocument, options);
      }
export type UpdateShipmentStopsEstimatedTimes_MutationHookResult = ReturnType<typeof useUpdateShipmentStopsEstimatedTimes_Mutation>;
export type UpdateShipmentStopsEstimatedTimes_MutationMutationResult = Apollo.MutationResult<Types.UpdateShipmentStopsEstimatedTimes_Mutation>;
export type UpdateShipmentStopsEstimatedTimes_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipmentStopsEstimatedTimes_Mutation, Types.UpdateShipmentStopsEstimatedTimes_MutationVariables>;
 const UpdateShipmentVehicle_MutationDocument = gql`
    mutation updateShipmentVehicle_mutation($filter: FilterShipmentInput!, $vehicle: ShipmentVehicleInput!) {
  updateShipmentVehicle(filter: $filter, vehicle: $vehicle) {
    id
    version
    createdAt
    updatedAt
    deletedAt
    assignment {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    requests {
      carrier {
        name
        address {
          street
          houseNumber
          city
          zipCode
          country
        }
        contact {
          name
          mobile
          phone
          email
        }
      }
      dispatcher {
        contact {
          name
          mobile
          phone
          email
        }
      }
      referenceId
      rate {
        perKm {
          minDistance
          costPerKm
        }
        unloadingCharges {
          costPerAdditionalStop
          isAppliedAtDepot
        }
        laneBased {
          id
          pickUp {
            country
            zipCode
          }
          dropOff {
            country
            zipCode
          }
          cost
          costWeight {
            valueFromLimit
            valueToLimit
            costMin
            costMax
            cost
          }
        }
        equipmentCharges {
          equipment
          rateType
          costPerEquipment
        }
        calculatedTotalCost
        agreedTotalCost
      }
      costAdjustment {
        type
        amount
      }
      assignedAt
      preferredLanguage
      status
    }
    driver {
      name
      phone
      email
    }
    tenantId
    flagged
    status
    stops {
      id
      location {
        address {
          street
          city
          zipCode
          country
          coordinates {
            latitude
            longitude
          }
        }
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        loadingRequirements
        serviceTime
        openingHours {
          openingHoursType
          timezone
          openingHoursPerWeekDay {
            weekday
            from
            to
          }
        }
      }
      timeWindow {
        start
        end
      }
      pickUp {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      dropOff {
        referenceId
        customerReference
        content
        article
        pallets
        weight
        ldmm
      }
      estimatedTimes {
        estimatedArrivalTime
        estimatedDepartureTime
        comment
      }
      status
      completion {
        actualDepartureTime
        inFull
        comment
      }
      actualArrivalTime
      plannedTimes {
        plannedArrivalTime
        plannedDepartureTime
      }
      proofOfDeliveryUrl
    }
    transportRequirements {
      requiredPalletCapacity
      requiredWeightCapacity
      requiredLdmCapacity
      loadingRequirements
    }
    incidents {
      id
      userId
      tenantId
      timestamp
      comment
      stopId
    }
    referenceId
    distance
    vehicle {
      referenceId
      vehicleType
      vehicleLicense
      trailerLicense
      dimension {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      name
    }
    route {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    enRoute {
      sections {
        polyline
        summary {
          duration
          length
          consumption
          co2Emission
        }
        aggregateTolls {
          countryCode
          tollSystem
          currency
        }
      }
    }
    anonymousLink
    transportAllocationId
    cargoboardId
    transportOrderdocuments
    applicationDeadline
  }
}
    `;
export type UpdateShipmentVehicle_MutationMutationFn = Apollo.MutationFunction<Types.UpdateShipmentVehicle_Mutation, Types.UpdateShipmentVehicle_MutationVariables>;

/**
 * __useUpdateShipmentVehicle_Mutation__
 *
 * To run a mutation, you first call `useUpdateShipmentVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentVehicleMutation, { data, loading, error }] = useUpdateShipmentVehicle_Mutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      vehicle: // value for 'vehicle'
 *   },
 * });
 */
export function useUpdateShipmentVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateShipmentVehicle_Mutation, Types.UpdateShipmentVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateShipmentVehicle_Mutation, Types.UpdateShipmentVehicle_MutationVariables>(UpdateShipmentVehicle_MutationDocument, options);
      }
export type UpdateShipmentVehicle_MutationHookResult = ReturnType<typeof useUpdateShipmentVehicle_Mutation>;
export type UpdateShipmentVehicle_MutationMutationResult = Apollo.MutationResult<Types.UpdateShipmentVehicle_Mutation>;
export type UpdateShipmentVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateShipmentVehicle_Mutation, Types.UpdateShipmentVehicle_MutationVariables>;
 const CompleteRegistration_MutationDocument = gql`
    mutation completeRegistration_mutation($details: ApiRegistrationInput!) {
  completeRegistration(details: $details) {
    message
  }
}
    `;
export type CompleteRegistration_MutationMutationFn = Apollo.MutationFunction<Types.CompleteRegistration_Mutation, Types.CompleteRegistration_MutationVariables>;

/**
 * __useCompleteRegistration_Mutation__
 *
 * To run a mutation, you first call `useCompleteRegistration_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRegistration_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRegistrationMutation, { data, loading, error }] = useCompleteRegistration_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useCompleteRegistration_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CompleteRegistration_Mutation, Types.CompleteRegistration_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CompleteRegistration_Mutation, Types.CompleteRegistration_MutationVariables>(CompleteRegistration_MutationDocument, options);
      }
export type CompleteRegistration_MutationHookResult = ReturnType<typeof useCompleteRegistration_Mutation>;
export type CompleteRegistration_MutationMutationResult = Apollo.MutationResult<Types.CompleteRegistration_Mutation>;
export type CompleteRegistration_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CompleteRegistration_Mutation, Types.CompleteRegistration_MutationVariables>;
 const DeleteInvitation_MutationDocument = gql`
    mutation deleteInvitation_mutation($details: ApiDeleteInvitationInput!) {
  deleteInvitation(details: $details) {
    message
  }
}
    `;
export type DeleteInvitation_MutationMutationFn = Apollo.MutationFunction<Types.DeleteInvitation_Mutation, Types.DeleteInvitation_MutationVariables>;

/**
 * __useDeleteInvitation_Mutation__
 *
 * To run a mutation, you first call `useDeleteInvitation_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitation_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitation_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useDeleteInvitation_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInvitation_Mutation, Types.DeleteInvitation_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInvitation_Mutation, Types.DeleteInvitation_MutationVariables>(DeleteInvitation_MutationDocument, options);
      }
export type DeleteInvitation_MutationHookResult = ReturnType<typeof useDeleteInvitation_Mutation>;
export type DeleteInvitation_MutationMutationResult = Apollo.MutationResult<Types.DeleteInvitation_Mutation>;
export type DeleteInvitation_MutationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInvitation_Mutation, Types.DeleteInvitation_MutationVariables>;
 const GetDecryptedPayload_QueryDocument = gql`
    query getDecryptedPayload_query($payload: String!) {
  getDecryptedPayload(payload: $payload) {
    payload
  }
}
    `;

/**
 * __useGetDecryptedPayload_Query__
 *
 * To run a query within a React component, call `useGetDecryptedPayload_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetDecryptedPayload_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecryptedPayload_Query({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetDecryptedPayload_Query(baseOptions: Apollo.QueryHookOptions<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables> & ({ variables: Types.GetDecryptedPayload_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables>(GetDecryptedPayload_QueryDocument, options);
      }
export function useGetDecryptedPayload_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables>(GetDecryptedPayload_QueryDocument, options);
        }
export function useGetDecryptedPayload_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables>(GetDecryptedPayload_QueryDocument, options);
        }
export type GetDecryptedPayload_QueryHookResult = ReturnType<typeof useGetDecryptedPayload_Query>;
export type GetDecryptedPayload_QueryLazyQueryHookResult = ReturnType<typeof useGetDecryptedPayload_QueryLazyQuery>;
export type GetDecryptedPayload_QuerySuspenseQueryHookResult = ReturnType<typeof useGetDecryptedPayload_QuerySuspenseQuery>;
export type GetDecryptedPayload_QueryQueryResult = Apollo.QueryResult<Types.GetDecryptedPayload_Query, Types.GetDecryptedPayload_QueryVariables>;
 const GetLogoUrl_QueryDocument = gql`
    query getLogoUrl_query($userId: String!, $tenantId: String!) {
  getLogoUrl(userId: $userId, tenantId: $tenantId)
}
    `;

/**
 * __useGetLogoUrl_Query__
 *
 * To run a query within a React component, call `useGetLogoUrl_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetLogoUrl_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogoUrl_Query({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetLogoUrl_Query(baseOptions: Apollo.QueryHookOptions<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables> & ({ variables: Types.GetLogoUrl_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables>(GetLogoUrl_QueryDocument, options);
      }
export function useGetLogoUrl_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables>(GetLogoUrl_QueryDocument, options);
        }
export function useGetLogoUrl_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables>(GetLogoUrl_QueryDocument, options);
        }
export type GetLogoUrl_QueryHookResult = ReturnType<typeof useGetLogoUrl_Query>;
export type GetLogoUrl_QueryLazyQueryHookResult = ReturnType<typeof useGetLogoUrl_QueryLazyQuery>;
export type GetLogoUrl_QuerySuspenseQueryHookResult = ReturnType<typeof useGetLogoUrl_QuerySuspenseQuery>;
export type GetLogoUrl_QueryQueryResult = Apollo.QueryResult<Types.GetLogoUrl_Query, Types.GetLogoUrl_QueryVariables>;
 const GetMe_QueryDocument = gql`
    query getMe_query {
  getMe {
    id
    username
    name
    firstName
    lastName
    email
    language
    status
    userType
    createdDate
    invitedOn
    emailVerified
  }
}
    `;

/**
 * __useGetMe_Query__
 *
 * To run a query within a React component, call `useGetMe_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMe_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMe_Query({
 *   variables: {
 *   },
 * });
 */
export function useGetMe_Query(baseOptions?: Apollo.QueryHookOptions<Types.GetMe_Query, Types.GetMe_QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMe_Query, Types.GetMe_QueryVariables>(GetMe_QueryDocument, options);
      }
export function useGetMe_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMe_Query, Types.GetMe_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMe_Query, Types.GetMe_QueryVariables>(GetMe_QueryDocument, options);
        }
export function useGetMe_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMe_Query, Types.GetMe_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMe_Query, Types.GetMe_QueryVariables>(GetMe_QueryDocument, options);
        }
export type GetMe_QueryHookResult = ReturnType<typeof useGetMe_Query>;
export type GetMe_QueryLazyQueryHookResult = ReturnType<typeof useGetMe_QueryLazyQuery>;
export type GetMe_QuerySuspenseQueryHookResult = ReturnType<typeof useGetMe_QuerySuspenseQuery>;
export type GetMe_QueryQueryResult = Apollo.QueryResult<Types.GetMe_Query, Types.GetMe_QueryVariables>;
 const GetMyTenant_QueryDocument = gql`
    query getMyTenant_query {
  getMyTenant {
    id
    name
    street
    city
    zipCode
    country
    taxId
    dashboardId
    logoUrl
    cargoboardApiKey
  }
}
    `;

/**
 * __useGetMyTenant_Query__
 *
 * To run a query within a React component, call `useGetMyTenant_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTenant_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTenant_Query({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTenant_Query(baseOptions?: Apollo.QueryHookOptions<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>(GetMyTenant_QueryDocument, options);
      }
export function useGetMyTenant_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>(GetMyTenant_QueryDocument, options);
        }
export function useGetMyTenant_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>(GetMyTenant_QueryDocument, options);
        }
export type GetMyTenant_QueryHookResult = ReturnType<typeof useGetMyTenant_Query>;
export type GetMyTenant_QueryLazyQueryHookResult = ReturnType<typeof useGetMyTenant_QueryLazyQuery>;
export type GetMyTenant_QuerySuspenseQueryHookResult = ReturnType<typeof useGetMyTenant_QuerySuspenseQuery>;
export type GetMyTenant_QueryQueryResult = Apollo.QueryResult<Types.GetMyTenant_Query, Types.GetMyTenant_QueryVariables>;
 const GetMyTenantUsers_QueryDocument = gql`
    query getMyTenantUsers_query($query: QueryUsersInput!) {
  getMyTenantUsers(query: $query) {
    totalCount
    filteredCount
    itemList {
      id
      username
      name
      firstName
      lastName
      email
      language
      status
      userType
      createdDate
      invitedOn
      emailVerified
    }
  }
}
    `;

/**
 * __useGetMyTenantUsers_Query__
 *
 * To run a query within a React component, call `useGetMyTenantUsers_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTenantUsers_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTenantUsers_Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetMyTenantUsers_Query(baseOptions: Apollo.QueryHookOptions<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables> & ({ variables: Types.GetMyTenantUsers_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables>(GetMyTenantUsers_QueryDocument, options);
      }
export function useGetMyTenantUsers_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables>(GetMyTenantUsers_QueryDocument, options);
        }
export function useGetMyTenantUsers_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables>(GetMyTenantUsers_QueryDocument, options);
        }
export type GetMyTenantUsers_QueryHookResult = ReturnType<typeof useGetMyTenantUsers_Query>;
export type GetMyTenantUsers_QueryLazyQueryHookResult = ReturnType<typeof useGetMyTenantUsers_QueryLazyQuery>;
export type GetMyTenantUsers_QuerySuspenseQueryHookResult = ReturnType<typeof useGetMyTenantUsers_QuerySuspenseQuery>;
export type GetMyTenantUsers_QueryQueryResult = Apollo.QueryResult<Types.GetMyTenantUsers_Query, Types.GetMyTenantUsers_QueryVariables>;
 const ResendInvitation_MutationDocument = gql`
    mutation resendInvitation_mutation($details: ApiResendInvitationInput!) {
  resendInvitation(details: $details) {
    message
  }
}
    `;
export type ResendInvitation_MutationMutationFn = Apollo.MutationFunction<Types.ResendInvitation_Mutation, Types.ResendInvitation_MutationVariables>;

/**
 * __useResendInvitation_Mutation__
 *
 * To run a mutation, you first call `useResendInvitation_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitation_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitation_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useResendInvitation_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendInvitation_Mutation, Types.ResendInvitation_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendInvitation_Mutation, Types.ResendInvitation_MutationVariables>(ResendInvitation_MutationDocument, options);
      }
export type ResendInvitation_MutationHookResult = ReturnType<typeof useResendInvitation_Mutation>;
export type ResendInvitation_MutationMutationResult = Apollo.MutationResult<Types.ResendInvitation_Mutation>;
export type ResendInvitation_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ResendInvitation_Mutation, Types.ResendInvitation_MutationVariables>;
 const ResetPassword_MutationDocument = gql`
    mutation resetPassword_mutation($details: ApiResetPasswordInput!) {
  resetPassword(details: $details) {
    message
  }
}
    `;
export type ResetPassword_MutationMutationFn = Apollo.MutationFunction<Types.ResetPassword_Mutation, Types.ResetPassword_MutationVariables>;

/**
 * __useResetPassword_Mutation__
 *
 * To run a mutation, you first call `useResetPassword_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPassword_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPassword_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useResetPassword_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ResetPassword_Mutation, Types.ResetPassword_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResetPassword_Mutation, Types.ResetPassword_MutationVariables>(ResetPassword_MutationDocument, options);
      }
export type ResetPassword_MutationHookResult = ReturnType<typeof useResetPassword_Mutation>;
export type ResetPassword_MutationMutationResult = Apollo.MutationResult<Types.ResetPassword_Mutation>;
export type ResetPassword_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ResetPassword_Mutation, Types.ResetPassword_MutationVariables>;
 const SendInvitation_MutationDocument = gql`
    mutation sendInvitation_mutation($details: ApiInvitationInput!) {
  sendInvitation(details: $details) {
    message
  }
}
    `;
export type SendInvitation_MutationMutationFn = Apollo.MutationFunction<Types.SendInvitation_Mutation, Types.SendInvitation_MutationVariables>;

/**
 * __useSendInvitation_Mutation__
 *
 * To run a mutation, you first call `useSendInvitation_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitation_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitation_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useSendInvitation_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SendInvitation_Mutation, Types.SendInvitation_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendInvitation_Mutation, Types.SendInvitation_MutationVariables>(SendInvitation_MutationDocument, options);
      }
export type SendInvitation_MutationHookResult = ReturnType<typeof useSendInvitation_Mutation>;
export type SendInvitation_MutationMutationResult = Apollo.MutationResult<Types.SendInvitation_Mutation>;
export type SendInvitation_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SendInvitation_Mutation, Types.SendInvitation_MutationVariables>;
 const SendPasswordResetEmail_MutationDocument = gql`
    mutation sendPasswordResetEmail_mutation($details: ApiResetPasswordEmailInput!) {
  sendPasswordResetEmail(details: $details) {
    message
  }
}
    `;
export type SendPasswordResetEmail_MutationMutationFn = Apollo.MutationFunction<Types.SendPasswordResetEmail_Mutation, Types.SendPasswordResetEmail_MutationVariables>;

/**
 * __useSendPasswordResetEmail_Mutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmail_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmail_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmail_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useSendPasswordResetEmail_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SendPasswordResetEmail_Mutation, Types.SendPasswordResetEmail_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendPasswordResetEmail_Mutation, Types.SendPasswordResetEmail_MutationVariables>(SendPasswordResetEmail_MutationDocument, options);
      }
export type SendPasswordResetEmail_MutationHookResult = ReturnType<typeof useSendPasswordResetEmail_Mutation>;
export type SendPasswordResetEmail_MutationMutationResult = Apollo.MutationResult<Types.SendPasswordResetEmail_Mutation>;
export type SendPasswordResetEmail_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SendPasswordResetEmail_Mutation, Types.SendPasswordResetEmail_MutationVariables>;
 const SignedTenantBucketUrl_QueryDocument = gql`
    query signedTenantBucketUrl_query($url: String!) {
  signedTenantBucketUrl(url: $url)
}
    `;

/**
 * __useSignedTenantBucketUrl_Query__
 *
 * To run a query within a React component, call `useSignedTenantBucketUrl_Query` and pass it any options that fit your needs.
 * When your component renders, `useSignedTenantBucketUrl_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignedTenantBucketUrl_Query({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSignedTenantBucketUrl_Query(baseOptions: Apollo.QueryHookOptions<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables> & ({ variables: Types.SignedTenantBucketUrl_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables>(SignedTenantBucketUrl_QueryDocument, options);
      }
export function useSignedTenantBucketUrl_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables>(SignedTenantBucketUrl_QueryDocument, options);
        }
export function useSignedTenantBucketUrl_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables>(SignedTenantBucketUrl_QueryDocument, options);
        }
export type SignedTenantBucketUrl_QueryHookResult = ReturnType<typeof useSignedTenantBucketUrl_Query>;
export type SignedTenantBucketUrl_QueryLazyQueryHookResult = ReturnType<typeof useSignedTenantBucketUrl_QueryLazyQuery>;
export type SignedTenantBucketUrl_QuerySuspenseQueryHookResult = ReturnType<typeof useSignedTenantBucketUrl_QuerySuspenseQuery>;
export type SignedTenantBucketUrl_QueryQueryResult = Apollo.QueryResult<Types.SignedTenantBucketUrl_Query, Types.SignedTenantBucketUrl_QueryVariables>;
 const UpdateMe_MutationDocument = gql`
    mutation updateMe_mutation($details: ApiUserInput!) {
  updateMe(details: $details) {
    message
  }
}
    `;
export type UpdateMe_MutationMutationFn = Apollo.MutationFunction<Types.UpdateMe_Mutation, Types.UpdateMe_MutationVariables>;

/**
 * __useUpdateMe_Mutation__
 *
 * To run a mutation, you first call `useUpdateMe_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMe_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMe_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateMe_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMe_Mutation, Types.UpdateMe_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMe_Mutation, Types.UpdateMe_MutationVariables>(UpdateMe_MutationDocument, options);
      }
export type UpdateMe_MutationHookResult = ReturnType<typeof useUpdateMe_Mutation>;
export type UpdateMe_MutationMutationResult = Apollo.MutationResult<Types.UpdateMe_Mutation>;
export type UpdateMe_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMe_Mutation, Types.UpdateMe_MutationVariables>;
 const UpdateMyTenant_MutationDocument = gql`
    mutation updateMyTenant_mutation($details: ApiTenantInput!) {
  updateMyTenant(details: $details) {
    message
  }
}
    `;
export type UpdateMyTenant_MutationMutationFn = Apollo.MutationFunction<Types.UpdateMyTenant_Mutation, Types.UpdateMyTenant_MutationVariables>;

/**
 * __useUpdateMyTenant_Mutation__
 *
 * To run a mutation, you first call `useUpdateMyTenant_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyTenant_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyTenantMutation, { data, loading, error }] = useUpdateMyTenant_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateMyTenant_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyTenant_Mutation, Types.UpdateMyTenant_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyTenant_Mutation, Types.UpdateMyTenant_MutationVariables>(UpdateMyTenant_MutationDocument, options);
      }
export type UpdateMyTenant_MutationHookResult = ReturnType<typeof useUpdateMyTenant_Mutation>;
export type UpdateMyTenant_MutationMutationResult = Apollo.MutationResult<Types.UpdateMyTenant_Mutation>;
export type UpdateMyTenant_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyTenant_Mutation, Types.UpdateMyTenant_MutationVariables>;
 const UpdateUserByAdmin_MutationDocument = gql`
    mutation updateUserByAdmin_mutation($details: ApiUpdateUserByAdmin!) {
  updateUserByAdmin(details: $details) {
    message
  }
}
    `;
export type UpdateUserByAdmin_MutationMutationFn = Apollo.MutationFunction<Types.UpdateUserByAdmin_Mutation, Types.UpdateUserByAdmin_MutationVariables>;

/**
 * __useUpdateUserByAdmin_Mutation__
 *
 * To run a mutation, you first call `useUpdateUserByAdmin_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserByAdmin_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserByAdminMutation, { data, loading, error }] = useUpdateUserByAdmin_Mutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateUserByAdmin_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserByAdmin_Mutation, Types.UpdateUserByAdmin_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserByAdmin_Mutation, Types.UpdateUserByAdmin_MutationVariables>(UpdateUserByAdmin_MutationDocument, options);
      }
export type UpdateUserByAdmin_MutationHookResult = ReturnType<typeof useUpdateUserByAdmin_Mutation>;
export type UpdateUserByAdmin_MutationMutationResult = Apollo.MutationResult<Types.UpdateUserByAdmin_Mutation>;
export type UpdateUserByAdmin_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserByAdmin_Mutation, Types.UpdateUserByAdmin_MutationVariables>;
 const AddFleetsToTourPlan_MutationDocument = gql`
    mutation addFleetsToTourPlan_mutation($tourPlanId: String!, $addFleetInputs: [TourPlannerAddFleetInput!]!) {
  addFleetsToTourPlan(tourPlanId: $tourPlanId, addFleetInputs: $addFleetInputs) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type AddFleetsToTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.AddFleetsToTourPlan_Mutation, Types.AddFleetsToTourPlan_MutationVariables>;

/**
 * __useAddFleetsToTourPlan_Mutation__
 *
 * To run a mutation, you first call `useAddFleetsToTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFleetsToTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFleetsToTourPlanMutation, { data, loading, error }] = useAddFleetsToTourPlan_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      addFleetInputs: // value for 'addFleetInputs'
 *   },
 * });
 */
export function useAddFleetsToTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFleetsToTourPlan_Mutation, Types.AddFleetsToTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFleetsToTourPlan_Mutation, Types.AddFleetsToTourPlan_MutationVariables>(AddFleetsToTourPlan_MutationDocument, options);
      }
export type AddFleetsToTourPlan_MutationHookResult = ReturnType<typeof useAddFleetsToTourPlan_Mutation>;
export type AddFleetsToTourPlan_MutationMutationResult = Apollo.MutationResult<Types.AddFleetsToTourPlan_Mutation>;
export type AddFleetsToTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AddFleetsToTourPlan_Mutation, Types.AddFleetsToTourPlan_MutationVariables>;
 const AddLoadToFleet_MutationDocument = gql`
    mutation addLoadToFleet_mutation($load: TourPlannerLoadInput!, $fleetId: String!, $tourPlanId: String!) {
  addLoadToFleet(load: $load, fleetId: $fleetId, tourPlanId: $tourPlanId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type AddLoadToFleet_MutationMutationFn = Apollo.MutationFunction<Types.AddLoadToFleet_Mutation, Types.AddLoadToFleet_MutationVariables>;

/**
 * __useAddLoadToFleet_Mutation__
 *
 * To run a mutation, you first call `useAddLoadToFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoadToFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoadToFleetMutation, { data, loading, error }] = useAddLoadToFleet_Mutation({
 *   variables: {
 *      load: // value for 'load'
 *      fleetId: // value for 'fleetId'
 *      tourPlanId: // value for 'tourPlanId'
 *   },
 * });
 */
export function useAddLoadToFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLoadToFleet_Mutation, Types.AddLoadToFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLoadToFleet_Mutation, Types.AddLoadToFleet_MutationVariables>(AddLoadToFleet_MutationDocument, options);
      }
export type AddLoadToFleet_MutationHookResult = ReturnType<typeof useAddLoadToFleet_Mutation>;
export type AddLoadToFleet_MutationMutationResult = Apollo.MutationResult<Types.AddLoadToFleet_Mutation>;
export type AddLoadToFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AddLoadToFleet_Mutation, Types.AddLoadToFleet_MutationVariables>;
 const AddLoadToTour_MutationDocument = gql`
    mutation addLoadToTour_mutation($tourPlanId: String!, $load: TourPlannerLoadInput!, $tourId: String!, $index: Int) {
  addLoadToTour(
    tourPlanId: $tourPlanId
    load: $load
    tourId: $tourId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type AddLoadToTour_MutationMutationFn = Apollo.MutationFunction<Types.AddLoadToTour_Mutation, Types.AddLoadToTour_MutationVariables>;

/**
 * __useAddLoadToTour_Mutation__
 *
 * To run a mutation, you first call `useAddLoadToTour_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoadToTour_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoadToTourMutation, { data, loading, error }] = useAddLoadToTour_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      load: // value for 'load'
 *      tourId: // value for 'tourId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useAddLoadToTour_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLoadToTour_Mutation, Types.AddLoadToTour_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLoadToTour_Mutation, Types.AddLoadToTour_MutationVariables>(AddLoadToTour_MutationDocument, options);
      }
export type AddLoadToTour_MutationHookResult = ReturnType<typeof useAddLoadToTour_Mutation>;
export type AddLoadToTour_MutationMutationResult = Apollo.MutationResult<Types.AddLoadToTour_Mutation>;
export type AddLoadToTour_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AddLoadToTour_Mutation, Types.AddLoadToTour_MutationVariables>;
 const AddLoadToVehicle_MutationDocument = gql`
    mutation addLoadToVehicle_mutation($load: TourPlannerLoadInput!, $vehicleId: String!, $tourPlanId: String!) {
  addLoadToVehicle(load: $load, vehicleId: $vehicleId, tourPlanId: $tourPlanId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type AddLoadToVehicle_MutationMutationFn = Apollo.MutationFunction<Types.AddLoadToVehicle_Mutation, Types.AddLoadToVehicle_MutationVariables>;

/**
 * __useAddLoadToVehicle_Mutation__
 *
 * To run a mutation, you first call `useAddLoadToVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoadToVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoadToVehicleMutation, { data, loading, error }] = useAddLoadToVehicle_Mutation({
 *   variables: {
 *      load: // value for 'load'
 *      vehicleId: // value for 'vehicleId'
 *      tourPlanId: // value for 'tourPlanId'
 *   },
 * });
 */
export function useAddLoadToVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLoadToVehicle_Mutation, Types.AddLoadToVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLoadToVehicle_Mutation, Types.AddLoadToVehicle_MutationVariables>(AddLoadToVehicle_MutationDocument, options);
      }
export type AddLoadToVehicle_MutationHookResult = ReturnType<typeof useAddLoadToVehicle_Mutation>;
export type AddLoadToVehicle_MutationMutationResult = Apollo.MutationResult<Types.AddLoadToVehicle_Mutation>;
export type AddLoadToVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AddLoadToVehicle_Mutation, Types.AddLoadToVehicle_MutationVariables>;
 const AssignUnplannedLoads_MutationDocument = gql`
    mutation assignUnplannedLoads_mutation($tourPlanId: String!, $settings: TourSettingsInput!, $loads: [TourPlannerLoadInput!]!) {
  assignUnplannedLoads(
    tourPlanId: $tourPlanId
    settings: $settings
    loads: $loads
  ) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
export type AssignUnplannedLoads_MutationMutationFn = Apollo.MutationFunction<Types.AssignUnplannedLoads_Mutation, Types.AssignUnplannedLoads_MutationVariables>;

/**
 * __useAssignUnplannedLoads_Mutation__
 *
 * To run a mutation, you first call `useAssignUnplannedLoads_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUnplannedLoads_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUnplannedLoadsMutation, { data, loading, error }] = useAssignUnplannedLoads_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      settings: // value for 'settings'
 *      loads: // value for 'loads'
 *   },
 * });
 */
export function useAssignUnplannedLoads_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AssignUnplannedLoads_Mutation, Types.AssignUnplannedLoads_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AssignUnplannedLoads_Mutation, Types.AssignUnplannedLoads_MutationVariables>(AssignUnplannedLoads_MutationDocument, options);
      }
export type AssignUnplannedLoads_MutationHookResult = ReturnType<typeof useAssignUnplannedLoads_Mutation>;
export type AssignUnplannedLoads_MutationMutationResult = Apollo.MutationResult<Types.AssignUnplannedLoads_Mutation>;
export type AssignUnplannedLoads_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AssignUnplannedLoads_Mutation, Types.AssignUnplannedLoads_MutationVariables>;
 const AssignUnplannedLoadsAsync_MutationDocument = gql`
    mutation assignUnplannedLoadsAsync_mutation($tourPlanId: String!, $settings: TourSettingsInput!, $loads: [TourPlannerLoadInput!]!) {
  assignUnplannedLoadsAsync(
    tourPlanId: $tourPlanId
    settings: $settings
    loads: $loads
  ) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
export type AssignUnplannedLoadsAsync_MutationMutationFn = Apollo.MutationFunction<Types.AssignUnplannedLoadsAsync_Mutation, Types.AssignUnplannedLoadsAsync_MutationVariables>;

/**
 * __useAssignUnplannedLoadsAsync_Mutation__
 *
 * To run a mutation, you first call `useAssignUnplannedLoadsAsync_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUnplannedLoadsAsync_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUnplannedLoadsAsyncMutation, { data, loading, error }] = useAssignUnplannedLoadsAsync_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      settings: // value for 'settings'
 *      loads: // value for 'loads'
 *   },
 * });
 */
export function useAssignUnplannedLoadsAsync_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.AssignUnplannedLoadsAsync_Mutation, Types.AssignUnplannedLoadsAsync_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AssignUnplannedLoadsAsync_Mutation, Types.AssignUnplannedLoadsAsync_MutationVariables>(AssignUnplannedLoadsAsync_MutationDocument, options);
      }
export type AssignUnplannedLoadsAsync_MutationHookResult = ReturnType<typeof useAssignUnplannedLoadsAsync_Mutation>;
export type AssignUnplannedLoadsAsync_MutationMutationResult = Apollo.MutationResult<Types.AssignUnplannedLoadsAsync_Mutation>;
export type AssignUnplannedLoadsAsync_MutationMutationOptions = Apollo.BaseMutationOptions<Types.AssignUnplannedLoadsAsync_Mutation, Types.AssignUnplannedLoadsAsync_MutationVariables>;
 const BulkLockTours_MutationDocument = gql`
    mutation bulkLockTours_mutation($tourPlanId: String!, $tourIds: [String!]!, $lockReason: TourLockReasonEnum!) {
  bulkLockTours(
    tourPlanId: $tourPlanId
    tourIds: $tourIds
    lockReason: $lockReason
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type BulkLockTours_MutationMutationFn = Apollo.MutationFunction<Types.BulkLockTours_Mutation, Types.BulkLockTours_MutationVariables>;

/**
 * __useBulkLockTours_Mutation__
 *
 * To run a mutation, you first call `useBulkLockTours_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkLockTours_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkLockToursMutation, { data, loading, error }] = useBulkLockTours_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourIds: // value for 'tourIds'
 *      lockReason: // value for 'lockReason'
 *   },
 * });
 */
export function useBulkLockTours_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.BulkLockTours_Mutation, Types.BulkLockTours_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BulkLockTours_Mutation, Types.BulkLockTours_MutationVariables>(BulkLockTours_MutationDocument, options);
      }
export type BulkLockTours_MutationHookResult = ReturnType<typeof useBulkLockTours_Mutation>;
export type BulkLockTours_MutationMutationResult = Apollo.MutationResult<Types.BulkLockTours_Mutation>;
export type BulkLockTours_MutationMutationOptions = Apollo.BaseMutationOptions<Types.BulkLockTours_Mutation, Types.BulkLockTours_MutationVariables>;
 const CancelPlanning_MutationDocument = gql`
    mutation cancelPlanning_mutation($tourPlanId: String!) {
  cancelPlanning(tourPlanId: $tourPlanId) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
export type CancelPlanning_MutationMutationFn = Apollo.MutationFunction<Types.CancelPlanning_Mutation, Types.CancelPlanning_MutationVariables>;

/**
 * __useCancelPlanning_Mutation__
 *
 * To run a mutation, you first call `useCancelPlanning_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlanning_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlanningMutation, { data, loading, error }] = useCancelPlanning_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *   },
 * });
 */
export function useCancelPlanning_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CancelPlanning_Mutation, Types.CancelPlanning_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CancelPlanning_Mutation, Types.CancelPlanning_MutationVariables>(CancelPlanning_MutationDocument, options);
      }
export type CancelPlanning_MutationHookResult = ReturnType<typeof useCancelPlanning_Mutation>;
export type CancelPlanning_MutationMutationResult = Apollo.MutationResult<Types.CancelPlanning_Mutation>;
export type CancelPlanning_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CancelPlanning_Mutation, Types.CancelPlanning_MutationVariables>;
 const CreateTourPlan_MutationDocument = gql`
    mutation createTourPlan_mutation($name: String!, $planningDate: String!, $vehicles: [TourPlannerVehicleInput!]!, $fleets: [TourPlannerFleetInput!]!, $depotLocation: TourPlannerLocationInput) {
  createTourPlan(
    name: $name
    planningDate: $planningDate
    vehicles: $vehicles
    fleets: $fleets
    depotLocation: $depotLocation
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type CreateTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.CreateTourPlan_Mutation, Types.CreateTourPlan_MutationVariables>;

/**
 * __useCreateTourPlan_Mutation__
 *
 * To run a mutation, you first call `useCreateTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourPlanMutation, { data, loading, error }] = useCreateTourPlan_Mutation({
 *   variables: {
 *      name: // value for 'name'
 *      planningDate: // value for 'planningDate'
 *      vehicles: // value for 'vehicles'
 *      fleets: // value for 'fleets'
 *      depotLocation: // value for 'depotLocation'
 *   },
 * });
 */
export function useCreateTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTourPlan_Mutation, Types.CreateTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTourPlan_Mutation, Types.CreateTourPlan_MutationVariables>(CreateTourPlan_MutationDocument, options);
      }
export type CreateTourPlan_MutationHookResult = ReturnType<typeof useCreateTourPlan_Mutation>;
export type CreateTourPlan_MutationMutationResult = Apollo.MutationResult<Types.CreateTourPlan_Mutation>;
export type CreateTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.CreateTourPlan_Mutation, Types.CreateTourPlan_MutationVariables>;
 const FindLoadsUsedInTourPlan_QueryDocument = gql`
    query findLoadsUsedInTourPlan_query($loadIds: [String!]!) {
  findLoadsUsedInTourPlan(loadIds: $loadIds) {
    alreadyAssignedLoadIds
    lockedIds
  }
}
    `;

/**
 * __useFindLoadsUsedInTourPlan_Query__
 *
 * To run a query within a React component, call `useFindLoadsUsedInTourPlan_Query` and pass it any options that fit your needs.
 * When your component renders, `useFindLoadsUsedInTourPlan_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLoadsUsedInTourPlan_Query({
 *   variables: {
 *      loadIds: // value for 'loadIds'
 *   },
 * });
 */
export function useFindLoadsUsedInTourPlan_Query(baseOptions: Apollo.QueryHookOptions<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables> & ({ variables: Types.FindLoadsUsedInTourPlan_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables>(FindLoadsUsedInTourPlan_QueryDocument, options);
      }
export function useFindLoadsUsedInTourPlan_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables>(FindLoadsUsedInTourPlan_QueryDocument, options);
        }
export function useFindLoadsUsedInTourPlan_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables>(FindLoadsUsedInTourPlan_QueryDocument, options);
        }
export type FindLoadsUsedInTourPlan_QueryHookResult = ReturnType<typeof useFindLoadsUsedInTourPlan_Query>;
export type FindLoadsUsedInTourPlan_QueryLazyQueryHookResult = ReturnType<typeof useFindLoadsUsedInTourPlan_QueryLazyQuery>;
export type FindLoadsUsedInTourPlan_QuerySuspenseQueryHookResult = ReturnType<typeof useFindLoadsUsedInTourPlan_QuerySuspenseQuery>;
export type FindLoadsUsedInTourPlan_QueryQueryResult = Apollo.QueryResult<Types.FindLoadsUsedInTourPlan_Query, Types.FindLoadsUsedInTourPlan_QueryVariables>;
 const GetTourPlannerConfiguration_QueryDocument = gql`
    query getTourPlannerConfiguration_query {
  getTourPlannerConfiguration {
    maxDrivingHours
    maxWorkingHours
    cutOffTimeHours
    warningTimeHours
    toursAlwaysStartAtDepot
    toursAlwaysEndAtDepot
  }
}
    `;

/**
 * __useGetTourPlannerConfiguration_Query__
 *
 * To run a query within a React component, call `useGetTourPlannerConfiguration_Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTourPlannerConfiguration_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourPlannerConfiguration_Query({
 *   variables: {
 *   },
 * });
 */
export function useGetTourPlannerConfiguration_Query(baseOptions?: Apollo.QueryHookOptions<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>(GetTourPlannerConfiguration_QueryDocument, options);
      }
export function useGetTourPlannerConfiguration_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>(GetTourPlannerConfiguration_QueryDocument, options);
        }
export function useGetTourPlannerConfiguration_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>(GetTourPlannerConfiguration_QueryDocument, options);
        }
export type GetTourPlannerConfiguration_QueryHookResult = ReturnType<typeof useGetTourPlannerConfiguration_Query>;
export type GetTourPlannerConfiguration_QueryLazyQueryHookResult = ReturnType<typeof useGetTourPlannerConfiguration_QueryLazyQuery>;
export type GetTourPlannerConfiguration_QuerySuspenseQueryHookResult = ReturnType<typeof useGetTourPlannerConfiguration_QuerySuspenseQuery>;
export type GetTourPlannerConfiguration_QueryQueryResult = Apollo.QueryResult<Types.GetTourPlannerConfiguration_Query, Types.GetTourPlannerConfiguration_QueryVariables>;
 const LockTour_MutationDocument = gql`
    mutation lockTour_mutation($tourPlanId: String!, $tourId: String!, $lockReason: TourLockReasonEnum!) {
  lockTour(tourPlanId: $tourPlanId, tourId: $tourId, lockReason: $lockReason) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type LockTour_MutationMutationFn = Apollo.MutationFunction<Types.LockTour_Mutation, Types.LockTour_MutationVariables>;

/**
 * __useLockTour_Mutation__
 *
 * To run a mutation, you first call `useLockTour_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockTour_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockTourMutation, { data, loading, error }] = useLockTour_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *      lockReason: // value for 'lockReason'
 *   },
 * });
 */
export function useLockTour_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.LockTour_Mutation, Types.LockTour_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LockTour_Mutation, Types.LockTour_MutationVariables>(LockTour_MutationDocument, options);
      }
export type LockTour_MutationHookResult = ReturnType<typeof useLockTour_Mutation>;
export type LockTour_MutationMutationResult = Apollo.MutationResult<Types.LockTour_Mutation>;
export type LockTour_MutationMutationOptions = Apollo.BaseMutationOptions<Types.LockTour_Mutation, Types.LockTour_MutationVariables>;
 const MoveFleetsFromDateToTourPlan_MutationDocument = gql`
    mutation moveFleetsFromDateToTourPlan_mutation($tourPlanId: String!, $fromDate: String!) {
  moveFleetsFromDateToTourPlan(tourPlanId: $tourPlanId, fromDate: $fromDate) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveFleetsFromDateToTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.MoveFleetsFromDateToTourPlan_Mutation, Types.MoveFleetsFromDateToTourPlan_MutationVariables>;

/**
 * __useMoveFleetsFromDateToTourPlan_Mutation__
 *
 * To run a mutation, you first call `useMoveFleetsFromDateToTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFleetsFromDateToTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFleetsFromDateToTourPlanMutation, { data, loading, error }] = useMoveFleetsFromDateToTourPlan_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useMoveFleetsFromDateToTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveFleetsFromDateToTourPlan_Mutation, Types.MoveFleetsFromDateToTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveFleetsFromDateToTourPlan_Mutation, Types.MoveFleetsFromDateToTourPlan_MutationVariables>(MoveFleetsFromDateToTourPlan_MutationDocument, options);
      }
export type MoveFleetsFromDateToTourPlan_MutationHookResult = ReturnType<typeof useMoveFleetsFromDateToTourPlan_Mutation>;
export type MoveFleetsFromDateToTourPlan_MutationMutationResult = Apollo.MutationResult<Types.MoveFleetsFromDateToTourPlan_Mutation>;
export type MoveFleetsFromDateToTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveFleetsFromDateToTourPlan_Mutation, Types.MoveFleetsFromDateToTourPlan_MutationVariables>;
 const MoveLoadToFleet_MutationDocument = gql`
    mutation moveLoadToFleet_mutation($tourPlanId: String!, $fleetId: String!, $loadId: String!) {
  moveLoadToFleet(tourPlanId: $tourPlanId, fleetId: $fleetId, loadId: $loadId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveLoadToFleet_MutationMutationFn = Apollo.MutationFunction<Types.MoveLoadToFleet_Mutation, Types.MoveLoadToFleet_MutationVariables>;

/**
 * __useMoveLoadToFleet_Mutation__
 *
 * To run a mutation, you first call `useMoveLoadToFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLoadToFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLoadToFleetMutation, { data, loading, error }] = useMoveLoadToFleet_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      fleetId: // value for 'fleetId'
 *      loadId: // value for 'loadId'
 *   },
 * });
 */
export function useMoveLoadToFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLoadToFleet_Mutation, Types.MoveLoadToFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLoadToFleet_Mutation, Types.MoveLoadToFleet_MutationVariables>(MoveLoadToFleet_MutationDocument, options);
      }
export type MoveLoadToFleet_MutationHookResult = ReturnType<typeof useMoveLoadToFleet_Mutation>;
export type MoveLoadToFleet_MutationMutationResult = Apollo.MutationResult<Types.MoveLoadToFleet_Mutation>;
export type MoveLoadToFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveLoadToFleet_Mutation, Types.MoveLoadToFleet_MutationVariables>;
 const MoveLoadToStop_MutationDocument = gql`
    mutation moveLoadToStop_mutation($tourPlanId: String!, $fromStopId: String!, $toStopId: String!, $loadId: String!) {
  moveLoadToStop(
    tourPlanId: $tourPlanId
    fromStopId: $fromStopId
    toStopId: $toStopId
    loadId: $loadId
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveLoadToStop_MutationMutationFn = Apollo.MutationFunction<Types.MoveLoadToStop_Mutation, Types.MoveLoadToStop_MutationVariables>;

/**
 * __useMoveLoadToStop_Mutation__
 *
 * To run a mutation, you first call `useMoveLoadToStop_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLoadToStop_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLoadToStopMutation, { data, loading, error }] = useMoveLoadToStop_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      fromStopId: // value for 'fromStopId'
 *      toStopId: // value for 'toStopId'
 *      loadId: // value for 'loadId'
 *   },
 * });
 */
export function useMoveLoadToStop_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLoadToStop_Mutation, Types.MoveLoadToStop_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLoadToStop_Mutation, Types.MoveLoadToStop_MutationVariables>(MoveLoadToStop_MutationDocument, options);
      }
export type MoveLoadToStop_MutationHookResult = ReturnType<typeof useMoveLoadToStop_Mutation>;
export type MoveLoadToStop_MutationMutationResult = Apollo.MutationResult<Types.MoveLoadToStop_Mutation>;
export type MoveLoadToStop_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveLoadToStop_Mutation, Types.MoveLoadToStop_MutationVariables>;
 const MoveLoadToTour_MutationDocument = gql`
    mutation moveLoadToTour_mutation($tourPlanId: String!, $tourId: String!, $loadId: String!, $index: Int) {
  moveLoadToTour(
    tourPlanId: $tourPlanId
    tourId: $tourId
    loadId: $loadId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveLoadToTour_MutationMutationFn = Apollo.MutationFunction<Types.MoveLoadToTour_Mutation, Types.MoveLoadToTour_MutationVariables>;

/**
 * __useMoveLoadToTour_Mutation__
 *
 * To run a mutation, you first call `useMoveLoadToTour_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLoadToTour_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLoadToTourMutation, { data, loading, error }] = useMoveLoadToTour_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *      loadId: // value for 'loadId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useMoveLoadToTour_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLoadToTour_Mutation, Types.MoveLoadToTour_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLoadToTour_Mutation, Types.MoveLoadToTour_MutationVariables>(MoveLoadToTour_MutationDocument, options);
      }
export type MoveLoadToTour_MutationHookResult = ReturnType<typeof useMoveLoadToTour_Mutation>;
export type MoveLoadToTour_MutationMutationResult = Apollo.MutationResult<Types.MoveLoadToTour_Mutation>;
export type MoveLoadToTour_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveLoadToTour_Mutation, Types.MoveLoadToTour_MutationVariables>;
 const MoveLoadToVehicle_MutationDocument = gql`
    mutation moveLoadToVehicle_mutation($tourPlanId: String!, $vehicleId: String!, $loadId: String!) {
  moveLoadToVehicle(
    tourPlanId: $tourPlanId
    vehicleId: $vehicleId
    loadId: $loadId
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveLoadToVehicle_MutationMutationFn = Apollo.MutationFunction<Types.MoveLoadToVehicle_Mutation, Types.MoveLoadToVehicle_MutationVariables>;

/**
 * __useMoveLoadToVehicle_Mutation__
 *
 * To run a mutation, you first call `useMoveLoadToVehicle_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLoadToVehicle_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLoadToVehicleMutation, { data, loading, error }] = useMoveLoadToVehicle_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      vehicleId: // value for 'vehicleId'
 *      loadId: // value for 'loadId'
 *   },
 * });
 */
export function useMoveLoadToVehicle_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLoadToVehicle_Mutation, Types.MoveLoadToVehicle_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLoadToVehicle_Mutation, Types.MoveLoadToVehicle_MutationVariables>(MoveLoadToVehicle_MutationDocument, options);
      }
export type MoveLoadToVehicle_MutationHookResult = ReturnType<typeof useMoveLoadToVehicle_Mutation>;
export type MoveLoadToVehicle_MutationMutationResult = Apollo.MutationResult<Types.MoveLoadToVehicle_Mutation>;
export type MoveLoadToVehicle_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveLoadToVehicle_Mutation, Types.MoveLoadToVehicle_MutationVariables>;
 const MoveStopToFleet_MutationDocument = gql`
    mutation moveStopToFleet_mutation($tourPlanId: String!, $stopId: String!, $fleetId: String!) {
  moveStopToFleet(tourPlanId: $tourPlanId, stopId: $stopId, fleetId: $fleetId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveStopToFleet_MutationMutationFn = Apollo.MutationFunction<Types.MoveStopToFleet_Mutation, Types.MoveStopToFleet_MutationVariables>;

/**
 * __useMoveStopToFleet_Mutation__
 *
 * To run a mutation, you first call `useMoveStopToFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStopToFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStopToFleetMutation, { data, loading, error }] = useMoveStopToFleet_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      stopId: // value for 'stopId'
 *      fleetId: // value for 'fleetId'
 *   },
 * });
 */
export function useMoveStopToFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveStopToFleet_Mutation, Types.MoveStopToFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveStopToFleet_Mutation, Types.MoveStopToFleet_MutationVariables>(MoveStopToFleet_MutationDocument, options);
      }
export type MoveStopToFleet_MutationHookResult = ReturnType<typeof useMoveStopToFleet_Mutation>;
export type MoveStopToFleet_MutationMutationResult = Apollo.MutationResult<Types.MoveStopToFleet_Mutation>;
export type MoveStopToFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveStopToFleet_Mutation, Types.MoveStopToFleet_MutationVariables>;
 const MoveStopToTour_MutationDocument = gql`
    mutation moveStopToTour_mutation($tourPlanId: String!, $stopId: String!, $tourId: String!, $index: Int) {
  moveStopToTour(
    tourPlanId: $tourPlanId
    stopId: $stopId
    tourId: $tourId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveStopToTour_MutationMutationFn = Apollo.MutationFunction<Types.MoveStopToTour_Mutation, Types.MoveStopToTour_MutationVariables>;

/**
 * __useMoveStopToTour_Mutation__
 *
 * To run a mutation, you first call `useMoveStopToTour_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStopToTour_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStopToTourMutation, { data, loading, error }] = useMoveStopToTour_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      stopId: // value for 'stopId'
 *      tourId: // value for 'tourId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useMoveStopToTour_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveStopToTour_Mutation, Types.MoveStopToTour_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveStopToTour_Mutation, Types.MoveStopToTour_MutationVariables>(MoveStopToTour_MutationDocument, options);
      }
export type MoveStopToTour_MutationHookResult = ReturnType<typeof useMoveStopToTour_Mutation>;
export type MoveStopToTour_MutationMutationResult = Apollo.MutationResult<Types.MoveStopToTour_Mutation>;
export type MoveStopToTour_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveStopToTour_Mutation, Types.MoveStopToTour_MutationVariables>;
 const MoveTourToFleet_MutationDocument = gql`
    mutation moveTourToFleet_mutation($tourPlanId: String!, $tourId: String!, $fleetId: String!, $index: Int) {
  moveTourToFleet(
    tourPlanId: $tourPlanId
    tourId: $tourId
    fleetId: $fleetId
    index: $index
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type MoveTourToFleet_MutationMutationFn = Apollo.MutationFunction<Types.MoveTourToFleet_Mutation, Types.MoveTourToFleet_MutationVariables>;

/**
 * __useMoveTourToFleet_Mutation__
 *
 * To run a mutation, you first call `useMoveTourToFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTourToFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTourToFleetMutation, { data, loading, error }] = useMoveTourToFleet_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *      fleetId: // value for 'fleetId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useMoveTourToFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveTourToFleet_Mutation, Types.MoveTourToFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveTourToFleet_Mutation, Types.MoveTourToFleet_MutationVariables>(MoveTourToFleet_MutationDocument, options);
      }
export type MoveTourToFleet_MutationHookResult = ReturnType<typeof useMoveTourToFleet_Mutation>;
export type MoveTourToFleet_MutationMutationResult = Apollo.MutationResult<Types.MoveTourToFleet_Mutation>;
export type MoveTourToFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.MoveTourToFleet_Mutation, Types.MoveTourToFleet_MutationVariables>;
 const OptimizeFleet_MutationDocument = gql`
    mutation optimizeFleet_mutation($tourPlanId: String!, $fleetId: String!, $tourId: String!) {
  optimizeFleet(tourPlanId: $tourPlanId, fleetId: $fleetId, tourId: $tourId) {
    tourPlan {
      id
      name
      tenantId
      planningDate
      vehicles {
        id
        name
        vehicleType
        maxLoadingWeight
        ldmm
        pallets
        vehicleCapabilities
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      fleets {
        id
        name
        fleetTemplateId
        bodyType
        fleetDimensions {
          totalLoadingWeight
          totalLoadingHeight
          totalLoadingWidth
          totalLoadingLength
          fleetCapabilities
        }
        carriers {
          id
          name
        }
        possibleLocationIds
        possibleCountries
        tours {
          id
          stops {
            id
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            reference
            earliestPlannedArrivalTime
            latestPlannedArrivalTime
            serviceTime
            loads {
              id
              pickUp {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              dropOff {
                id
                location {
                  id
                  externalReference
                  company
                  contact {
                    firstName
                    lastName
                    phone
                    email
                    role
                  }
                  owned
                  address {
                    street
                    zipCode
                    city
                    country
                    coordinates {
                      latitude
                      longitude
                    }
                    comments
                    region
                  }
                  serviceTime
                  timeWindows {
                    weekday
                    from
                    to
                  }
                  timezone
                  loadingRequirements
                  timeWindowType
                }
                timeWindow {
                  id
                  start
                  end
                }
              }
              loadingMillimeter
              article {
                id
                packagingOptions {
                  packaging {
                    packagingCode
                    packagingDescription
                    articlesPerPackage
                    maxStackSize
                    dimensions {
                      weight
                      height
                      width
                      length
                    }
                    parent {
                      packaging {
                        packagingCode
                        packagingDescription
                        articlesPerPackage
                        maxStackSize
                        dimensions {
                          weight
                          height
                          width
                          length
                        }
                        liftingSide
                      }
                      quantityChildrenPerParent
                    }
                    liftingSide
                  }
                  maxStackSize
                  articlesPerPackage
                }
                externalReference
                name
                weightInKgPerUnit
              }
              pallets
              weight
              customerReference
              content
              transportRequirements
              stackable
              articleNumber
              articleName
              articleQuantity
              orderReference
              additionalInfo
            }
            distance
          }
          distance
          route {
            sections {
              polyline
              summary {
                duration
                length
                consumption
                co2Emission
              }
              aggregateTolls {
                countryCode
                tollSystem
                currency
                value
              }
            }
          }
          shipment {
            id
            createdAt
          }
          lock {
            createdAt
            lockReason
          }
        }
      }
      configuration {
        maxDrivingHours
        maxWorkingHours
        cutOffTimeHours
        warningTimeHours
        toursAlwaysStartAtDepot
        toursAlwaysEndAtDepot
      }
      lastPlannedTourExecutionTime
      lockedAtTime
      lockedTimeout
      lock {
        createdAt
        timeout
        reason
      }
      unplannedLoads {
        id
        pickUp {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        dropOff {
          id
          location {
            id
            externalReference
            company
            contact {
              firstName
              lastName
              phone
              email
              role
            }
            owned
            address {
              street
              zipCode
              city
              country
              coordinates {
                latitude
                longitude
              }
              comments
              region
            }
            serviceTime
            timeWindows {
              weekday
              from
              to
            }
            timezone
            loadingRequirements
            timeWindowType
          }
          timeWindow {
            id
            start
            end
          }
        }
        loadingMillimeter
        article {
          id
          packagingOptions {
            packaging {
              packagingCode
              packagingDescription
              articlesPerPackage
              maxStackSize
              dimensions {
                weight
                height
                width
                length
              }
              parent {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  liftingSide
                }
                quantityChildrenPerParent
              }
              liftingSide
            }
            maxStackSize
            articlesPerPackage
          }
          externalReference
          name
          weightInKgPerUnit
        }
        pallets
        weight
        customerReference
        content
        transportRequirements
        stackable
        articleNumber
        articleName
        articleQuantity
        orderReference
        additionalInfo
      }
      startLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
      depotLocation {
        id
        externalReference
        company
        contact {
          firstName
          lastName
          phone
          email
          role
        }
        owned
        address {
          street
          zipCode
          city
          country
          coordinates {
            latitude
            longitude
          }
          comments
          region
        }
        serviceTime
        timeWindows {
          weekday
          from
          to
        }
        timezone
        loadingRequirements
        timeWindowType
      }
    }
    messages {
      key
      type
      data
    }
  }
}
    `;
export type OptimizeFleet_MutationMutationFn = Apollo.MutationFunction<Types.OptimizeFleet_Mutation, Types.OptimizeFleet_MutationVariables>;

/**
 * __useOptimizeFleet_Mutation__
 *
 * To run a mutation, you first call `useOptimizeFleet_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeFleet_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeFleetMutation, { data, loading, error }] = useOptimizeFleet_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      fleetId: // value for 'fleetId'
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useOptimizeFleet_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.OptimizeFleet_Mutation, Types.OptimizeFleet_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.OptimizeFleet_Mutation, Types.OptimizeFleet_MutationVariables>(OptimizeFleet_MutationDocument, options);
      }
export type OptimizeFleet_MutationHookResult = ReturnType<typeof useOptimizeFleet_Mutation>;
export type OptimizeFleet_MutationMutationResult = Apollo.MutationResult<Types.OptimizeFleet_Mutation>;
export type OptimizeFleet_MutationMutationOptions = Apollo.BaseMutationOptions<Types.OptimizeFleet_Mutation, Types.OptimizeFleet_MutationVariables>;
 const RemoveFleetsFromTourPlan_MutationDocument = gql`
    mutation removeFleetsFromTourPlan_mutation($tourPlanId: String!, $fleetIds: [String!]!) {
  removeFleetsFromTourPlan(tourPlanId: $tourPlanId, fleetIds: $fleetIds) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type RemoveFleetsFromTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.RemoveFleetsFromTourPlan_Mutation, Types.RemoveFleetsFromTourPlan_MutationVariables>;

/**
 * __useRemoveFleetsFromTourPlan_Mutation__
 *
 * To run a mutation, you first call `useRemoveFleetsFromTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFleetsFromTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFleetsFromTourPlanMutation, { data, loading, error }] = useRemoveFleetsFromTourPlan_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      fleetIds: // value for 'fleetIds'
 *   },
 * });
 */
export function useRemoveFleetsFromTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveFleetsFromTourPlan_Mutation, Types.RemoveFleetsFromTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveFleetsFromTourPlan_Mutation, Types.RemoveFleetsFromTourPlan_MutationVariables>(RemoveFleetsFromTourPlan_MutationDocument, options);
      }
export type RemoveFleetsFromTourPlan_MutationHookResult = ReturnType<typeof useRemoveFleetsFromTourPlan_Mutation>;
export type RemoveFleetsFromTourPlan_MutationMutationResult = Apollo.MutationResult<Types.RemoveFleetsFromTourPlan_Mutation>;
export type RemoveFleetsFromTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveFleetsFromTourPlan_Mutation, Types.RemoveFleetsFromTourPlan_MutationVariables>;
 const RemoveLoadFromTourPlan_MutationDocument = gql`
    mutation removeLoadFromTourPlan_mutation($tourPlanId: String!, $loadId: String!) {
  removeLoadFromTourPlan(tourPlanId: $tourPlanId, loadId: $loadId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type RemoveLoadFromTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.RemoveLoadFromTourPlan_Mutation, Types.RemoveLoadFromTourPlan_MutationVariables>;

/**
 * __useRemoveLoadFromTourPlan_Mutation__
 *
 * To run a mutation, you first call `useRemoveLoadFromTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLoadFromTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLoadFromTourPlanMutation, { data, loading, error }] = useRemoveLoadFromTourPlan_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      loadId: // value for 'loadId'
 *   },
 * });
 */
export function useRemoveLoadFromTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveLoadFromTourPlan_Mutation, Types.RemoveLoadFromTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveLoadFromTourPlan_Mutation, Types.RemoveLoadFromTourPlan_MutationVariables>(RemoveLoadFromTourPlan_MutationDocument, options);
      }
export type RemoveLoadFromTourPlan_MutationHookResult = ReturnType<typeof useRemoveLoadFromTourPlan_Mutation>;
export type RemoveLoadFromTourPlan_MutationMutationResult = Apollo.MutationResult<Types.RemoveLoadFromTourPlan_Mutation>;
export type RemoveLoadFromTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveLoadFromTourPlan_Mutation, Types.RemoveLoadFromTourPlan_MutationVariables>;
 const RemoveStopFromTourPlan_MutationDocument = gql`
    mutation removeStopFromTourPlan_mutation($tourPlanId: String!, $stopId: String!) {
  removeStopFromTourPlan(tourPlanId: $tourPlanId, stopId: $stopId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type RemoveStopFromTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.RemoveStopFromTourPlan_Mutation, Types.RemoveStopFromTourPlan_MutationVariables>;

/**
 * __useRemoveStopFromTourPlan_Mutation__
 *
 * To run a mutation, you first call `useRemoveStopFromTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStopFromTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStopFromTourPlanMutation, { data, loading, error }] = useRemoveStopFromTourPlan_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      stopId: // value for 'stopId'
 *   },
 * });
 */
export function useRemoveStopFromTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveStopFromTourPlan_Mutation, Types.RemoveStopFromTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveStopFromTourPlan_Mutation, Types.RemoveStopFromTourPlan_MutationVariables>(RemoveStopFromTourPlan_MutationDocument, options);
      }
export type RemoveStopFromTourPlan_MutationHookResult = ReturnType<typeof useRemoveStopFromTourPlan_Mutation>;
export type RemoveStopFromTourPlan_MutationMutationResult = Apollo.MutationResult<Types.RemoveStopFromTourPlan_Mutation>;
export type RemoveStopFromTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveStopFromTourPlan_Mutation, Types.RemoveStopFromTourPlan_MutationVariables>;
 const RemoveTourFromTourPlan_MutationDocument = gql`
    mutation removeTourFromTourPlan_mutation($tourPlanId: String!, $tourId: String!) {
  removeTourFromTourPlan(tourPlanId: $tourPlanId, tourId: $tourId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type RemoveTourFromTourPlan_MutationMutationFn = Apollo.MutationFunction<Types.RemoveTourFromTourPlan_Mutation, Types.RemoveTourFromTourPlan_MutationVariables>;

/**
 * __useRemoveTourFromTourPlan_Mutation__
 *
 * To run a mutation, you first call `useRemoveTourFromTourPlan_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTourFromTourPlan_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTourFromTourPlanMutation, { data, loading, error }] = useRemoveTourFromTourPlan_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useRemoveTourFromTourPlan_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveTourFromTourPlan_Mutation, Types.RemoveTourFromTourPlan_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveTourFromTourPlan_Mutation, Types.RemoveTourFromTourPlan_MutationVariables>(RemoveTourFromTourPlan_MutationDocument, options);
      }
export type RemoveTourFromTourPlan_MutationHookResult = ReturnType<typeof useRemoveTourFromTourPlan_Mutation>;
export type RemoveTourFromTourPlan_MutationMutationResult = Apollo.MutationResult<Types.RemoveTourFromTourPlan_Mutation>;
export type RemoveTourFromTourPlan_MutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveTourFromTourPlan_Mutation, Types.RemoveTourFromTourPlan_MutationVariables>;
 const ReverseTour_MutationDocument = gql`
    mutation reverseTour_mutation($tourPlanId: String!, $tourId: String!) {
  reverseTour(tourPlanId: $tourPlanId, tourId: $tourId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type ReverseTour_MutationMutationFn = Apollo.MutationFunction<Types.ReverseTour_Mutation, Types.ReverseTour_MutationVariables>;

/**
 * __useReverseTour_Mutation__
 *
 * To run a mutation, you first call `useReverseTour_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseTour_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseTourMutation, { data, loading, error }] = useReverseTour_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useReverseTour_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.ReverseTour_Mutation, Types.ReverseTour_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReverseTour_Mutation, Types.ReverseTour_MutationVariables>(ReverseTour_MutationDocument, options);
      }
export type ReverseTour_MutationHookResult = ReturnType<typeof useReverseTour_Mutation>;
export type ReverseTour_MutationMutationResult = Apollo.MutationResult<Types.ReverseTour_Mutation>;
export type ReverseTour_MutationMutationOptions = Apollo.BaseMutationOptions<Types.ReverseTour_Mutation, Types.ReverseTour_MutationVariables>;
 const SendTourToShipmentExecution_MutationDocument = gql`
    mutation sendTourToShipmentExecution_mutation($tourPlanId: String!, $tourId: String!, $lockReason: TourLockReasonEnum!) {
  sendTourToShipmentExecution(
    tourPlanId: $tourPlanId
    tourId: $tourId
    lockReason: $lockReason
  ) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type SendTourToShipmentExecution_MutationMutationFn = Apollo.MutationFunction<Types.SendTourToShipmentExecution_Mutation, Types.SendTourToShipmentExecution_MutationVariables>;

/**
 * __useSendTourToShipmentExecution_Mutation__
 *
 * To run a mutation, you first call `useSendTourToShipmentExecution_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTourToShipmentExecution_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTourToShipmentExecutionMutation, { data, loading, error }] = useSendTourToShipmentExecution_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *      lockReason: // value for 'lockReason'
 *   },
 * });
 */
export function useSendTourToShipmentExecution_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SendTourToShipmentExecution_Mutation, Types.SendTourToShipmentExecution_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendTourToShipmentExecution_Mutation, Types.SendTourToShipmentExecution_MutationVariables>(SendTourToShipmentExecution_MutationDocument, options);
      }
export type SendTourToShipmentExecution_MutationHookResult = ReturnType<typeof useSendTourToShipmentExecution_Mutation>;
export type SendTourToShipmentExecution_MutationMutationResult = Apollo.MutationResult<Types.SendTourToShipmentExecution_Mutation>;
export type SendTourToShipmentExecution_MutationMutationOptions = Apollo.BaseMutationOptions<Types.SendTourToShipmentExecution_Mutation, Types.SendTourToShipmentExecution_MutationVariables>;
 const TourPlanById_QueryDocument = gql`
    query tourPlanById_query($id: String!) {
  tourPlanById(id: $id) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;

/**
 * __useTourPlanById_Query__
 *
 * To run a query within a React component, call `useTourPlanById_Query` and pass it any options that fit your needs.
 * When your component renders, `useTourPlanById_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPlanById_Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourPlanById_Query(baseOptions: Apollo.QueryHookOptions<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables> & ({ variables: Types.TourPlanById_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables>(TourPlanById_QueryDocument, options);
      }
export function useTourPlanById_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables>(TourPlanById_QueryDocument, options);
        }
export function useTourPlanById_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables>(TourPlanById_QueryDocument, options);
        }
export type TourPlanById_QueryHookResult = ReturnType<typeof useTourPlanById_Query>;
export type TourPlanById_QueryLazyQueryHookResult = ReturnType<typeof useTourPlanById_QueryLazyQuery>;
export type TourPlanById_QuerySuspenseQueryHookResult = ReturnType<typeof useTourPlanById_QuerySuspenseQuery>;
export type TourPlanById_QueryQueryResult = Apollo.QueryResult<Types.TourPlanById_Query, Types.TourPlanById_QueryVariables>;
 const TourPlanByName_QueryDocument = gql`
    query tourPlanByName_query($name: String!) {
  tourPlanByName(name: $name) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;

/**
 * __useTourPlanByName_Query__
 *
 * To run a query within a React component, call `useTourPlanByName_Query` and pass it any options that fit your needs.
 * When your component renders, `useTourPlanByName_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPlanByName_Query({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTourPlanByName_Query(baseOptions: Apollo.QueryHookOptions<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables> & ({ variables: Types.TourPlanByName_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables>(TourPlanByName_QueryDocument, options);
      }
export function useTourPlanByName_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables>(TourPlanByName_QueryDocument, options);
        }
export function useTourPlanByName_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables>(TourPlanByName_QueryDocument, options);
        }
export type TourPlanByName_QueryHookResult = ReturnType<typeof useTourPlanByName_Query>;
export type TourPlanByName_QueryLazyQueryHookResult = ReturnType<typeof useTourPlanByName_QueryLazyQuery>;
export type TourPlanByName_QuerySuspenseQueryHookResult = ReturnType<typeof useTourPlanByName_QuerySuspenseQuery>;
export type TourPlanByName_QueryQueryResult = Apollo.QueryResult<Types.TourPlanByName_Query, Types.TourPlanByName_QueryVariables>;
 const TourPlanScore_QueryDocument = gql`
    query tourPlanScore_query($tourPlan: TourPlannerTourPlanInput!, $depotLocationId: String!) {
  tourPlanScore(tourPlan: $tourPlan, depotLocationId: $depotLocationId)
}
    `;

/**
 * __useTourPlanScore_Query__
 *
 * To run a query within a React component, call `useTourPlanScore_Query` and pass it any options that fit your needs.
 * When your component renders, `useTourPlanScore_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPlanScore_Query({
 *   variables: {
 *      tourPlan: // value for 'tourPlan'
 *      depotLocationId: // value for 'depotLocationId'
 *   },
 * });
 */
export function useTourPlanScore_Query(baseOptions: Apollo.QueryHookOptions<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables> & ({ variables: Types.TourPlanScore_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables>(TourPlanScore_QueryDocument, options);
      }
export function useTourPlanScore_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables>(TourPlanScore_QueryDocument, options);
        }
export function useTourPlanScore_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables>(TourPlanScore_QueryDocument, options);
        }
export type TourPlanScore_QueryHookResult = ReturnType<typeof useTourPlanScore_Query>;
export type TourPlanScore_QueryLazyQueryHookResult = ReturnType<typeof useTourPlanScore_QueryLazyQuery>;
export type TourPlanScore_QuerySuspenseQueryHookResult = ReturnType<typeof useTourPlanScore_QuerySuspenseQuery>;
export type TourPlanScore_QueryQueryResult = Apollo.QueryResult<Types.TourPlanScore_Query, Types.TourPlanScore_QueryVariables>;
 const TourPlansByDate_QueryDocument = gql`
    query tourPlansByDate_query($date: DateTime!) {
  tourPlansByDate(date: $date) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;

/**
 * __useTourPlansByDate_Query__
 *
 * To run a query within a React component, call `useTourPlansByDate_Query` and pass it any options that fit your needs.
 * When your component renders, `useTourPlansByDate_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPlansByDate_Query({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTourPlansByDate_Query(baseOptions: Apollo.QueryHookOptions<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables> & ({ variables: Types.TourPlansByDate_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables>(TourPlansByDate_QueryDocument, options);
      }
export function useTourPlansByDate_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables>(TourPlansByDate_QueryDocument, options);
        }
export function useTourPlansByDate_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables>(TourPlansByDate_QueryDocument, options);
        }
export type TourPlansByDate_QueryHookResult = ReturnType<typeof useTourPlansByDate_Query>;
export type TourPlansByDate_QueryLazyQueryHookResult = ReturnType<typeof useTourPlansByDate_QueryLazyQuery>;
export type TourPlansByDate_QuerySuspenseQueryHookResult = ReturnType<typeof useTourPlansByDate_QuerySuspenseQuery>;
export type TourPlansByDate_QueryQueryResult = Apollo.QueryResult<Types.TourPlansByDate_Query, Types.TourPlansByDate_QueryVariables>;
 const TourPlansByDateAggregated_QueryDocument = gql`
    query tourPlansByDateAggregated_query($fromDate: DateTime!, $toDate: DateTime) {
  tourPlansByDateAggregated(fromDate: $fromDate, toDate: $toDate) {
    id
    date
    locations {
      id
      locationId
      finalizedLoads
      plannedLoads
      finalizedTours
      plannedTours
    }
  }
}
    `;

/**
 * __useTourPlansByDateAggregated_Query__
 *
 * To run a query within a React component, call `useTourPlansByDateAggregated_Query` and pass it any options that fit your needs.
 * When your component renders, `useTourPlansByDateAggregated_Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPlansByDateAggregated_Query({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useTourPlansByDateAggregated_Query(baseOptions: Apollo.QueryHookOptions<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables> & ({ variables: Types.TourPlansByDateAggregated_QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables>(TourPlansByDateAggregated_QueryDocument, options);
      }
export function useTourPlansByDateAggregated_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables>(TourPlansByDateAggregated_QueryDocument, options);
        }
export function useTourPlansByDateAggregated_QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables>(TourPlansByDateAggregated_QueryDocument, options);
        }
export type TourPlansByDateAggregated_QueryHookResult = ReturnType<typeof useTourPlansByDateAggregated_Query>;
export type TourPlansByDateAggregated_QueryLazyQueryHookResult = ReturnType<typeof useTourPlansByDateAggregated_QueryLazyQuery>;
export type TourPlansByDateAggregated_QuerySuspenseQueryHookResult = ReturnType<typeof useTourPlansByDateAggregated_QuerySuspenseQuery>;
export type TourPlansByDateAggregated_QueryQueryResult = Apollo.QueryResult<Types.TourPlansByDateAggregated_Query, Types.TourPlansByDateAggregated_QueryVariables>;
 const UnlockTour_MutationDocument = gql`
    mutation unlockTour_mutation($tourPlanId: String!, $tourId: String!) {
  unlockTour(tourPlanId: $tourPlanId, tourId: $tourId) {
    id
    name
    tenantId
    planningDate
    vehicles {
      id
      name
      vehicleType
      maxLoadingWeight
      ldmm
      pallets
      vehicleCapabilities
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    fleets {
      id
      name
      fleetTemplateId
      bodyType
      fleetDimensions {
        totalLoadingWeight
        totalLoadingHeight
        totalLoadingWidth
        totalLoadingLength
        fleetCapabilities
      }
      carriers {
        id
        name
      }
      possibleLocationIds
      possibleCountries
      tours {
        id
        stops {
          id
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          reference
          earliestPlannedArrivalTime
          latestPlannedArrivalTime
          serviceTime
          loads {
            id
            pickUp {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            dropOff {
              id
              location {
                id
                externalReference
                company
                contact {
                  firstName
                  lastName
                  phone
                  email
                  role
                }
                owned
                address {
                  street
                  zipCode
                  city
                  country
                  coordinates {
                    latitude
                    longitude
                  }
                  comments
                  region
                }
                serviceTime
                timeWindows {
                  weekday
                  from
                  to
                }
                timezone
                loadingRequirements
                timeWindowType
              }
              timeWindow {
                id
                start
                end
              }
            }
            loadingMillimeter
            article {
              id
              packagingOptions {
                packaging {
                  packagingCode
                  packagingDescription
                  articlesPerPackage
                  maxStackSize
                  dimensions {
                    weight
                    height
                    width
                    length
                  }
                  parent {
                    packaging {
                      packagingCode
                      packagingDescription
                      articlesPerPackage
                      maxStackSize
                      dimensions {
                        weight
                        height
                        width
                        length
                      }
                      liftingSide
                    }
                    quantityChildrenPerParent
                  }
                  liftingSide
                }
                maxStackSize
                articlesPerPackage
              }
              externalReference
              name
              weightInKgPerUnit
            }
            pallets
            weight
            customerReference
            content
            transportRequirements
            stackable
            articleNumber
            articleName
            articleQuantity
            orderReference
            additionalInfo
          }
          distance
        }
        distance
        route {
          sections {
            polyline
            summary {
              duration
              length
              consumption
              co2Emission
            }
            aggregateTolls {
              countryCode
              tollSystem
              currency
              value
            }
          }
        }
        shipment {
          id
          createdAt
        }
        lock {
          createdAt
          lockReason
        }
      }
    }
    configuration {
      maxDrivingHours
      maxWorkingHours
      cutOffTimeHours
      warningTimeHours
      toursAlwaysStartAtDepot
      toursAlwaysEndAtDepot
    }
    lastPlannedTourExecutionTime
    lockedAtTime
    lockedTimeout
    lock {
      createdAt
      timeout
      reason
    }
    unplannedLoads {
      id
      pickUp {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      dropOff {
        id
        location {
          id
          externalReference
          company
          contact {
            firstName
            lastName
            phone
            email
            role
          }
          owned
          address {
            street
            zipCode
            city
            country
            coordinates {
              latitude
              longitude
            }
            comments
            region
          }
          serviceTime
          timeWindows {
            weekday
            from
            to
          }
          timezone
          loadingRequirements
          timeWindowType
        }
        timeWindow {
          id
          start
          end
        }
      }
      loadingMillimeter
      article {
        id
        packagingOptions {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            parent {
              packaging {
                packagingCode
                packagingDescription
                articlesPerPackage
                maxStackSize
                dimensions {
                  weight
                  height
                  width
                  length
                }
                liftingSide
              }
              quantityChildrenPerParent
            }
            liftingSide
          }
          maxStackSize
          articlesPerPackage
        }
        externalReference
        name
        weightInKgPerUnit
      }
      pallets
      weight
      customerReference
      content
      transportRequirements
      stackable
      articleNumber
      articleName
      articleQuantity
      orderReference
      additionalInfo
    }
    startLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
    depotLocation {
      id
      externalReference
      company
      contact {
        firstName
        lastName
        phone
        email
        role
      }
      owned
      address {
        street
        zipCode
        city
        country
        coordinates {
          latitude
          longitude
        }
        comments
        region
      }
      serviceTime
      timeWindows {
        weekday
        from
        to
      }
      timezone
      loadingRequirements
      timeWindowType
    }
  }
}
    `;
export type UnlockTour_MutationMutationFn = Apollo.MutationFunction<Types.UnlockTour_Mutation, Types.UnlockTour_MutationVariables>;

/**
 * __useUnlockTour_Mutation__
 *
 * To run a mutation, you first call `useUnlockTour_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockTour_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockTourMutation, { data, loading, error }] = useUnlockTour_Mutation({
 *   variables: {
 *      tourPlanId: // value for 'tourPlanId'
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useUnlockTour_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UnlockTour_Mutation, Types.UnlockTour_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnlockTour_Mutation, Types.UnlockTour_MutationVariables>(UnlockTour_MutationDocument, options);
      }
export type UnlockTour_MutationHookResult = ReturnType<typeof useUnlockTour_Mutation>;
export type UnlockTour_MutationMutationResult = Apollo.MutationResult<Types.UnlockTour_Mutation>;
export type UnlockTour_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UnlockTour_Mutation, Types.UnlockTour_MutationVariables>;
 const UpdateTourPlannerConfiguration_MutationDocument = gql`
    mutation updateTourPlannerConfiguration_mutation($configuration: TourPlannerConfigurationInput!) {
  updateTourPlannerConfiguration(configuration: $configuration) {
    maxDrivingHours
    maxWorkingHours
    cutOffTimeHours
    warningTimeHours
    toursAlwaysStartAtDepot
    toursAlwaysEndAtDepot
  }
}
    `;
export type UpdateTourPlannerConfiguration_MutationMutationFn = Apollo.MutationFunction<Types.UpdateTourPlannerConfiguration_Mutation, Types.UpdateTourPlannerConfiguration_MutationVariables>;

/**
 * __useUpdateTourPlannerConfiguration_Mutation__
 *
 * To run a mutation, you first call `useUpdateTourPlannerConfiguration_Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourPlannerConfiguration_Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourPlannerConfigurationMutation, { data, loading, error }] = useUpdateTourPlannerConfiguration_Mutation({
 *   variables: {
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useUpdateTourPlannerConfiguration_Mutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTourPlannerConfiguration_Mutation, Types.UpdateTourPlannerConfiguration_MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTourPlannerConfiguration_Mutation, Types.UpdateTourPlannerConfiguration_MutationVariables>(UpdateTourPlannerConfiguration_MutationDocument, options);
      }
export type UpdateTourPlannerConfiguration_MutationHookResult = ReturnType<typeof useUpdateTourPlannerConfiguration_Mutation>;
export type UpdateTourPlannerConfiguration_MutationMutationResult = Apollo.MutationResult<Types.UpdateTourPlannerConfiguration_Mutation>;
export type UpdateTourPlannerConfiguration_MutationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTourPlannerConfiguration_Mutation, Types.UpdateTourPlannerConfiguration_MutationVariables>;